/*! jQuery v3.3.1 | (c) JS Foundation and other contributors | jquery.org/license */
!function(e, t) {
    "use strict";
    "object" == typeof module && "object" == typeof module.exports ? module.exports = e.document ? t(e, !0) : function(e) {
        if (!e.document)
            throw new Error("jQuery requires a window with a document");
        return t(e)
    }
    : t(e)
}("undefined" != typeof window ? window : this, function(e, t) {
    "use strict";
    var n = []
      , r = e.document
      , i = Object.getPrototypeOf
      , o = n.slice
      , a = n.concat
      , s = n.push
      , u = n.indexOf
      , l = {}
      , c = l.toString
      , f = l.hasOwnProperty
      , p = f.toString
      , d = p.call(Object)
      , h = {}
      , g = function e(t) {
        return "function" == typeof t && "number" != typeof t.nodeType
    }
      , y = function e(t) {
        return null != t && t === t.window
    }
      , v = {
        type: !0,
        src: !0,
        noModule: !0
    };
    function m(e, t, n) {
        var i, o = (t = t || r).createElement("script");
        if (o.text = e,
        n)
            for (i in v)
                n[i] && (o[i] = n[i]);
        t.head.appendChild(o).parentNode.removeChild(o)
    }
    function x(e) {
        return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? l[c.call(e)] || "object" : typeof e
    }
    var b = "3.3.1"
      , w = function(e, t) {
        return new w.fn.init(e,t)
    }
      , T = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    w.fn = w.prototype = {
        jquery: "3.3.1",
        constructor: w,
        length: 0,
        toArray: function() {
            return o.call(this)
        },
        get: function(e) {
            return null == e ? o.call(this) : e < 0 ? this[e + this.length] : this[e]
        },
        pushStack: function(e) {
            var t = w.merge(this.constructor(), e);
            return t.prevObject = this,
            t
        },
        each: function(e) {
            return w.each(this, e)
        },
        map: function(e) {
            return this.pushStack(w.map(this, function(t, n) {
                return e.call(t, n, t)
            }))
        },
        slice: function() {
            return this.pushStack(o.apply(this, arguments))
        },
        first: function() {
            return this.eq(0)
        },
        last: function() {
            return this.eq(-1)
        },
        eq: function(e) {
            var t = this.length
              , n = +e + (e < 0 ? t : 0);
            return this.pushStack(n >= 0 && n < t ? [this[n]] : [])
        },
        end: function() {
            return this.prevObject || this.constructor()
        },
        push: s,
        sort: n.sort,
        splice: n.splice
    },
    w.extend = w.fn.extend = function() {
        var e, t, n, r, i, o, a = arguments[0] || {}, s = 1, u = arguments.length, l = !1;
        for ("boolean" == typeof a && (l = a,
        a = arguments[s] || {},
        s++),
        "object" == typeof a || g(a) || (a = {}),
        s === u && (a = this,
        s--); s < u; s++)
            if (null != (e = arguments[s]))
                for (t in e)
                    n = a[t],
                    a !== (r = e[t]) && (l && r && (w.isPlainObject(r) || (i = Array.isArray(r))) ? (i ? (i = !1,
                    o = n && Array.isArray(n) ? n : []) : o = n && w.isPlainObject(n) ? n : {},
                    a[t] = w.extend(l, o, r)) : void 0 !== r && (a[t] = r));
        return a
    }
    ,
    w.extend({
        expando: "jQuery" + ("3.3.1" + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function(e) {
            throw new Error(e)
        },
        noop: function() {},
        isPlainObject: function(e) {
            var t, n;
            return !(!e || "[object Object]" !== c.call(e)) && (!(t = i(e)) || "function" == typeof (n = f.call(t, "constructor") && t.constructor) && p.call(n) === d)
        },
        isEmptyObject: function(e) {
            var t;
            for (t in e)
                return !1;
            return !0
        },
        globalEval: function(e) {
            m(e)
        },
        each: function(e, t) {
            var n, r = 0;
            if (C(e)) {
                for (n = e.length; r < n; r++)
                    if (!1 === t.call(e[r], r, e[r]))
                        break
            } else
                for (r in e)
                    if (!1 === t.call(e[r], r, e[r]))
                        break;
            return e
        },
        trim: function(e) {
            return null == e ? "" : (e + "").replace(T, "")
        },
        makeArray: function(e, t) {
            var n = t || [];
            return null != e && (C(Object(e)) ? w.merge(n, "string" == typeof e ? [e] : e) : s.call(n, e)),
            n
        },
        inArray: function(e, t, n) {
            return null == t ? -1 : u.call(t, e, n)
        },
        merge: function(e, t) {
            for (var n = +t.length, r = 0, i = e.length; r < n; r++)
                e[i++] = t[r];
            return e.length = i,
            e
        },
        grep: function(e, t, n) {
            for (var r, i = [], o = 0, a = e.length, s = !n; o < a; o++)
                (r = !t(e[o], o)) !== s && i.push(e[o]);
            return i
        },
        map: function(e, t, n) {
            var r, i, o = 0, s = [];
            if (C(e))
                for (r = e.length; o < r; o++)
                    null != (i = t(e[o], o, n)) && s.push(i);
            else
                for (o in e)
                    null != (i = t(e[o], o, n)) && s.push(i);
            return a.apply([], s)
        },
        guid: 1,
        support: h
    }),
    "function" == typeof Symbol && (w.fn[Symbol.iterator] = n[Symbol.iterator]),
    w.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(e, t) {
        l["[object " + t + "]"] = t.toLowerCase()
    });
    function C(e) {
        var t = !!e && "length"in e && e.length
          , n = x(e);
        return !g(e) && !y(e) && ("array" === n || 0 === t || "number" == typeof t && t > 0 && t - 1 in e)
    }
    var E = function(e) {
        var t, n, r, i, o, a, s, u, l, c, f, p, d, h, g, y, v, m, x, b = "sizzle" + 1 * new Date, w = e.document, T = 0, C = 0, E = ae(), k = ae(), S = ae(), D = function(e, t) {
            return e === t && (f = !0),
            0
        }, N = {}.hasOwnProperty, A = [], j = A.pop, q = A.push, L = A.push, H = A.slice, O = function(e, t) {
            for (var n = 0, r = e.length; n < r; n++)
                if (e[n] === t)
                    return n;
            return -1
        }, P = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", M = "[\\x20\\t\\r\\n\\f]", R = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+", I = "\\[" + M + "*(" + R + ")(?:" + M + "*([*^$|!~]?=)" + M + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + R + "))|)" + M + "*\\]", W = ":(" + R + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + I + ")*)|.*)\\)|)", $ = new RegExp(M + "+","g"), B = new RegExp("^" + M + "+|((?:^|[^\\\\])(?:\\\\.)*)" + M + "+$","g"), F = new RegExp("^" + M + "*," + M + "*"), _ = new RegExp("^" + M + "*([>+~]|" + M + ")" + M + "*"), z = new RegExp("=" + M + "*([^\\]'\"]*?)" + M + "*\\]","g"), X = new RegExp(W), U = new RegExp("^" + R + "$"), V = {
            ID: new RegExp("^#(" + R + ")"),
            CLASS: new RegExp("^\\.(" + R + ")"),
            TAG: new RegExp("^(" + R + "|[*])"),
            ATTR: new RegExp("^" + I),
            PSEUDO: new RegExp("^" + W),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + M + "*(even|odd|(([+-]|)(\\d*)n|)" + M + "*(?:([+-]|)" + M + "*(\\d+)|))" + M + "*\\)|)","i"),
            bool: new RegExp("^(?:" + P + ")$","i"),
            needsContext: new RegExp("^" + M + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + M + "*((?:-\\d)?\\d*)" + M + "*\\)|)(?=[^-]|$)","i")
        }, G = /^(?:input|select|textarea|button)$/i, Y = /^h\d$/i, Q = /^[^{]+\{\s*\[native \w/, J = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, K = /[+~]/, Z = new RegExp("\\\\([\\da-f]{1,6}" + M + "?|(" + M + ")|.)","ig"), ee = function(e, t, n) {
            var r = "0x" + t - 65536;
            return r !== r || n ? t : r < 0 ? String.fromCharCode(r + 65536) : String.fromCharCode(r >> 10 | 55296, 1023 & r | 56320)
        }, te = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g, ne = function(e, t) {
            return t ? "\0" === e ? "\ufffd" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " " : "\\" + e
        }, re = function() {
            p()
        }, ie = me(function(e) {
            return !0 === e.disabled && ("form"in e || "label"in e)
        }, {
            dir: "parentNode",
            next: "legend"
        });
        try {
            L.apply(A = H.call(w.childNodes), w.childNodes),
            A[w.childNodes.length].nodeType
        } catch (e) {
            L = {
                apply: A.length ? function(e, t) {
                    q.apply(e, H.call(t))
                }
                : function(e, t) {
                    var n = e.length
                      , r = 0;
                    while (e[n++] = t[r++])
                        ;
                    e.length = n - 1
                }
            }
        }
        function oe(e, t, r, i) {
            var o, s, l, c, f, h, v, m = t && t.ownerDocument, T = t ? t.nodeType : 9;
            if (r = r || [],
            "string" != typeof e || !e || 1 !== T && 9 !== T && 11 !== T)
                return r;
            if (!i && ((t ? t.ownerDocument || t : w) !== d && p(t),
            t = t || d,
            g)) {
                if (11 !== T && (f = J.exec(e)))
                    if (o = f[1]) {
                        if (9 === T) {
                            if (!(l = t.getElementById(o)))
                                return r;
                            if (l.id === o)
                                return r.push(l),
                                r
                        } else if (m && (l = m.getElementById(o)) && x(t, l) && l.id === o)
                            return r.push(l),
                            r
                    } else {
                        if (f[2])
                            return L.apply(r, t.getElementsByTagName(e)),
                            r;
                        if ((o = f[3]) && n.getElementsByClassName && t.getElementsByClassName)
                            return L.apply(r, t.getElementsByClassName(o)),
                            r
                    }
                if (n.qsa && !S[e + " "] && (!y || !y.test(e))) {
                    if (1 !== T)
                        m = t,
                        v = e;
                    else if ("object" !== t.nodeName.toLowerCase()) {
                        (c = t.getAttribute("id")) ? c = c.replace(te, ne) : t.setAttribute("id", c = b),
                        s = (h = a(e)).length;
                        while (s--)
                            h[s] = "#" + c + " " + ve(h[s]);
                        v = h.join(","),
                        m = K.test(e) && ge(t.parentNode) || t
                    }
                    if (v)
                        try {
                            return L.apply(r, m.querySelectorAll(v)),
                            r
                        } catch (e) {} finally {
                            c === b && t.removeAttribute("id")
                        }
                }
            }
            return u(e.replace(B, "$1"), t, r, i)
        }
        function ae() {
            var e = [];
            function t(n, i) {
                return e.push(n + " ") > r.cacheLength && delete t[e.shift()],
                t[n + " "] = i
            }
            return t
        }
        function se(e) {
            return e[b] = !0,
            e
        }
        function ue(e) {
            var t = d.createElement("fieldset");
            try {
                return !!e(t)
            } catch (e) {
                return !1
            } finally {
                t.parentNode && t.parentNode.removeChild(t),
                t = null
            }
        }
        function le(e, t) {
            var n = e.split("|")
              , i = n.length;
            while (i--)
                r.attrHandle[n[i]] = t
        }
        function ce(e, t) {
            var n = t && e
              , r = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
            if (r)
                return r;
            if (n)
                while (n = n.nextSibling)
                    if (n === t)
                        return -1;
            return e ? 1 : -1
        }
        function fe(e) {
            return function(t) {
                return "input" === t.nodeName.toLowerCase() && t.type === e
            }
        }
        function pe(e) {
            return function(t) {
                var n = t.nodeName.toLowerCase();
                return ("input" === n || "button" === n) && t.type === e
            }
        }
        function de(e) {
            return function(t) {
                return "form"in t ? t.parentNode && !1 === t.disabled ? "label"in t ? "label"in t.parentNode ? t.parentNode.disabled === e : t.disabled === e : t.isDisabled === e || t.isDisabled !== !e && ie(t) === e : t.disabled === e : "label"in t && t.disabled === e
            }
        }
        function he(e) {
            return se(function(t) {
                return t = +t,
                se(function(n, r) {
                    var i, o = e([], n.length, t), a = o.length;
                    while (a--)
                        n[i = o[a]] && (n[i] = !(r[i] = n[i]))
                })
            })
        }
        function ge(e) {
            return e && "undefined" != typeof e.getElementsByTagName && e
        }
        n = oe.support = {},
        o = oe.isXML = function(e) {
            var t = e && (e.ownerDocument || e).documentElement;
            return !!t && "HTML" !== t.nodeName
        }
        ,
        p = oe.setDocument = function(e) {
            var t, i, a = e ? e.ownerDocument || e : w;
            return a !== d && 9 === a.nodeType && a.documentElement ? (d = a,
            h = d.documentElement,
            g = !o(d),
            w !== d && (i = d.defaultView) && i.top !== i && (i.addEventListener ? i.addEventListener("unload", re, !1) : i.attachEvent && i.attachEvent("onunload", re)),
            n.attributes = ue(function(e) {
                return e.className = "i",
                !e.getAttribute("className")
            }),
            n.getElementsByTagName = ue(function(e) {
                return e.appendChild(d.createComment("")),
                !e.getElementsByTagName("*").length
            }),
            n.getElementsByClassName = Q.test(d.getElementsByClassName),
            n.getById = ue(function(e) {
                return h.appendChild(e).id = b,
                !d.getElementsByName || !d.getElementsByName(b).length
            }),
            n.getById ? (r.filter.ID = function(e) {
                var t = e.replace(Z, ee);
                return function(e) {
                    return e.getAttribute("id") === t
                }
            }
            ,
            r.find.ID = function(e, t) {
                if ("undefined" != typeof t.getElementById && g) {
                    var n = t.getElementById(e);
                    return n ? [n] : []
                }
            }
            ) : (r.filter.ID = function(e) {
                var t = e.replace(Z, ee);
                return function(e) {
                    var n = "undefined" != typeof e.getAttributeNode && e.getAttributeNode("id");
                    return n && n.value === t
                }
            }
            ,
            r.find.ID = function(e, t) {
                if ("undefined" != typeof t.getElementById && g) {
                    var n, r, i, o = t.getElementById(e);
                    if (o) {
                        if ((n = o.getAttributeNode("id")) && n.value === e)
                            return [o];
                        i = t.getElementsByName(e),
                        r = 0;
                        while (o = i[r++])
                            if ((n = o.getAttributeNode("id")) && n.value === e)
                                return [o]
                    }
                    return []
                }
            }
            ),
            r.find.TAG = n.getElementsByTagName ? function(e, t) {
                return "undefined" != typeof t.getElementsByTagName ? t.getElementsByTagName(e) : n.qsa ? t.querySelectorAll(e) : void 0
            }
            : function(e, t) {
                var n, r = [], i = 0, o = t.getElementsByTagName(e);
                if ("*" === e) {
                    while (n = o[i++])
                        1 === n.nodeType && r.push(n);
                    return r
                }
                return o
            }
            ,
            r.find.CLASS = n.getElementsByClassName && function(e, t) {
                if ("undefined" != typeof t.getElementsByClassName && g)
                    return t.getElementsByClassName(e)
            }
            ,
            v = [],
            y = [],
            (n.qsa = Q.test(d.querySelectorAll)) && (ue(function(e) {
                h.appendChild(e).innerHTML = "<a id='" + b + "'></a><select id='" + b + "-\r\\' msallowcapture=''><option selected=''></option></select>",
                e.querySelectorAll("[msallowcapture^='']").length && y.push("[*^$]=" + M + "*(?:''|\"\")"),
                e.querySelectorAll("[selected]").length || y.push("\\[" + M + "*(?:value|" + P + ")"),
                e.querySelectorAll("[id~=" + b + "-]").length || y.push("~="),
                e.querySelectorAll(":checked").length || y.push(":checked"),
                e.querySelectorAll("a#" + b + "+*").length || y.push(".#.+[+~]")
            }),
            ue(function(e) {
                e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                var t = d.createElement("input");
                t.setAttribute("type", "hidden"),
                e.appendChild(t).setAttribute("name", "D"),
                e.querySelectorAll("[name=d]").length && y.push("name" + M + "*[*^$|!~]?="),
                2 !== e.querySelectorAll(":enabled").length && y.push(":enabled", ":disabled"),
                h.appendChild(e).disabled = !0,
                2 !== e.querySelectorAll(":disabled").length && y.push(":enabled", ":disabled"),
                e.querySelectorAll("*,:x"),
                y.push(",.*:")
            })),
            (n.matchesSelector = Q.test(m = h.matches || h.webkitMatchesSelector || h.mozMatchesSelector || h.oMatchesSelector || h.msMatchesSelector)) && ue(function(e) {
                n.disconnectedMatch = m.call(e, "*"),
                m.call(e, "[s!='']:x"),
                v.push("!=", W)
            }),
            y = y.length && new RegExp(y.join("|")),
            v = v.length && new RegExp(v.join("|")),
            t = Q.test(h.compareDocumentPosition),
            x = t || Q.test(h.contains) ? function(e, t) {
                var n = 9 === e.nodeType ? e.documentElement : e
                  , r = t && t.parentNode;
                return e === r || !(!r || 1 !== r.nodeType || !(n.contains ? n.contains(r) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(r)))
            }
            : function(e, t) {
                if (t)
                    while (t = t.parentNode)
                        if (t === e)
                            return !0;
                return !1
            }
            ,
            D = t ? function(e, t) {
                if (e === t)
                    return f = !0,
                    0;
                var r = !e.compareDocumentPosition - !t.compareDocumentPosition;
                return r || (1 & (r = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || !n.sortDetached && t.compareDocumentPosition(e) === r ? e === d || e.ownerDocument === w && x(w, e) ? -1 : t === d || t.ownerDocument === w && x(w, t) ? 1 : c ? O(c, e) - O(c, t) : 0 : 4 & r ? -1 : 1)
            }
            : function(e, t) {
                if (e === t)
                    return f = !0,
                    0;
                var n, r = 0, i = e.parentNode, o = t.parentNode, a = [e], s = [t];
                if (!i || !o)
                    return e === d ? -1 : t === d ? 1 : i ? -1 : o ? 1 : c ? O(c, e) - O(c, t) : 0;
                if (i === o)
                    return ce(e, t);
                n = e;
                while (n = n.parentNode)
                    a.unshift(n);
                n = t;
                while (n = n.parentNode)
                    s.unshift(n);
                while (a[r] === s[r])
                    r++;
                return r ? ce(a[r], s[r]) : a[r] === w ? -1 : s[r] === w ? 1 : 0
            }
            ,
            d) : d
        }
        ,
        oe.matches = function(e, t) {
            return oe(e, null, null, t)
        }
        ,
        oe.matchesSelector = function(e, t) {
            if ((e.ownerDocument || e) !== d && p(e),
            t = t.replace(z, "='$1']"),
            n.matchesSelector && g && !S[t + " "] && (!v || !v.test(t)) && (!y || !y.test(t)))
                try {
                    var r = m.call(e, t);
                    if (r || n.disconnectedMatch || e.document && 11 !== e.document.nodeType)
                        return r
                } catch (e) {}
            return oe(t, d, null, [e]).length > 0
        }
        ,
        oe.contains = function(e, t) {
            return (e.ownerDocument || e) !== d && p(e),
            x(e, t)
        }
        ,
        oe.attr = function(e, t) {
            (e.ownerDocument || e) !== d && p(e);
            var i = r.attrHandle[t.toLowerCase()]
              , o = i && N.call(r.attrHandle, t.toLowerCase()) ? i(e, t, !g) : void 0;
            return void 0 !== o ? o : n.attributes || !g ? e.getAttribute(t) : (o = e.getAttributeNode(t)) && o.specified ? o.value : null
        }
        ,
        oe.escape = function(e) {
            return (e + "").replace(te, ne)
        }
        ,
        oe.error = function(e) {
            throw new Error("Syntax error, unrecognized expression: " + e)
        }
        ,
        oe.uniqueSort = function(e) {
            var t, r = [], i = 0, o = 0;
            if (f = !n.detectDuplicates,
            c = !n.sortStable && e.slice(0),
            e.sort(D),
            f) {
                while (t = e[o++])
                    t === e[o] && (i = r.push(o));
                while (i--)
                    e.splice(r[i], 1)
            }
            return c = null,
            e
        }
        ,
        i = oe.getText = function(e) {
            var t, n = "", r = 0, o = e.nodeType;
            if (o) {
                if (1 === o || 9 === o || 11 === o) {
                    if ("string" == typeof e.textContent)
                        return e.textContent;
                    for (e = e.firstChild; e; e = e.nextSibling)
                        n += i(e)
                } else if (3 === o || 4 === o)
                    return e.nodeValue
            } else
                while (t = e[r++])
                    n += i(t);
            return n
        }
        ,
        (r = oe.selectors = {
            cacheLength: 50,
            createPseudo: se,
            match: V,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: !0
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: !0
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(e) {
                    return e[1] = e[1].replace(Z, ee),
                    e[3] = (e[3] || e[4] || e[5] || "").replace(Z, ee),
                    "~=" === e[2] && (e[3] = " " + e[3] + " "),
                    e.slice(0, 4)
                },
                CHILD: function(e) {
                    return e[1] = e[1].toLowerCase(),
                    "nth" === e[1].slice(0, 3) ? (e[3] || oe.error(e[0]),
                    e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])),
                    e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && oe.error(e[0]),
                    e
                },
                PSEUDO: function(e) {
                    var t, n = !e[6] && e[2];
                    return V.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : n && X.test(n) && (t = a(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t),
                    e[2] = n.slice(0, t)),
                    e.slice(0, 3))
                }
            },
            filter: {
                TAG: function(e) {
                    var t = e.replace(Z, ee).toLowerCase();
                    return "*" === e ? function() {
                        return !0
                    }
                    : function(e) {
                        return e.nodeName && e.nodeName.toLowerCase() === t
                    }
                },
                CLASS: function(e) {
                    var t = E[e + " "];
                    return t || (t = new RegExp("(^|" + M + ")" + e + "(" + M + "|$)")) && E(e, function(e) {
                        return t.test("string" == typeof e.className && e.className || "undefined" != typeof e.getAttribute && e.getAttribute("class") || "")
                    })
                },
                ATTR: function(e, t, n) {
                    return function(r) {
                        var i = oe.attr(r, e);
                        return null == i ? "!=" === t : !t || (i += "",
                        "=" === t ? i === n : "!=" === t ? i !== n : "^=" === t ? n && 0 === i.indexOf(n) : "*=" === t ? n && i.indexOf(n) > -1 : "$=" === t ? n && i.slice(-n.length) === n : "~=" === t ? (" " + i.replace($, " ") + " ").indexOf(n) > -1 : "|=" === t && (i === n || i.slice(0, n.length + 1) === n + "-"))
                    }
                },
                CHILD: function(e, t, n, r, i) {
                    var o = "nth" !== e.slice(0, 3)
                      , a = "last" !== e.slice(-4)
                      , s = "of-type" === t;
                    return 1 === r && 0 === i ? function(e) {
                        return !!e.parentNode
                    }
                    : function(t, n, u) {
                        var l, c, f, p, d, h, g = o !== a ? "nextSibling" : "previousSibling", y = t.parentNode, v = s && t.nodeName.toLowerCase(), m = !u && !s, x = !1;
                        if (y) {
                            if (o) {
                                while (g) {
                                    p = t;
                                    while (p = p[g])
                                        if (s ? p.nodeName.toLowerCase() === v : 1 === p.nodeType)
                                            return !1;
                                    h = g = "only" === e && !h && "nextSibling"
                                }
                                return !0
                            }
                            if (h = [a ? y.firstChild : y.lastChild],
                            a && m) {
                                x = (d = (l = (c = (f = (p = y)[b] || (p[b] = {}))[p.uniqueID] || (f[p.uniqueID] = {}))[e] || [])[0] === T && l[1]) && l[2],
                                p = d && y.childNodes[d];
                                while (p = ++d && p && p[g] || (x = d = 0) || h.pop())
                                    if (1 === p.nodeType && ++x && p === t) {
                                        c[e] = [T, d, x];
                                        break
                                    }
                            } else if (m && (x = d = (l = (c = (f = (p = t)[b] || (p[b] = {}))[p.uniqueID] || (f[p.uniqueID] = {}))[e] || [])[0] === T && l[1]),
                            !1 === x)
                                while (p = ++d && p && p[g] || (x = d = 0) || h.pop())
                                    if ((s ? p.nodeName.toLowerCase() === v : 1 === p.nodeType) && ++x && (m && ((c = (f = p[b] || (p[b] = {}))[p.uniqueID] || (f[p.uniqueID] = {}))[e] = [T, x]),
                                    p === t))
                                        break;
                            return (x -= i) === r || x % r == 0 && x / r >= 0
                        }
                    }
                },
                PSEUDO: function(e, t) {
                    var n, i = r.pseudos[e] || r.setFilters[e.toLowerCase()] || oe.error("unsupported pseudo: " + e);
                    return i[b] ? i(t) : i.length > 1 ? (n = [e, e, "", t],
                    r.setFilters.hasOwnProperty(e.toLowerCase()) ? se(function(e, n) {
                        var r, o = i(e, t), a = o.length;
                        while (a--)
                            e[r = O(e, o[a])] = !(n[r] = o[a])
                    }) : function(e) {
                        return i(e, 0, n)
                    }
                    ) : i
                }
            },
            pseudos: {
                not: se(function(e) {
                    var t = []
                      , n = []
                      , r = s(e.replace(B, "$1"));
                    return r[b] ? se(function(e, t, n, i) {
                        var o, a = r(e, null, i, []), s = e.length;
                        while (s--)
                            (o = a[s]) && (e[s] = !(t[s] = o))
                    }) : function(e, i, o) {
                        return t[0] = e,
                        r(t, null, o, n),
                        t[0] = null,
                        !n.pop()
                    }
                }),
                has: se(function(e) {
                    return function(t) {
                        return oe(e, t).length > 0
                    }
                }),
                contains: se(function(e) {
                    return e = e.replace(Z, ee),
                    function(t) {
                        return (t.textContent || t.innerText || i(t)).indexOf(e) > -1
                    }
                }),
                lang: se(function(e) {
                    return U.test(e || "") || oe.error("unsupported lang: " + e),
                    e = e.replace(Z, ee).toLowerCase(),
                    function(t) {
                        var n;
                        do {
                            if (n = g ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang"))
                                return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-")
                        } while ((t = t.parentNode) && 1 === t.nodeType);
                        return !1
                    }
                }),
                target: function(t) {
                    var n = e.location && e.location.hash;
                    return n && n.slice(1) === t.id
                },
                root: function(e) {
                    return e === h
                },
                focus: function(e) {
                    return e === d.activeElement && (!d.hasFocus || d.hasFocus()) && !!(e.type || e.href || ~e.tabIndex)
                },
                enabled: de(!1),
                disabled: de(!0),
                checked: function(e) {
                    var t = e.nodeName.toLowerCase();
                    return "input" === t && !!e.checked || "option" === t && !!e.selected
                },
                selected: function(e) {
                    return e.parentNode && e.parentNode.selectedIndex,
                    !0 === e.selected
                },
                empty: function(e) {
                    for (e = e.firstChild; e; e = e.nextSibling)
                        if (e.nodeType < 6)
                            return !1;
                    return !0
                },
                parent: function(e) {
                    return !r.pseudos.empty(e)
                },
                header: function(e) {
                    return Y.test(e.nodeName)
                },
                input: function(e) {
                    return G.test(e.nodeName)
                },
                button: function(e) {
                    var t = e.nodeName.toLowerCase();
                    return "input" === t && "button" === e.type || "button" === t
                },
                text: function(e) {
                    var t;
                    return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
                },
                first: he(function() {
                    return [0]
                }),
                last: he(function(e, t) {
                    return [t - 1]
                }),
                eq: he(function(e, t, n) {
                    return [n < 0 ? n + t : n]
                }),
                even: he(function(e, t) {
                    for (var n = 0; n < t; n += 2)
                        e.push(n);
                    return e
                }),
                odd: he(function(e, t) {
                    for (var n = 1; n < t; n += 2)
                        e.push(n);
                    return e
                }),
                lt: he(function(e, t, n) {
                    for (var r = n < 0 ? n + t : n; --r >= 0; )
                        e.push(r);
                    return e
                }),
                gt: he(function(e, t, n) {
                    for (var r = n < 0 ? n + t : n; ++r < t; )
                        e.push(r);
                    return e
                })
            }
        }).pseudos.nth = r.pseudos.eq;
        for (t in {
            radio: !0,
            checkbox: !0,
            file: !0,
            password: !0,
            image: !0
        })
            r.pseudos[t] = fe(t);
        for (t in {
            submit: !0,
            reset: !0
        })
            r.pseudos[t] = pe(t);
        function ye() {}
        ye.prototype = r.filters = r.pseudos,
        r.setFilters = new ye,
        a = oe.tokenize = function(e, t) {
            var n, i, o, a, s, u, l, c = k[e + " "];
            if (c)
                return t ? 0 : c.slice(0);
            s = e,
            u = [],
            l = r.preFilter;
            while (s) {
                n && !(i = F.exec(s)) || (i && (s = s.slice(i[0].length) || s),
                u.push(o = [])),
                n = !1,
                (i = _.exec(s)) && (n = i.shift(),
                o.push({
                    value: n,
                    type: i[0].replace(B, " ")
                }),
                s = s.slice(n.length));
                for (a in r.filter)
                    !(i = V[a].exec(s)) || l[a] && !(i = l[a](i)) || (n = i.shift(),
                    o.push({
                        value: n,
                        type: a,
                        matches: i
                    }),
                    s = s.slice(n.length));
                if (!n)
                    break
            }
            return t ? s.length : s ? oe.error(e) : k(e, u).slice(0)
        }
        ;
        function ve(e) {
            for (var t = 0, n = e.length, r = ""; t < n; t++)
                r += e[t].value;
            return r
        }
        function me(e, t, n) {
            var r = t.dir
              , i = t.next
              , o = i || r
              , a = n && "parentNode" === o
              , s = C++;
            return t.first ? function(t, n, i) {
                while (t = t[r])
                    if (1 === t.nodeType || a)
                        return e(t, n, i);
                return !1
            }
            : function(t, n, u) {
                var l, c, f, p = [T, s];
                if (u) {
                    while (t = t[r])
                        if ((1 === t.nodeType || a) && e(t, n, u))
                            return !0
                } else
                    while (t = t[r])
                        if (1 === t.nodeType || a)
                            if (f = t[b] || (t[b] = {}),
                            c = f[t.uniqueID] || (f[t.uniqueID] = {}),
                            i && i === t.nodeName.toLowerCase())
                                t = t[r] || t;
                            else {
                                if ((l = c[o]) && l[0] === T && l[1] === s)
                                    return p[2] = l[2];
                                if (c[o] = p,
                                p[2] = e(t, n, u))
                                    return !0
                            }
                return !1
            }
        }
        function xe(e) {
            return e.length > 1 ? function(t, n, r) {
                var i = e.length;
                while (i--)
                    if (!e[i](t, n, r))
                        return !1;
                return !0
            }
            : e[0]
        }
        function be(e, t, n) {
            for (var r = 0, i = t.length; r < i; r++)
                oe(e, t[r], n);
            return n
        }
        function we(e, t, n, r, i) {
            for (var o, a = [], s = 0, u = e.length, l = null != t; s < u; s++)
                (o = e[s]) && (n && !n(o, r, i) || (a.push(o),
                l && t.push(s)));
            return a
        }
        function Te(e, t, n, r, i, o) {
            return r && !r[b] && (r = Te(r)),
            i && !i[b] && (i = Te(i, o)),
            se(function(o, a, s, u) {
                var l, c, f, p = [], d = [], h = a.length, g = o || be(t || "*", s.nodeType ? [s] : s, []), y = !e || !o && t ? g : we(g, p, e, s, u), v = n ? i || (o ? e : h || r) ? [] : a : y;
                if (n && n(y, v, s, u),
                r) {
                    l = we(v, d),
                    r(l, [], s, u),
                    c = l.length;
                    while (c--)
                        (f = l[c]) && (v[d[c]] = !(y[d[c]] = f))
                }
                if (o) {
                    if (i || e) {
                        if (i) {
                            l = [],
                            c = v.length;
                            while (c--)
                                (f = v[c]) && l.push(y[c] = f);
                            i(null, v = [], l, u)
                        }
                        c = v.length;
                        while (c--)
                            (f = v[c]) && (l = i ? O(o, f) : p[c]) > -1 && (o[l] = !(a[l] = f))
                    }
                } else
                    v = we(v === a ? v.splice(h, v.length) : v),
                    i ? i(null, a, v, u) : L.apply(a, v)
            })
        }
        function Ce(e) {
            for (var t, n, i, o = e.length, a = r.relative[e[0].type], s = a || r.relative[" "], u = a ? 1 : 0, c = me(function(e) {
                return e === t
            }, s, !0), f = me(function(e) {
                return O(t, e) > -1
            }, s, !0), p = [function(e, n, r) {
                var i = !a && (r || n !== l) || ((t = n).nodeType ? c(e, n, r) : f(e, n, r));
                return t = null,
                i
            }
            ]; u < o; u++)
                if (n = r.relative[e[u].type])
                    p = [me(xe(p), n)];
                else {
                    if ((n = r.filter[e[u].type].apply(null, e[u].matches))[b]) {
                        for (i = ++u; i < o; i++)
                            if (r.relative[e[i].type])
                                break;
                        return Te(u > 1 && xe(p), u > 1 && ve(e.slice(0, u - 1).concat({
                            value: " " === e[u - 2].type ? "*" : ""
                        })).replace(B, "$1"), n, u < i && Ce(e.slice(u, i)), i < o && Ce(e = e.slice(i)), i < o && ve(e))
                    }
                    p.push(n)
                }
            return xe(p)
        }
        function Ee(e, t) {
            var n = t.length > 0
              , i = e.length > 0
              , o = function(o, a, s, u, c) {
                var f, h, y, v = 0, m = "0", x = o && [], b = [], w = l, C = o || i && r.find.TAG("*", c), E = T += null == w ? 1 : Math.random() || .1, k = C.length;
                for (c && (l = a === d || a || c); m !== k && null != (f = C[m]); m++) {
                    if (i && f) {
                        h = 0,
                        a || f.ownerDocument === d || (p(f),
                        s = !g);
                        while (y = e[h++])
                            if (y(f, a || d, s)) {
                                u.push(f);
                                break
                            }
                        c && (T = E)
                    }
                    n && ((f = !y && f) && v--,
                    o && x.push(f))
                }
                if (v += m,
                n && m !== v) {
                    h = 0;
                    while (y = t[h++])
                        y(x, b, a, s);
                    if (o) {
                        if (v > 0)
                            while (m--)
                                x[m] || b[m] || (b[m] = j.call(u));
                        b = we(b)
                    }
                    L.apply(u, b),
                    c && !o && b.length > 0 && v + t.length > 1 && oe.uniqueSort(u)
                }
                return c && (T = E,
                l = w),
                x
            };
            return n ? se(o) : o
        }
        return s = oe.compile = function(e, t) {
            var n, r = [], i = [], o = S[e + " "];
            if (!o) {
                t || (t = a(e)),
                n = t.length;
                while (n--)
                    (o = Ce(t[n]))[b] ? r.push(o) : i.push(o);
                (o = S(e, Ee(i, r))).selector = e
            }
            return o
        }
        ,
        u = oe.select = function(e, t, n, i) {
            var o, u, l, c, f, p = "function" == typeof e && e, d = !i && a(e = p.selector || e);
            if (n = n || [],
            1 === d.length) {
                if ((u = d[0] = d[0].slice(0)).length > 2 && "ID" === (l = u[0]).type && 9 === t.nodeType && g && r.relative[u[1].type]) {
                    if (!(t = (r.find.ID(l.matches[0].replace(Z, ee), t) || [])[0]))
                        return n;
                    p && (t = t.parentNode),
                    e = e.slice(u.shift().value.length)
                }
                o = V.needsContext.test(e) ? 0 : u.length;
                while (o--) {
                    if (l = u[o],
                    r.relative[c = l.type])
                        break;
                    if ((f = r.find[c]) && (i = f(l.matches[0].replace(Z, ee), K.test(u[0].type) && ge(t.parentNode) || t))) {
                        if (u.splice(o, 1),
                        !(e = i.length && ve(u)))
                            return L.apply(n, i),
                            n;
                        break
                    }
                }
            }
            return (p || s(e, d))(i, t, !g, n, !t || K.test(e) && ge(t.parentNode) || t),
            n
        }
        ,
        n.sortStable = b.split("").sort(D).join("") === b,
        n.detectDuplicates = !!f,
        p(),
        n.sortDetached = ue(function(e) {
            return 1 & e.compareDocumentPosition(d.createElement("fieldset"))
        }),
        ue(function(e) {
            return e.innerHTML = "<a href='#'></a>",
            "#" === e.firstChild.getAttribute("href")
        }) || le("type|href|height|width", function(e, t, n) {
            if (!n)
                return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2)
        }),
        n.attributes && ue(function(e) {
            return e.innerHTML = "<input/>",
            e.firstChild.setAttribute("value", ""),
            "" === e.firstChild.getAttribute("value")
        }) || le("value", function(e, t, n) {
            if (!n && "input" === e.nodeName.toLowerCase())
                return e.defaultValue
        }),
        ue(function(e) {
            return null == e.getAttribute("disabled")
        }) || le(P, function(e, t, n) {
            var r;
            if (!n)
                return !0 === e[t] ? t.toLowerCase() : (r = e.getAttributeNode(t)) && r.specified ? r.value : null
        }),
        oe
    }(e);
    w.find = E,
    w.expr = E.selectors,
    w.expr[":"] = w.expr.pseudos,
    w.uniqueSort = w.unique = E.uniqueSort,
    w.text = E.getText,
    w.isXMLDoc = E.isXML,
    w.contains = E.contains,
    w.escapeSelector = E.escape;
    var k = function(e, t, n) {
        var r = []
          , i = void 0 !== n;
        while ((e = e[t]) && 9 !== e.nodeType)
            if (1 === e.nodeType) {
                if (i && w(e).is(n))
                    break;
                r.push(e)
            }
        return r
    }
      , S = function(e, t) {
        for (var n = []; e; e = e.nextSibling)
            1 === e.nodeType && e !== t && n.push(e);
        return n
    }
      , D = w.expr.match.needsContext;
    function N(e, t) {
        return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase()
    }
    var A = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    function j(e, t, n) {
        return g(t) ? w.grep(e, function(e, r) {
            return !!t.call(e, r, e) !== n
        }) : t.nodeType ? w.grep(e, function(e) {
            return e === t !== n
        }) : "string" != typeof t ? w.grep(e, function(e) {
            return u.call(t, e) > -1 !== n
        }) : w.filter(t, e, n)
    }
    w.filter = function(e, t, n) {
        var r = t[0];
        return n && (e = ":not(" + e + ")"),
        1 === t.length && 1 === r.nodeType ? w.find.matchesSelector(r, e) ? [r] : [] : w.find.matches(e, w.grep(t, function(e) {
            return 1 === e.nodeType
        }))
    }
    ,
    w.fn.extend({
        find: function(e) {
            var t, n, r = this.length, i = this;
            if ("string" != typeof e)
                return this.pushStack(w(e).filter(function() {
                    for (t = 0; t < r; t++)
                        if (w.contains(i[t], this))
                            return !0
                }));
            for (n = this.pushStack([]),
            t = 0; t < r; t++)
                w.find(e, i[t], n);
            return r > 1 ? w.uniqueSort(n) : n
        },
        filter: function(e) {
            return this.pushStack(j(this, e || [], !1))
        },
        not: function(e) {
            return this.pushStack(j(this, e || [], !0))
        },
        is: function(e) {
            return !!j(this, "string" == typeof e && D.test(e) ? w(e) : e || [], !1).length
        }
    });
    var q, L = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
    (w.fn.init = function(e, t, n) {
        var i, o;
        if (!e)
            return this;
        if (n = n || q,
        "string" == typeof e) {
            if (!(i = "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [null, e, null] : L.exec(e)) || !i[1] && t)
                return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
            if (i[1]) {
                if (t = t instanceof w ? t[0] : t,
                w.merge(this, w.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : r, !0)),
                A.test(i[1]) && w.isPlainObject(t))
                    for (i in t)
                        g(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
                return this
            }
            return (o = r.getElementById(i[2])) && (this[0] = o,
            this.length = 1),
            this
        }
        return e.nodeType ? (this[0] = e,
        this.length = 1,
        this) : g(e) ? void 0 !== n.ready ? n.ready(e) : e(w) : w.makeArray(e, this)
    }
    ).prototype = w.fn,
    q = w(r);
    var H = /^(?:parents|prev(?:Until|All))/
      , O = {
        children: !0,
        contents: !0,
        next: !0,
        prev: !0
    };
    w.fn.extend({
        has: function(e) {
            var t = w(e, this)
              , n = t.length;
            return this.filter(function() {
                for (var e = 0; e < n; e++)
                    if (w.contains(this, t[e]))
                        return !0
            })
        },
        closest: function(e, t) {
            var n, r = 0, i = this.length, o = [], a = "string" != typeof e && w(e);
            if (!D.test(e))
                for (; r < i; r++)
                    for (n = this[r]; n && n !== t; n = n.parentNode)
                        if (n.nodeType < 11 && (a ? a.index(n) > -1 : 1 === n.nodeType && w.find.matchesSelector(n, e))) {
                            o.push(n);
                            break
                        }
            return this.pushStack(o.length > 1 ? w.uniqueSort(o) : o)
        },
        index: function(e) {
            return e ? "string" == typeof e ? u.call(w(e), this[0]) : u.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
        },
        add: function(e, t) {
            return this.pushStack(w.uniqueSort(w.merge(this.get(), w(e, t))))
        },
        addBack: function(e) {
            return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
        }
    });
    function P(e, t) {
        while ((e = e[t]) && 1 !== e.nodeType)
            ;
        return e
    }
    w.each({
        parent: function(e) {
            var t = e.parentNode;
            return t && 11 !== t.nodeType ? t : null
        },
        parents: function(e) {
            return k(e, "parentNode")
        },
        parentsUntil: function(e, t, n) {
            return k(e, "parentNode", n)
        },
        next: function(e) {
            return P(e, "nextSibling")
        },
        prev: function(e) {
            return P(e, "previousSibling")
        },
        nextAll: function(e) {
            return k(e, "nextSibling")
        },
        prevAll: function(e) {
            return k(e, "previousSibling")
        },
        nextUntil: function(e, t, n) {
            return k(e, "nextSibling", n)
        },
        prevUntil: function(e, t, n) {
            return k(e, "previousSibling", n)
        },
        siblings: function(e) {
            return S((e.parentNode || {}).firstChild, e)
        },
        children: function(e) {
            return S(e.firstChild)
        },
        contents: function(e) {
            return N(e, "iframe") ? e.contentDocument : (N(e, "template") && (e = e.content || e),
            w.merge([], e.childNodes))
        }
    }, function(e, t) {
        w.fn[e] = function(n, r) {
            var i = w.map(this, t, n);
            return "Until" !== e.slice(-5) && (r = n),
            r && "string" == typeof r && (i = w.filter(r, i)),
            this.length > 1 && (O[e] || w.uniqueSort(i),
            H.test(e) && i.reverse()),
            this.pushStack(i)
        }
    });
    var M = /[^\x20\t\r\n\f]+/g;
    function R(e) {
        var t = {};
        return w.each(e.match(M) || [], function(e, n) {
            t[n] = !0
        }),
        t
    }
    w.Callbacks = function(e) {
        e = "string" == typeof e ? R(e) : w.extend({}, e);
        var t, n, r, i, o = [], a = [], s = -1, u = function() {
            for (i = i || e.once,
            r = t = !0; a.length; s = -1) {
                n = a.shift();
                while (++s < o.length)
                    !1 === o[s].apply(n[0], n[1]) && e.stopOnFalse && (s = o.length,
                    n = !1)
            }
            e.memory || (n = !1),
            t = !1,
            i && (o = n ? [] : "")
        }, l = {
            add: function() {
                return o && (n && !t && (s = o.length - 1,
                a.push(n)),
                function t(n) {
                    w.each(n, function(n, r) {
                        g(r) ? e.unique && l.has(r) || o.push(r) : r && r.length && "string" !== x(r) && t(r)
                    })
                }(arguments),
                n && !t && u()),
                this
            },
            remove: function() {
                return w.each(arguments, function(e, t) {
                    var n;
                    while ((n = w.inArray(t, o, n)) > -1)
                        o.splice(n, 1),
                        n <= s && s--
                }),
                this
            },
            has: function(e) {
                return e ? w.inArray(e, o) > -1 : o.length > 0
            },
            empty: function() {
                return o && (o = []),
                this
            },
            disable: function() {
                return i = a = [],
                o = n = "",
                this
            },
            disabled: function() {
                return !o
            },
            lock: function() {
                return i = a = [],
                n || t || (o = n = ""),
                this
            },
            locked: function() {
                return !!i
            },
            fireWith: function(e, n) {
                return i || (n = [e, (n = n || []).slice ? n.slice() : n],
                a.push(n),
                t || u()),
                this
            },
            fire: function() {
                return l.fireWith(this, arguments),
                this
            },
            fired: function() {
                return !!r
            }
        };
        return l
    }
    ;
    function I(e) {
        return e
    }
    function W(e) {
        throw e
    }
    function $(e, t, n, r) {
        var i;
        try {
            e && g(i = e.promise) ? i.call(e).done(t).fail(n) : e && g(i = e.then) ? i.call(e, t, n) : t.apply(void 0, [e].slice(r))
        } catch (e) {
            n.apply(void 0, [e])
        }
    }
    w.extend({
        Deferred: function(t) {
            var n = [["notify", "progress", w.Callbacks("memory"), w.Callbacks("memory"), 2], ["resolve", "done", w.Callbacks("once memory"), w.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", w.Callbacks("once memory"), w.Callbacks("once memory"), 1, "rejected"]]
              , r = "pending"
              , i = {
                state: function() {
                    return r
                },
                always: function() {
                    return o.done(arguments).fail(arguments),
                    this
                },
                "catch": function(e) {
                    return i.then(null, e)
                },
                pipe: function() {
                    var e = arguments;
                    return w.Deferred(function(t) {
                        w.each(n, function(n, r) {
                            var i = g(e[r[4]]) && e[r[4]];
                            o[r[1]](function() {
                                var e = i && i.apply(this, arguments);
                                e && g(e.promise) ? e.promise().progress(t.notify).done(t.resolve).fail(t.reject) : t[r[0] + "With"](this, i ? [e] : arguments)
                            })
                        }),
                        e = null
                    }).promise()
                },
                then: function(t, r, i) {
                    var o = 0;
                    function a(t, n, r, i) {
                        return function() {
                            var s = this
                              , u = arguments
                              , l = function() {
                                var e, l;
                                if (!(t < o)) {
                                    if ((e = r.apply(s, u)) === n.promise())
                                        throw new TypeError("Thenable self-resolution");
                                    l = e && ("object" == typeof e || "function" == typeof e) && e.then,
                                    g(l) ? i ? l.call(e, a(o, n, I, i), a(o, n, W, i)) : (o++,
                                    l.call(e, a(o, n, I, i), a(o, n, W, i), a(o, n, I, n.notifyWith))) : (r !== I && (s = void 0,
                                    u = [e]),
                                    (i || n.resolveWith)(s, u))
                                }
                            }
                              , c = i ? l : function() {
                                try {
                                    l()
                                } catch (e) {
                                    w.Deferred.exceptionHook && w.Deferred.exceptionHook(e, c.stackTrace),
                                    t + 1 >= o && (r !== W && (s = void 0,
                                    u = [e]),
                                    n.rejectWith(s, u))
                                }
                            }
                            ;
                            t ? c() : (w.Deferred.getStackHook && (c.stackTrace = w.Deferred.getStackHook()),
                            e.setTimeout(c))
                        }
                    }
                    return w.Deferred(function(e) {
                        n[0][3].add(a(0, e, g(i) ? i : I, e.notifyWith)),
                        n[1][3].add(a(0, e, g(t) ? t : I)),
                        n[2][3].add(a(0, e, g(r) ? r : W))
                    }).promise()
                },
                promise: function(e) {
                    return null != e ? w.extend(e, i) : i
                }
            }
              , o = {};
            return w.each(n, function(e, t) {
                var a = t[2]
                  , s = t[5];
                i[t[1]] = a.add,
                s && a.add(function() {
                    r = s
                }, n[3 - e][2].disable, n[3 - e][3].disable, n[0][2].lock, n[0][3].lock),
                a.add(t[3].fire),
                o[t[0]] = function() {
                    return o[t[0] + "With"](this === o ? void 0 : this, arguments),
                    this
                }
                ,
                o[t[0] + "With"] = a.fireWith
            }),
            i.promise(o),
            t && t.call(o, o),
            o
        },
        when: function(e) {
            var t = arguments.length
              , n = t
              , r = Array(n)
              , i = o.call(arguments)
              , a = w.Deferred()
              , s = function(e) {
                return function(n) {
                    r[e] = this,
                    i[e] = arguments.length > 1 ? o.call(arguments) : n,
                    --t || a.resolveWith(r, i)
                }
            };
            if (t <= 1 && ($(e, a.done(s(n)).resolve, a.reject, !t),
            "pending" === a.state() || g(i[n] && i[n].then)))
                return a.then();
            while (n--)
                $(i[n], s(n), a.reject);
            return a.promise()
        }
    });
    var B = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    w.Deferred.exceptionHook = function(t, n) {
        e.console && e.console.warn && t && B.test(t.name) && e.console.warn("jQuery.Deferred exception: " + t.message, t.stack, n)
    }
    ,
    w.readyException = function(t) {
        e.setTimeout(function() {
            throw t
        })
    }
    ;
    var F = w.Deferred();
    w.fn.ready = function(e) {
        return F.then(e)["catch"](function(e) {
            w.readyException(e)
        }),
        this
    }
    ,
    w.extend({
        isReady: !1,
        readyWait: 1,
        ready: function(e) {
            (!0 === e ? --w.readyWait : w.isReady) || (w.isReady = !0,
            !0 !== e && --w.readyWait > 0 || F.resolveWith(r, [w]))
        }
    }),
    w.ready.then = F.then;
    function _() {
        r.removeEventListener("DOMContentLoaded", _),
        e.removeEventListener("load", _),
        w.ready()
    }
    "complete" === r.readyState || "loading" !== r.readyState && !r.documentElement.doScroll ? e.setTimeout(w.ready) : (r.addEventListener("DOMContentLoaded", _),
    e.addEventListener("load", _));
    var z = function(e, t, n, r, i, o, a) {
        var s = 0
          , u = e.length
          , l = null == n;
        if ("object" === x(n)) {
            i = !0;
            for (s in n)
                z(e, t, s, n[s], !0, o, a)
        } else if (void 0 !== r && (i = !0,
        g(r) || (a = !0),
        l && (a ? (t.call(e, r),
        t = null) : (l = t,
        t = function(e, t, n) {
            return l.call(w(e), n)
        }
        )),
        t))
            for (; s < u; s++)
                t(e[s], n, a ? r : r.call(e[s], s, t(e[s], n)));
        return i ? e : l ? t.call(e) : u ? t(e[0], n) : o
    }
      , X = /^-ms-/
      , U = /-([a-z])/g;
    function V(e, t) {
        return t.toUpperCase()
    }
    function G(e) {
        return e.replace(X, "ms-").replace(U, V)
    }
    var Y = function(e) {
        return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType
    };
    function Q() {
        this.expando = w.expando + Q.uid++
    }
    Q.uid = 1,
    Q.prototype = {
        cache: function(e) {
            var t = e[this.expando];
            return t || (t = {},
            Y(e) && (e.nodeType ? e[this.expando] = t : Object.defineProperty(e, this.expando, {
                value: t,
                configurable: !0
            }))),
            t
        },
        set: function(e, t, n) {
            var r, i = this.cache(e);
            if ("string" == typeof t)
                i[G(t)] = n;
            else
                for (r in t)
                    i[G(r)] = t[r];
            return i
        },
        get: function(e, t) {
            return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][G(t)]
        },
        access: function(e, t, n) {
            return void 0 === t || t && "string" == typeof t && void 0 === n ? this.get(e, t) : (this.set(e, t, n),
            void 0 !== n ? n : t)
        },
        remove: function(e, t) {
            var n, r = e[this.expando];
            if (void 0 !== r) {
                if (void 0 !== t) {
                    n = (t = Array.isArray(t) ? t.map(G) : (t = G(t))in r ? [t] : t.match(M) || []).length;
                    while (n--)
                        delete r[t[n]]
                }
                (void 0 === t || w.isEmptyObject(r)) && (e.nodeType ? e[this.expando] = void 0 : delete e[this.expando])
            }
        },
        hasData: function(e) {
            var t = e[this.expando];
            return void 0 !== t && !w.isEmptyObject(t)
        }
    };
    var J = new Q
      , K = new Q
      , Z = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/
      , ee = /[A-Z]/g;
    function te(e) {
        return "true" === e || "false" !== e && ("null" === e ? null : e === +e + "" ? +e : Z.test(e) ? JSON.parse(e) : e)
    }
    function ne(e, t, n) {
        var r;
        if (void 0 === n && 1 === e.nodeType)
            if (r = "data-" + t.replace(ee, "-$&").toLowerCase(),
            "string" == typeof (n = e.getAttribute(r))) {
                try {
                    n = te(n)
                } catch (e) {}
                K.set(e, t, n)
            } else
                n = void 0;
        return n
    }
    w.extend({
        hasData: function(e) {
            return K.hasData(e) || J.hasData(e)
        },
        data: function(e, t, n) {
            return K.access(e, t, n)
        },
        removeData: function(e, t) {
            K.remove(e, t)
        },
        _data: function(e, t, n) {
            return J.access(e, t, n)
        },
        _removeData: function(e, t) {
            J.remove(e, t)
        }
    }),
    w.fn.extend({
        data: function(e, t) {
            var n, r, i, o = this[0], a = o && o.attributes;
            if (void 0 === e) {
                if (this.length && (i = K.get(o),
                1 === o.nodeType && !J.get(o, "hasDataAttrs"))) {
                    n = a.length;
                    while (n--)
                        a[n] && 0 === (r = a[n].name).indexOf("data-") && (r = G(r.slice(5)),
                        ne(o, r, i[r]));
                    J.set(o, "hasDataAttrs", !0)
                }
                return i
            }
            return "object" == typeof e ? this.each(function() {
                K.set(this, e)
            }) : z(this, function(t) {
                var n;
                if (o && void 0 === t) {
                    if (void 0 !== (n = K.get(o, e)))
                        return n;
                    if (void 0 !== (n = ne(o, e)))
                        return n
                } else
                    this.each(function() {
                        K.set(this, e, t)
                    })
            }, null, t, arguments.length > 1, null, !0)
        },
        removeData: function(e) {
            return this.each(function() {
                K.remove(this, e)
            })
        }
    }),
    w.extend({
        queue: function(e, t, n) {
            var r;
            if (e)
                return t = (t || "fx") + "queue",
                r = J.get(e, t),
                n && (!r || Array.isArray(n) ? r = J.access(e, t, w.makeArray(n)) : r.push(n)),
                r || []
        },
        dequeue: function(e, t) {
            t = t || "fx";
            var n = w.queue(e, t)
              , r = n.length
              , i = n.shift()
              , o = w._queueHooks(e, t)
              , a = function() {
                w.dequeue(e, t)
            };
            "inprogress" === i && (i = n.shift(),
            r--),
            i && ("fx" === t && n.unshift("inprogress"),
            delete o.stop,
            i.call(e, a, o)),
            !r && o && o.empty.fire()
        },
        _queueHooks: function(e, t) {
            var n = t + "queueHooks";
            return J.get(e, n) || J.access(e, n, {
                empty: w.Callbacks("once memory").add(function() {
                    J.remove(e, [t + "queue", n])
                })
            })
        }
    }),
    w.fn.extend({
        queue: function(e, t) {
            var n = 2;
            return "string" != typeof e && (t = e,
            e = "fx",
            n--),
            arguments.length < n ? w.queue(this[0], e) : void 0 === t ? this : this.each(function() {
                var n = w.queue(this, e, t);
                w._queueHooks(this, e),
                "fx" === e && "inprogress" !== n[0] && w.dequeue(this, e)
            })
        },
        dequeue: function(e) {
            return this.each(function() {
                w.dequeue(this, e)
            })
        },
        clearQueue: function(e) {
            return this.queue(e || "fx", [])
        },
        promise: function(e, t) {
            var n, r = 1, i = w.Deferred(), o = this, a = this.length, s = function() {
                --r || i.resolveWith(o, [o])
            };
            "string" != typeof e && (t = e,
            e = void 0),
            e = e || "fx";
            while (a--)
                (n = J.get(o[a], e + "queueHooks")) && n.empty && (r++,
                n.empty.add(s));
            return s(),
            i.promise(t)
        }
    });
    var re = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source
      , ie = new RegExp("^(?:([+-])=|)(" + re + ")([a-z%]*)$","i")
      , oe = ["Top", "Right", "Bottom", "Left"]
      , ae = function(e, t) {
        return "none" === (e = t || e).style.display || "" === e.style.display && w.contains(e.ownerDocument, e) && "none" === w.css(e, "display")
    }
      , se = function(e, t, n, r) {
        var i, o, a = {};
        for (o in t)
            a[o] = e.style[o],
            e.style[o] = t[o];
        i = n.apply(e, r || []);
        for (o in t)
            e.style[o] = a[o];
        return i
    };
    function ue(e, t, n, r) {
        var i, o, a = 20, s = r ? function() {
            return r.cur()
        }
        : function() {
            return w.css(e, t, "")
        }
        , u = s(), l = n && n[3] || (w.cssNumber[t] ? "" : "px"), c = (w.cssNumber[t] || "px" !== l && +u) && ie.exec(w.css(e, t));
        if (c && c[3] !== l) {
            u /= 2,
            l = l || c[3],
            c = +u || 1;
            while (a--)
                w.style(e, t, c + l),
                (1 - o) * (1 - (o = s() / u || .5)) <= 0 && (a = 0),
                c /= o;
            c *= 2,
            w.style(e, t, c + l),
            n = n || []
        }
        return n && (c = +c || +u || 0,
        i = n[1] ? c + (n[1] + 1) * n[2] : +n[2],
        r && (r.unit = l,
        r.start = c,
        r.end = i)),
        i
    }
    var le = {};
    function ce(e) {
        var t, n = e.ownerDocument, r = e.nodeName, i = le[r];
        return i || (t = n.body.appendChild(n.createElement(r)),
        i = w.css(t, "display"),
        t.parentNode.removeChild(t),
        "none" === i && (i = "block"),
        le[r] = i,
        i)
    }
    function fe(e, t) {
        for (var n, r, i = [], o = 0, a = e.length; o < a; o++)
            (r = e[o]).style && (n = r.style.display,
            t ? ("none" === n && (i[o] = J.get(r, "display") || null,
            i[o] || (r.style.display = "")),
            "" === r.style.display && ae(r) && (i[o] = ce(r))) : "none" !== n && (i[o] = "none",
            J.set(r, "display", n)));
        for (o = 0; o < a; o++)
            null != i[o] && (e[o].style.display = i[o]);
        return e
    }
    w.fn.extend({
        show: function() {
            return fe(this, !0)
        },
        hide: function() {
            return fe(this)
        },
        toggle: function(e) {
            return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function() {
                ae(this) ? w(this).show() : w(this).hide()
            })
        }
    });
    var pe = /^(?:checkbox|radio)$/i
      , de = /<([a-z][^\/\0>\x20\t\r\n\f]+)/i
      , he = /^$|^module$|\/(?:java|ecma)script/i
      , ge = {
        option: [1, "<select multiple='multiple'>", "</select>"],
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""]
    };
    ge.optgroup = ge.option,
    ge.tbody = ge.tfoot = ge.colgroup = ge.caption = ge.thead,
    ge.th = ge.td;
    function ye(e, t) {
        var n;
        return n = "undefined" != typeof e.getElementsByTagName ? e.getElementsByTagName(t || "*") : "undefined" != typeof e.querySelectorAll ? e.querySelectorAll(t || "*") : [],
        void 0 === t || t && N(e, t) ? w.merge([e], n) : n
    }
    function ve(e, t) {
        for (var n = 0, r = e.length; n < r; n++)
            J.set(e[n], "globalEval", !t || J.get(t[n], "globalEval"))
    }
    var me = /<|&#?\w+;/;
    function xe(e, t, n, r, i) {
        for (var o, a, s, u, l, c, f = t.createDocumentFragment(), p = [], d = 0, h = e.length; d < h; d++)
            if ((o = e[d]) || 0 === o)
                if ("object" === x(o))
                    w.merge(p, o.nodeType ? [o] : o);
                else if (me.test(o)) {
                    a = a || f.appendChild(t.createElement("div")),
                    s = (de.exec(o) || ["", ""])[1].toLowerCase(),
                    u = ge[s] || ge._default,
                    a.innerHTML = u[1] + w.htmlPrefilter(o) + u[2],
                    c = u[0];
                    while (c--)
                        a = a.lastChild;
                    w.merge(p, a.childNodes),
                    (a = f.firstChild).textContent = ""
                } else
                    p.push(t.createTextNode(o));
        f.textContent = "",
        d = 0;
        while (o = p[d++])
            if (r && w.inArray(o, r) > -1)
                i && i.push(o);
            else if (l = w.contains(o.ownerDocument, o),
            a = ye(f.appendChild(o), "script"),
            l && ve(a),
            n) {
                c = 0;
                while (o = a[c++])
                    he.test(o.type || "") && n.push(o)
            }
        return f
    }
    !function() {
        var e = r.createDocumentFragment().appendChild(r.createElement("div"))
          , t = r.createElement("input");
        t.setAttribute("type", "radio"),
        t.setAttribute("checked", "checked"),
        t.setAttribute("name", "t"),
        e.appendChild(t),
        h.checkClone = e.cloneNode(!0).cloneNode(!0).lastChild.checked,
        e.innerHTML = "<textarea>x</textarea>",
        h.noCloneChecked = !!e.cloneNode(!0).lastChild.defaultValue
    }();
    var be = r.documentElement
      , we = /^key/
      , Te = /^(?:mouse|pointer|contextmenu|drag|drop)|click/
      , Ce = /^([^.]*)(?:\.(.+)|)/;
    function Ee() {
        return !0
    }
    function ke() {
        return !1
    }
    function Se() {
        try {
            return r.activeElement
        } catch (e) {}
    }
    function De(e, t, n, r, i, o) {
        var a, s;
        if ("object" == typeof t) {
            "string" != typeof n && (r = r || n,
            n = void 0);
            for (s in t)
                De(e, s, n, r, t[s], o);
            return e
        }
        if (null == r && null == i ? (i = n,
        r = n = void 0) : null == i && ("string" == typeof n ? (i = r,
        r = void 0) : (i = r,
        r = n,
        n = void 0)),
        !1 === i)
            i = ke;
        else if (!i)
            return e;
        return 1 === o && (a = i,
        (i = function(e) {
            return w().off(e),
            a.apply(this, arguments)
        }
        ).guid = a.guid || (a.guid = w.guid++)),
        e.each(function() {
            w.event.add(this, t, i, r, n)
        })
    }
    w.event = {
        global: {},
        add: function(e, t, n, r, i) {
            var o, a, s, u, l, c, f, p, d, h, g, y = J.get(e);
            if (y) {
                n.handler && (n = (o = n).handler,
                i = o.selector),
                i && w.find.matchesSelector(be, i),
                n.guid || (n.guid = w.guid++),
                (u = y.events) || (u = y.events = {}),
                (a = y.handle) || (a = y.handle = function(t) {
                    return "undefined" != typeof w && w.event.triggered !== t.type ? w.event.dispatch.apply(e, arguments) : void 0
                }
                ),
                l = (t = (t || "").match(M) || [""]).length;
                while (l--)
                    d = g = (s = Ce.exec(t[l]) || [])[1],
                    h = (s[2] || "").split(".").sort(),
                    d && (f = w.event.special[d] || {},
                    d = (i ? f.delegateType : f.bindType) || d,
                    f = w.event.special[d] || {},
                    c = w.extend({
                        type: d,
                        origType: g,
                        data: r,
                        handler: n,
                        guid: n.guid,
                        selector: i,
                        needsContext: i && w.expr.match.needsContext.test(i),
                        namespace: h.join(".")
                    }, o),
                    (p = u[d]) || ((p = u[d] = []).delegateCount = 0,
                    f.setup && !1 !== f.setup.call(e, r, h, a) || e.addEventListener && e.addEventListener(d, a)),
                    f.add && (f.add.call(e, c),
                    c.handler.guid || (c.handler.guid = n.guid)),
                    i ? p.splice(p.delegateCount++, 0, c) : p.push(c),
                    w.event.global[d] = !0)
            }
        },
        remove: function(e, t, n, r, i) {
            var o, a, s, u, l, c, f, p, d, h, g, y = J.hasData(e) && J.get(e);
            if (y && (u = y.events)) {
                l = (t = (t || "").match(M) || [""]).length;
                while (l--)
                    if (s = Ce.exec(t[l]) || [],
                    d = g = s[1],
                    h = (s[2] || "").split(".").sort(),
                    d) {
                        f = w.event.special[d] || {},
                        p = u[d = (r ? f.delegateType : f.bindType) || d] || [],
                        s = s[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                        a = o = p.length;
                        while (o--)
                            c = p[o],
                            !i && g !== c.origType || n && n.guid !== c.guid || s && !s.test(c.namespace) || r && r !== c.selector && ("**" !== r || !c.selector) || (p.splice(o, 1),
                            c.selector && p.delegateCount--,
                            f.remove && f.remove.call(e, c));
                        a && !p.length && (f.teardown && !1 !== f.teardown.call(e, h, y.handle) || w.removeEvent(e, d, y.handle),
                        delete u[d])
                    } else
                        for (d in u)
                            w.event.remove(e, d + t[l], n, r, !0);
                w.isEmptyObject(u) && J.remove(e, "handle events")
            }
        },
        dispatch: function(e) {
            var t = w.event.fix(e), n, r, i, o, a, s, u = new Array(arguments.length), l = (J.get(this, "events") || {})[t.type] || [], c = w.event.special[t.type] || {};
            for (u[0] = t,
            n = 1; n < arguments.length; n++)
                u[n] = arguments[n];
            if (t.delegateTarget = this,
            !c.preDispatch || !1 !== c.preDispatch.call(this, t)) {
                s = w.event.handlers.call(this, t, l),
                n = 0;
                while ((o = s[n++]) && !t.isPropagationStopped()) {
                    t.currentTarget = o.elem,
                    r = 0;
                    while ((a = o.handlers[r++]) && !t.isImmediatePropagationStopped())
                        t.rnamespace && !t.rnamespace.test(a.namespace) || (t.handleObj = a,
                        t.data = a.data,
                        void 0 !== (i = ((w.event.special[a.origType] || {}).handle || a.handler).apply(o.elem, u)) && !1 === (t.result = i) && (t.preventDefault(),
                        t.stopPropagation()))
                }
                return c.postDispatch && c.postDispatch.call(this, t),
                t.result
            }
        },
        handlers: function(e, t) {
            var n, r, i, o, a, s = [], u = t.delegateCount, l = e.target;
            if (u && l.nodeType && !("click" === e.type && e.button >= 1))
                for (; l !== this; l = l.parentNode || this)
                    if (1 === l.nodeType && ("click" !== e.type || !0 !== l.disabled)) {
                        for (o = [],
                        a = {},
                        n = 0; n < u; n++)
                            void 0 === a[i = (r = t[n]).selector + " "] && (a[i] = r.needsContext ? w(i, this).index(l) > -1 : w.find(i, this, null, [l]).length),
                            a[i] && o.push(r);
                        o.length && s.push({
                            elem: l,
                            handlers: o
                        })
                    }
            return l = this,
            u < t.length && s.push({
                elem: l,
                handlers: t.slice(u)
            }),
            s
        },
        addProp: function(e, t) {
            Object.defineProperty(w.Event.prototype, e, {
                enumerable: !0,
                configurable: !0,
                get: g(t) ? function() {
                    if (this.originalEvent)
                        return t(this.originalEvent)
                }
                : function() {
                    if (this.originalEvent)
                        return this.originalEvent[e]
                }
                ,
                set: function(t) {
                    Object.defineProperty(this, e, {
                        enumerable: !0,
                        configurable: !0,
                        writable: !0,
                        value: t
                    })
                }
            })
        },
        fix: function(e) {
            return e[w.expando] ? e : new w.Event(e)
        },
        special: {
            load: {
                noBubble: !0
            },
            focus: {
                trigger: function() {
                    if (this !== Se() && this.focus)
                        return this.focus(),
                        !1
                },
                delegateType: "focusin"
            },
            blur: {
                trigger: function() {
                    if (this === Se() && this.blur)
                        return this.blur(),
                        !1
                },
                delegateType: "focusout"
            },
            click: {
                trigger: function() {
                    if ("checkbox" === this.type && this.click && N(this, "input"))
                        return this.click(),
                        !1
                },
                _default: function(e) {
                    return N(e.target, "a")
                }
            },
            beforeunload: {
                postDispatch: function(e) {
                    void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result)
                }
            }
        }
    },
    w.removeEvent = function(e, t, n) {
        e.removeEventListener && e.removeEventListener(t, n)
    }
    ,
    w.Event = function(e, t) {
        if (!(this instanceof w.Event))
            return new w.Event(e,t);
        e && e.type ? (this.originalEvent = e,
        this.type = e.type,
        this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? Ee : ke,
        this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target,
        this.currentTarget = e.currentTarget,
        this.relatedTarget = e.relatedTarget) : this.type = e,
        t && w.extend(this, t),
        this.timeStamp = e && e.timeStamp || Date.now(),
        this[w.expando] = !0
    }
    ,
    w.Event.prototype = {
        constructor: w.Event,
        isDefaultPrevented: ke,
        isPropagationStopped: ke,
        isImmediatePropagationStopped: ke,
        isSimulated: !1,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = Ee,
            e && !this.isSimulated && e.preventDefault()
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = Ee,
            e && !this.isSimulated && e.stopPropagation()
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = Ee,
            e && !this.isSimulated && e.stopImmediatePropagation(),
            this.stopPropagation()
        }
    },
    w.each({
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        "char": !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: function(e) {
            var t = e.button;
            return null == e.which && we.test(e.type) ? null != e.charCode ? e.charCode : e.keyCode : !e.which && void 0 !== t && Te.test(e.type) ? 1 & t ? 1 : 2 & t ? 3 : 4 & t ? 2 : 0 : e.which
        }
    }, w.event.addProp),
    w.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(e, t) {
        w.event.special[e] = {
            delegateType: t,
            bindType: t,
            handle: function(e) {
                var n, r = this, i = e.relatedTarget, o = e.handleObj;
                return i && (i === r || w.contains(r, i)) || (e.type = o.origType,
                n = o.handler.apply(this, arguments),
                e.type = t),
                n
            }
        }
    }),
    w.fn.extend({
        on: function(e, t, n, r) {
            return De(this, e, t, n, r)
        },
        one: function(e, t, n, r) {
            return De(this, e, t, n, r, 1)
        },
        off: function(e, t, n) {
            var r, i;
            if (e && e.preventDefault && e.handleObj)
                return r = e.handleObj,
                w(e.delegateTarget).off(r.namespace ? r.origType + "." + r.namespace : r.origType, r.selector, r.handler),
                this;
            if ("object" == typeof e) {
                for (i in e)
                    this.off(i, t, e[i]);
                return this
            }
            return !1 !== t && "function" != typeof t || (n = t,
            t = void 0),
            !1 === n && (n = ke),
            this.each(function() {
                w.event.remove(this, e, n, t)
            })
        }
    });
    var Ne = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi
      , Ae = /<script|<style|<link/i
      , je = /checked\s*(?:[^=]|=\s*.checked.)/i
      , qe = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    function Le(e, t) {
        return N(e, "table") && N(11 !== t.nodeType ? t : t.firstChild, "tr") ? w(e).children("tbody")[0] || e : e
    }
    function He(e) {
        return e.type = (null !== e.getAttribute("type")) + "/" + e.type,
        e
    }
    function Oe(e) {
        return "true/" === (e.type || "").slice(0, 5) ? e.type = e.type.slice(5) : e.removeAttribute("type"),
        e
    }
    function Pe(e, t) {
        var n, r, i, o, a, s, u, l;
        if (1 === t.nodeType) {
            if (J.hasData(e) && (o = J.access(e),
            a = J.set(t, o),
            l = o.events)) {
                delete a.handle,
                a.events = {};
                for (i in l)
                    for (n = 0,
                    r = l[i].length; n < r; n++)
                        w.event.add(t, i, l[i][n])
            }
            K.hasData(e) && (s = K.access(e),
            u = w.extend({}, s),
            K.set(t, u))
        }
    }
    function Me(e, t) {
        var n = t.nodeName.toLowerCase();
        "input" === n && pe.test(e.type) ? t.checked = e.checked : "input" !== n && "textarea" !== n || (t.defaultValue = e.defaultValue)
    }
    function Re(e, t, n, r) {
        t = a.apply([], t);
        var i, o, s, u, l, c, f = 0, p = e.length, d = p - 1, y = t[0], v = g(y);
        if (v || p > 1 && "string" == typeof y && !h.checkClone && je.test(y))
            return e.each(function(i) {
                var o = e.eq(i);
                v && (t[0] = y.call(this, i, o.html())),
                Re(o, t, n, r)
            });
        if (p && (i = xe(t, e[0].ownerDocument, !1, e, r),
        o = i.firstChild,
        1 === i.childNodes.length && (i = o),
        o || r)) {
            for (u = (s = w.map(ye(i, "script"), He)).length; f < p; f++)
                l = i,
                f !== d && (l = w.clone(l, !0, !0),
                u && w.merge(s, ye(l, "script"))),
                n.call(e[f], l, f);
            if (u)
                for (c = s[s.length - 1].ownerDocument,
                w.map(s, Oe),
                f = 0; f < u; f++)
                    l = s[f],
                    he.test(l.type || "") && !J.access(l, "globalEval") && w.contains(c, l) && (l.src && "module" !== (l.type || "").toLowerCase() ? w._evalUrl && w._evalUrl(l.src) : m(l.textContent.replace(qe, ""), c, l))
        }
        return e
    }
    function Ie(e, t, n) {
        for (var r, i = t ? w.filter(t, e) : e, o = 0; null != (r = i[o]); o++)
            n || 1 !== r.nodeType || w.cleanData(ye(r)),
            r.parentNode && (n && w.contains(r.ownerDocument, r) && ve(ye(r, "script")),
            r.parentNode.removeChild(r));
        return e
    }
    w.extend({
        htmlPrefilter: function(e) {
            return e.replace(Ne, "<$1></$2>")
        },
        clone: function(e, t, n) {
            var r, i, o, a, s = e.cloneNode(!0), u = w.contains(e.ownerDocument, e);
            if (!(h.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || w.isXMLDoc(e)))
                for (a = ye(s),
                r = 0,
                i = (o = ye(e)).length; r < i; r++)
                    Me(o[r], a[r]);
            if (t)
                if (n)
                    for (o = o || ye(e),
                    a = a || ye(s),
                    r = 0,
                    i = o.length; r < i; r++)
                        Pe(o[r], a[r]);
                else
                    Pe(e, s);
            return (a = ye(s, "script")).length > 0 && ve(a, !u && ye(e, "script")),
            s
        },
        cleanData: function(e) {
            for (var t, n, r, i = w.event.special, o = 0; void 0 !== (n = e[o]); o++)
                if (Y(n)) {
                    if (t = n[J.expando]) {
                        if (t.events)
                            for (r in t.events)
                                i[r] ? w.event.remove(n, r) : w.removeEvent(n, r, t.handle);
                        n[J.expando] = void 0
                    }
                    n[K.expando] && (n[K.expando] = void 0)
                }
        }
    }),
    w.fn.extend({
        detach: function(e) {
            return Ie(this, e, !0)
        },
        remove: function(e) {
            return Ie(this, e)
        },
        text: function(e) {
            return z(this, function(e) {
                return void 0 === e ? w.text(this) : this.empty().each(function() {
                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = e)
                })
            }, null, e, arguments.length)
        },
        append: function() {
            return Re(this, arguments, function(e) {
                1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || Le(this, e).appendChild(e)
            })
        },
        prepend: function() {
            return Re(this, arguments, function(e) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var t = Le(this, e);
                    t.insertBefore(e, t.firstChild)
                }
            })
        },
        before: function() {
            return Re(this, arguments, function(e) {
                this.parentNode && this.parentNode.insertBefore(e, this)
            })
        },
        after: function() {
            return Re(this, arguments, function(e) {
                this.parentNode && this.parentNode.insertBefore(e, this.nextSibling)
            })
        },
        empty: function() {
            for (var e, t = 0; null != (e = this[t]); t++)
                1 === e.nodeType && (w.cleanData(ye(e, !1)),
                e.textContent = "");
            return this
        },
        clone: function(e, t) {
            return e = null != e && e,
            t = null == t ? e : t,
            this.map(function() {
                return w.clone(this, e, t)
            })
        },
        html: function(e) {
            return z(this, function(e) {
                var t = this[0] || {}
                  , n = 0
                  , r = this.length;
                if (void 0 === e && 1 === t.nodeType)
                    return t.innerHTML;
                if ("string" == typeof e && !Ae.test(e) && !ge[(de.exec(e) || ["", ""])[1].toLowerCase()]) {
                    e = w.htmlPrefilter(e);
                    try {
                        for (; n < r; n++)
                            1 === (t = this[n] || {}).nodeType && (w.cleanData(ye(t, !1)),
                            t.innerHTML = e);
                        t = 0
                    } catch (e) {}
                }
                t && this.empty().append(e)

    if (BOLD && BOLD.common && BOLD.common.eventEmitter &&
        typeof BOLD.common.eventEmitter.emit === 'function') {
      BOLD.common.eventEmitter.emit("BOLD_COMMON_variant_changed");
    }
            }, null, e, arguments.length)
        },
        replaceWith: function() {
            var e = [];
            return Re(this, arguments, function(t) {
                var n = this.parentNode;
                w.inArray(this, e) < 0 && (w.cleanData(ye(this)),
                n && n.replaceChild(t, this))
            }, e)
        }
    }),
    w.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(e, t) {
        w.fn[e] = function(e) {
            for (var n, r = [], i = w(e), o = i.length - 1, a = 0; a <= o; a++)
                n = a === o ? this : this.clone(!0),
                w(i[a])[t](n),
                s.apply(r, n.get());
            return this.pushStack(r)
        }
    });
    var We = new RegExp("^(" + re + ")(?!px)[a-z%]+$","i")
      , $e = function(t) {
        var n = t.ownerDocument.defaultView;
        return n && n.opener || (n = e),
        n.getComputedStyle(t)
    }
      , Be = new RegExp(oe.join("|"),"i");
    !function() {
        function t() {
            if (c) {
                l.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",
                c.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",
                be.appendChild(l).appendChild(c);
                var t = e.getComputedStyle(c);
                i = "1%" !== t.top,
                u = 12 === n(t.marginLeft),
                c.style.right = "60%",
                s = 36 === n(t.right),
                o = 36 === n(t.width),
                c.style.position = "absolute",
                a = 36 === c.offsetWidth || "absolute",
                be.removeChild(l),
                c = null
            }
        }
        function n(e) {
            return Math.round(parseFloat(e))
        }
        var i, o, a, s, u, l = r.createElement("div"), c = r.createElement("div");
        c.style && (c.style.backgroundClip = "content-box",
        c.cloneNode(!0).style.backgroundClip = "",
        h.clearCloneStyle = "content-box" === c.style.backgroundClip,
        w.extend(h, {
            boxSizingReliable: function() {
                return t(),
                o
            },
            pixelBoxStyles: function() {
                return t(),
                s
            },
            pixelPosition: function() {
                return t(),
                i
            },
            reliableMarginLeft: function() {
                return t(),
                u
            },
            scrollboxSize: function() {
                return t(),
                a
            }
        }))
    }();
    function Fe(e, t, n) {
        var r, i, o, a, s = e.style;
        return (n = n || $e(e)) && ("" !== (a = n.getPropertyValue(t) || n[t]) || w.contains(e.ownerDocument, e) || (a = w.style(e, t)),
        !h.pixelBoxStyles() && We.test(a) && Be.test(t) && (r = s.width,
        i = s.minWidth,
        o = s.maxWidth,
        s.minWidth = s.maxWidth = s.width = a,
        a = n.width,
        s.width = r,
        s.minWidth = i,
        s.maxWidth = o)),
        void 0 !== a ? a + "" : a
    }
    function _e(e, t) {
        return {
            get: function() {
                if (!e())
                    return (this.get = t).apply(this, arguments);
                delete this.get
            }
        }
    }
    var ze = /^(none|table(?!-c[ea]).+)/
      , Xe = /^--/
      , Ue = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }
      , Ve = {
        letterSpacing: "0",
        fontWeight: "400"
    }
      , Ge = ["Webkit", "Moz", "ms"]
      , Ye = r.createElement("div").style;
    function Qe(e) {
        if (e in Ye)
            return e;
        var t = e[0].toUpperCase() + e.slice(1)
          , n = Ge.length;
        while (n--)
            if ((e = Ge[n] + t)in Ye)
                return e
    }
    function Je(e) {
        var t = w.cssProps[e];
        return t || (t = w.cssProps[e] = Qe(e) || e),
        t
    }
    function Ke(e, t, n) {
        var r = ie.exec(t);
        return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || "px") : t
    }
    function Ze(e, t, n, r, i, o) {
        var a = "width" === t ? 1 : 0
          , s = 0
          , u = 0;
        if (n === (r ? "border" : "content"))
            return 0;
        for (; a < 4; a += 2)
            "margin" === n && (u += w.css(e, n + oe[a], !0, i)),
            r ? ("content" === n && (u -= w.css(e, "padding" + oe[a], !0, i)),
            "margin" !== n && (u -= w.css(e, "border" + oe[a] + "Width", !0, i))) : (u += w.css(e, "padding" + oe[a], !0, i),
            "padding" !== n ? u += w.css(e, "border" + oe[a] + "Width", !0, i) : s += w.css(e, "border" + oe[a] + "Width", !0, i));
        return !r && o >= 0 && (u += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - o - u - s - .5))),
        u
    }
    function et(e, t, n) {
        var r = $e(e)
          , i = Fe(e, t, r)
          , o = "border-box" === w.css(e, "boxSizing", !1, r)
          , a = o;
        if (We.test(i)) {
            if (!n)
                return i;
            i = "auto"
        }
        return a = a && (h.boxSizingReliable() || i === e.style[t]),
        ("auto" === i || !parseFloat(i) && "inline" === w.css(e, "display", !1, r)) && (i = e["offset" + t[0].toUpperCase() + t.slice(1)],
        a = !0),
        (i = parseFloat(i) || 0) + Ze(e, t, n || (o ? "border" : "content"), a, r, i) + "px"
    }
    w.extend({
        cssHooks: {
            opacity: {
                get: function(e, t) {
                    if (t) {
                        var n = Fe(e, "opacity");
                        return "" === n ? "1" : n
                    }
                }
            }
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {},
        style: function(e, t, n, r) {
            if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                var i, o, a, s = G(t), u = Xe.test(t), l = e.style;
                if (u || (t = Je(s)),
                a = w.cssHooks[t] || w.cssHooks[s],
                void 0 === n)
                    return a && "get"in a && void 0 !== (i = a.get(e, !1, r)) ? i : l[t];
                "string" == (o = typeof n) && (i = ie.exec(n)) && i[1] && (n = ue(e, t, i),
                o = "number"),
                null != n && n === n && ("number" === o && (n += i && i[3] || (w.cssNumber[s] ? "" : "px")),
                h.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (l[t] = "inherit"),
                a && "set"in a && void 0 === (n = a.set(e, n, r)) || (u ? l.setProperty(t, n) : l[t] = n))
            }
        },
        css: function(e, t, n, r) {
            var i, o, a, s = G(t);
            return Xe.test(t) || (t = Je(s)),
            (a = w.cssHooks[t] || w.cssHooks[s]) && "get"in a && (i = a.get(e, !0, n)),
            void 0 === i && (i = Fe(e, t, r)),
            "normal" === i && t in Ve && (i = Ve[t]),
            "" === n || n ? (o = parseFloat(i),
            !0 === n || isFinite(o) ? o || 0 : i) : i
        }
    }),
    w.each(["height", "width"], function(e, t) {
        w.cssHooks[t] = {
            get: function(e, n, r) {
                if (n)
                    return !ze.test(w.css(e, "display")) || e.getClientRects().length && e.getBoundingClientRect().width ? et(e, t, r) : se(e, Ue, function() {
                        return et(e, t, r)
                    })
            },
            set: function(e, n, r) {
                var i, o = $e(e), a = "border-box" === w.css(e, "boxSizing", !1, o), s = r && Ze(e, t, r, a, o);
                return a && h.scrollboxSize() === o.position && (s -= Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - parseFloat(o[t]) - Ze(e, t, "border", !1, o) - .5)),
                s && (i = ie.exec(n)) && "px" !== (i[3] || "px") && (e.style[t] = n,
                n = w.css(e, t)),
                Ke(e, n, s)
            }
        }
    }),
    w.cssHooks.marginLeft = _e(h.reliableMarginLeft, function(e, t) {
        if (t)
            return (parseFloat(Fe(e, "marginLeft")) || e.getBoundingClientRect().left - se(e, {
                marginLeft: 0
            }, function() {
                return e.getBoundingClientRect().left
            })) + "px"
    }),
    w.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(e, t) {
        w.cssHooks[e + t] = {
            expand: function(n) {
                for (var r = 0, i = {}, o = "string" == typeof n ? n.split(" ") : [n]; r < 4; r++)
                    i[e + oe[r] + t] = o[r] || o[r - 2] || o[0];
                return i
            }
        },
        "margin" !== e && (w.cssHooks[e + t].set = Ke)
    }),
    w.fn.extend({
        css: function(e, t) {
            return z(this, function(e, t, n) {
                var r, i, o = {}, a = 0;
                if (Array.isArray(t)) {
                    for (r = $e(e),
                    i = t.length; a < i; a++)
                        o[t[a]] = w.css(e, t[a], !1, r);
                    return o
                }
                return void 0 !== n ? w.style(e, t, n) : w.css(e, t)
            }, e, t, arguments.length > 1)
        }
    });
    function tt(e, t, n, r, i) {
        return new tt.prototype.init(e,t,n,r,i)
    }
    w.Tween = tt,
    tt.prototype = {
        constructor: tt,
        init: function(e, t, n, r, i, o) {
            this.elem = e,
            this.prop = n,
            this.easing = i || w.easing._default,
            this.options = t,
            this.start = this.now = this.cur(),
            this.end = r,
            this.unit = o || (w.cssNumber[n] ? "" : "px")
        },
        cur: function() {
            var e = tt.propHooks[this.prop];
            return e && e.get ? e.get(this) : tt.propHooks._default.get(this)
        },
        run: function(e) {
            var t, n = tt.propHooks[this.prop];
            return this.options.duration ? this.pos = t = w.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e,
            this.now = (this.end - this.start) * t + this.start,
            this.options.step && this.options.step.call(this.elem, this.now, this),
            n && n.set ? n.set(this) : tt.propHooks._default.set(this),
            this
        }
    },
    tt.prototype.init.prototype = tt.prototype,
    tt.propHooks = {
        _default: {
            get: function(e) {
                var t;
                return 1 !== e.elem.nodeType || null != e.elem[e.prop] && null == e.elem.style[e.prop] ? e.elem[e.prop] : (t = w.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0
            },
            set: function(e) {
                w.fx.step[e.prop] ? w.fx.step[e.prop](e) : 1 !== e.elem.nodeType || null == e.elem.style[w.cssProps[e.prop]] && !w.cssHooks[e.prop] ? e.elem[e.prop] = e.now : w.style(e.elem, e.prop, e.now + e.unit)
            }
        }
    },
    tt.propHooks.scrollTop = tt.propHooks.scrollLeft = {
        set: function(e) {
            e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now)
        }
    },
    w.easing = {
        linear: function(e) {
            return e
        },
        swing: function(e) {
            return .5 - Math.cos(e * Math.PI) / 2
        },
        _default: "swing"
    },
    w.fx = tt.prototype.init,
    w.fx.step = {};
    var nt, rt, it = /^(?:toggle|show|hide)$/, ot = /queueHooks$/;
    function at() {
        rt && (!1 === r.hidden && e.requestAnimationFrame ? e.requestAnimationFrame(at) : e.setTimeout(at, w.fx.interval),
        w.fx.tick())
    }
    function st() {
        return e.setTimeout(function() {
            nt = void 0
        }),
        nt = Date.now()
    }
    function ut(e, t) {
        var n, r = 0, i = {
            height: e
        };
        for (t = t ? 1 : 0; r < 4; r += 2 - t)
            i["margin" + (n = oe[r])] = i["padding" + n] = e;
        return t && (i.opacity = i.width = e),
        i
    }
    function lt(e, t, n) {
        for (var r, i = (pt.tweeners[t] || []).concat(pt.tweeners["*"]), o = 0, a = i.length; o < a; o++)
            if (r = i[o].call(n, t, e))
                return r
    }
    function ct(e, t, n) {
        var r, i, o, a, s, u, l, c, f = "width"in t || "height"in t, p = this, d = {}, h = e.style, g = e.nodeType && ae(e), y = J.get(e, "fxshow");
        n.queue || (null == (a = w._queueHooks(e, "fx")).unqueued && (a.unqueued = 0,
        s = a.empty.fire,
        a.empty.fire = function() {
            a.unqueued || s()
        }
        ),
        a.unqueued++,
        p.always(function() {
            p.always(function() {
                a.unqueued--,
                w.queue(e, "fx").length || a.empty.fire()
            })
        }));
        for (r in t)
            if (i = t[r],
            it.test(i)) {
                if (delete t[r],
                o = o || "toggle" === i,
                i === (g ? "hide" : "show")) {
                    if ("show" !== i || !y || void 0 === y[r])
                        continue;
                    g = !0
                }
                d[r] = y && y[r] || w.style(e, r)
            }
        if ((u = !w.isEmptyObject(t)) || !w.isEmptyObject(d)) {
            f && 1 === e.nodeType && (n.overflow = [h.overflow, h.overflowX, h.overflowY],
            null == (l = y && y.display) && (l = J.get(e, "display")),
            "none" === (c = w.css(e, "display")) && (l ? c = l : (fe([e], !0),
            l = e.style.display || l,
            c = w.css(e, "display"),
            fe([e]))),
            ("inline" === c || "inline-block" === c && null != l) && "none" === w.css(e, "float") && (u || (p.done(function() {
                h.display = l
            }),
            null == l && (c = h.display,
            l = "none" === c ? "" : c)),
            h.display = "inline-block")),
            n.overflow && (h.overflow = "hidden",
            p.always(function() {
                h.overflow = n.overflow[0],
                h.overflowX = n.overflow[1],
                h.overflowY = n.overflow[2]
            })),
            u = !1;
            for (r in d)
                u || (y ? "hidden"in y && (g = y.hidden) : y = J.access(e, "fxshow", {
                    display: l
                }),
                o && (y.hidden = !g),
                g && fe([e], !0),
                p.done(function() {
                    g || fe([e]),
                    J.remove(e, "fxshow");
                    for (r in d)
                        w.style(e, r, d[r])
                })),
                u = lt(g ? y[r] : 0, r, p),
                r in y || (y[r] = u.start,
                g && (u.end = u.start,
                u.start = 0))
        }
    }
    function ft(e, t) {
        var n, r, i, o, a;
        for (n in e)
            if (r = G(n),
            i = t[r],
            o = e[n],
            Array.isArray(o) && (i = o[1],
            o = e[n] = o[0]),
            n !== r && (e[r] = o,
            delete e[n]),
            (a = w.cssHooks[r]) && "expand"in a) {
                o = a.expand(o),
                delete e[r];
                for (n in o)
                    n in e || (e[n] = o[n],
                    t[n] = i)
            } else
                t[r] = i
    }
    function pt(e, t, n) {
        var r, i, o = 0, a = pt.prefilters.length, s = w.Deferred().always(function() {
            delete u.elem
        }), u = function() {
            if (i)
                return !1;
            for (var t = nt || st(), n = Math.max(0, l.startTime + l.duration - t), r = 1 - (n / l.duration || 0), o = 0, a = l.tweens.length; o < a; o++)
                l.tweens[o].run(r);
            return s.notifyWith(e, [l, r, n]),
            r < 1 && a ? n : (a || s.notifyWith(e, [l, 1, 0]),
            s.resolveWith(e, [l]),
            !1)
        }, l = s.promise({
            elem: e,
            props: w.extend({}, t),
            opts: w.extend(!0, {
                specialEasing: {},
                easing: w.easing._default
            }, n),
            originalProperties: t,
            originalOptions: n,
            startTime: nt || st(),
            duration: n.duration,
            tweens: [],
            createTween: function(t, n) {
                var r = w.Tween(e, l.opts, t, n, l.opts.specialEasing[t] || l.opts.easing);
                return l.tweens.push(r),
                r
            },
            stop: function(t) {
                var n = 0
                  , r = t ? l.tweens.length : 0;
                if (i)
                    return this;
                for (i = !0; n < r; n++)
                    l.tweens[n].run(1);
                return t ? (s.notifyWith(e, [l, 1, 0]),
                s.resolveWith(e, [l, t])) : s.rejectWith(e, [l, t]),
                this
            }
        }), c = l.props;
        for (ft(c, l.opts.specialEasing); o < a; o++)
            if (r = pt.prefilters[o].call(l, e, c, l.opts))
                return g(r.stop) && (w._queueHooks(l.elem, l.opts.queue).stop = r.stop.bind(r)),
                r;
        return w.map(c, lt, l),
        g(l.opts.start) && l.opts.start.call(e, l),
        l.progress(l.opts.progress).done(l.opts.done, l.opts.complete).fail(l.opts.fail).always(l.opts.always),
        w.fx.timer(w.extend(u, {
            elem: e,
            anim: l,
            queue: l.opts.queue
        })),
        l
    }
    w.Animation = w.extend(pt, {
        tweeners: {
            "*": [function(e, t) {
                var n = this.createTween(e, t);
                return ue(n.elem, e, ie.exec(t), n),
                n
            }
            ]
        },
        tweener: function(e, t) {
            g(e) ? (t = e,
            e = ["*"]) : e = e.match(M);
            for (var n, r = 0, i = e.length; r < i; r++)
                n = e[r],
                pt.tweeners[n] = pt.tweeners[n] || [],
                pt.tweeners[n].unshift(t)
        },
        prefilters: [ct],
        prefilter: function(e, t) {
            t ? pt.prefilters.unshift(e) : pt.prefilters.push(e)
        }
    }),
    w.speed = function(e, t, n) {
        var r = e && "object" == typeof e ? w.extend({}, e) : {
            complete: n || !n && t || g(e) && e,
            duration: e,
            easing: n && t || t && !g(t) && t
        };
        return w.fx.off ? r.duration = 0 : "number" != typeof r.duration && (r.duration in w.fx.speeds ? r.duration = w.fx.speeds[r.duration] : r.duration = w.fx.speeds._default),
        null != r.queue && !0 !== r.queue || (r.queue = "fx"),
        r.old = r.complete,
        r.complete = function() {
            g(r.old) && r.old.call(this),
            r.queue && w.dequeue(this, r.queue)
        }
        ,
        r
    }
    ,
    w.fn.extend({
        fadeTo: function(e, t, n, r) {
            return this.filter(ae).css("opacity", 0).show().end().animate({
                opacity: t
            }, e, n, r)
        },
        animate: function(e, t, n, r) {
            var i = w.isEmptyObject(e)
              , o = w.speed(t, n, r)
              , a = function() {
                var t = pt(this, w.extend({}, e), o);
                (i || J.get(this, "finish")) && t.stop(!0)
            };
            return a.finish = a,
            i || !1 === o.queue ? this.each(a) : this.queue(o.queue, a)
        },
        stop: function(e, t, n) {
            var r = function(e) {
                var t = e.stop;
                delete e.stop,
                t(n)
            };
            return "string" != typeof e && (n = t,
            t = e,
            e = void 0),
            t && !1 !== e && this.queue(e || "fx", []),
            this.each(function() {
                var t = !0
                  , i = null != e && e + "queueHooks"
                  , o = w.timers
                  , a = J.get(this);
                if (i)
                    a[i] && a[i].stop && r(a[i]);
                else
                    for (i in a)
                        a[i] && a[i].stop && ot.test(i) && r(a[i]);
                for (i = o.length; i--; )
                    o[i].elem !== this || null != e && o[i].queue !== e || (o[i].anim.stop(n),
                    t = !1,
                    o.splice(i, 1));
                !t && n || w.dequeue(this, e)
            })
        },
        finish: function(e) {
            return !1 !== e && (e = e || "fx"),
            this.each(function() {
                var t, n = J.get(this), r = n[e + "queue"], i = n[e + "queueHooks"], o = w.timers, a = r ? r.length : 0;
                for (n.finish = !0,
                w.queue(this, e, []),
                i && i.stop && i.stop.call(this, !0),
                t = o.length; t--; )
                    o[t].elem === this && o[t].queue === e && (o[t].anim.stop(!0),
                    o.splice(t, 1));
                for (t = 0; t < a; t++)
                    r[t] && r[t].finish && r[t].finish.call(this);
                delete n.finish
            })
        }
    }),
    w.each(["toggle", "show", "hide"], function(e, t) {
        var n = w.fn[t];
        w.fn[t] = function(e, r, i) {
            return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(ut(t, !0), e, r, i)
        }
    }),
    w.each({
        slideDown: ut("show"),
        slideUp: ut("hide"),
        slideToggle: ut("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(e, t) {
        w.fn[e] = function(e, n, r) {
            return this.animate(t, e, n, r)
        }
    }),
    w.timers = [],
    w.fx.tick = function() {
        var e, t = 0, n = w.timers;
        for (nt = Date.now(); t < n.length; t++)
            (e = n[t])() || n[t] !== e || n.splice(t--, 1);
        n.length || w.fx.stop(),
        nt = void 0
    }
    ,
    w.fx.timer = function(e) {
        w.timers.push(e),
        w.fx.start()
    }
    ,
    w.fx.interval = 13,
    w.fx.start = function() {
        rt || (rt = !0,
        at())
    }
    ,
    w.fx.stop = function() {
        rt = null
    }
    ,
    w.fx.speeds = {
        slow: 600,
        fast: 200,
        _default: 400
    },
    w.fn.delay = function(t, n) {
        return t = w.fx ? w.fx.speeds[t] || t : t,
        n = n || "fx",
        this.queue(n, function(n, r) {
            var i = e.setTimeout(n, t);
            r.stop = function() {
                e.clearTimeout(i)
            }
        })
    }
    ,
    function() {
        var e = r.createElement("input")
          , t = r.createElement("select").appendChild(r.createElement("option"));
        e.type = "checkbox",
        h.checkOn = "" !== e.value,
        h.optSelected = t.selected,
        (e = r.createElement("input")).value = "t",
        e.type = "radio",
        h.radioValue = "t" === e.value
    }();
    var dt, ht = w.expr.attrHandle;
    w.fn.extend({
        attr: function(e, t) {
            return z(this, w.attr, e, t, arguments.length > 1)
        },
        removeAttr: function(e) {
            return this.each(function() {
                w.removeAttr(this, e)
            })
        }
    }),
    w.extend({
        attr: function(e, t, n) {
            var r, i, o = e.nodeType;
            if (3 !== o && 8 !== o && 2 !== o)
                return "undefined" == typeof e.getAttribute ? w.prop(e, t, n) : (1 === o && w.isXMLDoc(e) || (i = w.attrHooks[t.toLowerCase()] || (w.expr.match.bool.test(t) ? dt : void 0)),
                void 0 !== n ? null === n ? void w.removeAttr(e, t) : i && "set"in i && void 0 !== (r = i.set(e, n, t)) ? r : (e.setAttribute(t, n + ""),
                n) : i && "get"in i && null !== (r = i.get(e, t)) ? r : null == (r = w.find.attr(e, t)) ? void 0 : r)
        },
        attrHooks: {
            type: {
                set: function(e, t) {
                    if (!h.radioValue && "radio" === t && N(e, "input")) {
                        var n = e.value;
                        return e.setAttribute("type", t),
                        n && (e.value = n),
                        t
                    }
                }
            }
        },
        removeAttr: function(e, t) {
            var n, r = 0, i = t && t.match(M);
            if (i && 1 === e.nodeType)
                while (n = i[r++])
                    e.removeAttribute(n)
        }
    }),
    dt = {
        set: function(e, t, n) {
            return !1 === t ? w.removeAttr(e, n) : e.setAttribute(n, n),
            n
        }
    },
    w.each(w.expr.match.bool.source.match(/\w+/g), function(e, t) {
        var n = ht[t] || w.find.attr;
        ht[t] = function(e, t, r) {
            var i, o, a = t.toLowerCase();
            return r || (o = ht[a],
            ht[a] = i,
            i = null != n(e, t, r) ? a : null,
            ht[a] = o),
            i
        }
    });
    var gt = /^(?:input|select|textarea|button)$/i
      , yt = /^(?:a|area)$/i;
    w.fn.extend({
        prop: function(e, t) {
            return z(this, w.prop, e, t, arguments.length > 1)
        },
        removeProp: function(e) {
            return this.each(function() {
                delete this[w.propFix[e] || e]
            })
        }
    }),
    w.extend({
        prop: function(e, t, n) {
            var r, i, o = e.nodeType;
            if (3 !== o && 8 !== o && 2 !== o)
                return 1 === o && w.isXMLDoc(e) || (t = w.propFix[t] || t,
                i = w.propHooks[t]),
                void 0 !== n ? i && "set"in i && void 0 !== (r = i.set(e, n, t)) ? r : e[t] = n : i && "get"in i && null !== (r = i.get(e, t)) ? r : e[t]
        },
        propHooks: {
            tabIndex: {
                get: function(e) {
                    var t = w.find.attr(e, "tabindex");
                    return t ? parseInt(t, 10) : gt.test(e.nodeName) || yt.test(e.nodeName) && e.href ? 0 : -1
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    }),
    h.optSelected || (w.propHooks.selected = {
        get: function(e) {
            var t = e.parentNode;
            return t && t.parentNode && t.parentNode.selectedIndex,
            null
        },
        set: function(e) {
            var t = e.parentNode;
            t && (t.selectedIndex,
            t.parentNode && t.parentNode.selectedIndex)
        }
    }),
    w.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
        w.propFix[this.toLowerCase()] = this
    });
    function vt(e) {
        return (e.match(M) || []).join(" ")
    }
    function mt(e) {
        return e.getAttribute && e.getAttribute("class") || ""
    }
    function xt(e) {
        return Array.isArray(e) ? e : "string" == typeof e ? e.match(M) || [] : []
    }
    w.fn.extend({
        addClass: function(e) {
            var t, n, r, i, o, a, s, u = 0;
            if (g(e))
                return this.each(function(t) {
                    w(this).addClass(e.call(this, t, mt(this)))
                });
            if ((t = xt(e)).length)
                while (n = this[u++])
                    if (i = mt(n),
                    r = 1 === n.nodeType && " " + vt(i) + " ") {
                        a = 0;
                        while (o = t[a++])
                            r.indexOf(" " + o + " ") < 0 && (r += o + " ");
                        i !== (s = vt(r)) && n.setAttribute("class", s)
                    }
            return this
        },
        removeClass: function(e) {
            var t, n, r, i, o, a, s, u = 0;
            if (g(e))
                return this.each(function(t) {
                    w(this).removeClass(e.call(this, t, mt(this)))
                });
            if (!arguments.length)
                return this.attr("class", "");
            if ((t = xt(e)).length)
                while (n = this[u++])
                    if (i = mt(n),
                    r = 1 === n.nodeType && " " + vt(i) + " ") {
                        a = 0;
                        while (o = t[a++])
                            while (r.indexOf(" " + o + " ") > -1)
                                r = r.replace(" " + o + " ", " ");
                        i !== (s = vt(r)) && n.setAttribute("class", s)
                    }
            return this
        },
        toggleClass: function(e, t) {
            var n = typeof e
              , r = "string" === n || Array.isArray(e);
            return "boolean" == typeof t && r ? t ? this.addClass(e) : this.removeClass(e) : g(e) ? this.each(function(n) {
                w(this).toggleClass(e.call(this, n, mt(this), t), t)
            }) : this.each(function() {
                var t, i, o, a;
                if (r) {
                    i = 0,
                    o = w(this),
                    a = xt(e);
                    while (t = a[i++])
                        o.hasClass(t) ? o.removeClass(t) : o.addClass(t)
                } else
                    void 0 !== e && "boolean" !== n || ((t = mt(this)) && J.set(this, "__className__", t),
                    this.setAttribute && this.setAttribute("class", t || !1 === e ? "" : J.get(this, "__className__") || ""))
            })
        },
        hasClass: function(e) {
            var t, n, r = 0;
            t = " " + e + " ";
            while (n = this[r++])
                if (1 === n.nodeType && (" " + vt(mt(n)) + " ").indexOf(t) > -1)
                    return !0;
            return !1
        }
    });
    var bt = /\r/g;
    w.fn.extend({
        val: function(e) {
            var t, n, r, i = this[0];
            {
                if (arguments.length)
                    return r = g(e),
                    this.each(function(n) {
                        var i;
                        1 === this.nodeType && (null == (i = r ? e.call(this, n, w(this).val()) : e) ? i = "" : "number" == typeof i ? i += "" : Array.isArray(i) && (i = w.map(i, function(e) {
                            return null == e ? "" : e + ""
                        })),
                        (t = w.valHooks[this.type] || w.valHooks[this.nodeName.toLowerCase()]) && "set"in t && void 0 !== t.set(this, i, "value") || (this.value = i))
                    });
                if (i)
                    return (t = w.valHooks[i.type] || w.valHooks[i.nodeName.toLowerCase()]) && "get"in t && void 0 !== (n = t.get(i, "value")) ? n : "string" == typeof (n = i.value) ? n.replace(bt, "") : null == n ? "" : n
            }
        }
    }),
    w.extend({
        valHooks: {
            option: {
                get: function(e) {
                    var t = w.find.attr(e, "value");
                    return null != t ? t : vt(w.text(e))
                }
            },
            select: {
                get: function(e) {
                    var t, n, r, i = e.options, o = e.selectedIndex, a = "select-one" === e.type, s = a ? null : [], u = a ? o + 1 : i.length;
                    for (r = o < 0 ? u : a ? o : 0; r < u; r++)
                        if (((n = i[r]).selected || r === o) && !n.disabled && (!n.parentNode.disabled || !N(n.parentNode, "optgroup"))) {
                            if (t = w(n).val(),
                            a)
                                return t;
                            s.push(t)
                        }
                    return s
                },
                set: function(e, t) {
                    var n, r, i = e.options, o = w.makeArray(t), a = i.length;
                    while (a--)
                        ((r = i[a]).selected = w.inArray(w.valHooks.option.get(r), o) > -1) && (n = !0);
                    return n || (e.selectedIndex = -1),
                    o
                }
            }
        }
    }),
    w.each(["radio", "checkbox"], function() {
        w.valHooks[this] = {
            set: function(e, t) {
                if (Array.isArray(t))
                    return e.checked = w.inArray(w(e).val(), t) > -1
            }
        },
        h.checkOn || (w.valHooks[this].get = function(e) {
            return null === e.getAttribute("value") ? "on" : e.value
        }
        )
    }),
    h.focusin = "onfocusin"in e;
    var wt = /^(?:focusinfocus|focusoutblur)$/
      , Tt = function(e) {
        e.stopPropagation()
    };
    w.extend(w.event, {
        trigger: function(t, n, i, o) {
            var a, s, u, l, c, p, d, h, v = [i || r], m = f.call(t, "type") ? t.type : t, x = f.call(t, "namespace") ? t.namespace.split(".") : [];
            if (s = h = u = i = i || r,
            3 !== i.nodeType && 8 !== i.nodeType && !wt.test(m + w.event.triggered) && (m.indexOf(".") > -1 && (m = (x = m.split(".")).shift(),
            x.sort()),
            c = m.indexOf(":") < 0 && "on" + m,
            t = t[w.expando] ? t : new w.Event(m,"object" == typeof t && t),
            t.isTrigger = o ? 2 : 3,
            t.namespace = x.join("."),
            t.rnamespace = t.namespace ? new RegExp("(^|\\.)" + x.join("\\.(?:.*\\.|)") + "(\\.|$)") : null,
            t.result = void 0,
            t.target || (t.target = i),
            n = null == n ? [t] : w.makeArray(n, [t]),
            d = w.event.special[m] || {},
            o || !d.trigger || !1 !== d.trigger.apply(i, n))) {
                if (!o && !d.noBubble && !y(i)) {
                    for (l = d.delegateType || m,
                    wt.test(l + m) || (s = s.parentNode); s; s = s.parentNode)
                        v.push(s),
                        u = s;
                    u === (i.ownerDocument || r) && v.push(u.defaultView || u.parentWindow || e)
                }
                a = 0;
                while ((s = v[a++]) && !t.isPropagationStopped())
                    h = s,
                    t.type = a > 1 ? l : d.bindType || m,
                    (p = (J.get(s, "events") || {})[t.type] && J.get(s, "handle")) && p.apply(s, n),
                    (p = c && s[c]) && p.apply && Y(s) && (t.result = p.apply(s, n),
                    !1 === t.result && t.preventDefault());
                return t.type = m,
                o || t.isDefaultPrevented() || d._default && !1 !== d._default.apply(v.pop(), n) || !Y(i) || c && g(i[m]) && !y(i) && ((u = i[c]) && (i[c] = null),
                w.event.triggered = m,
                t.isPropagationStopped() && h.addEventListener(m, Tt),
                i[m](),
                t.isPropagationStopped() && h.removeEventListener(m, Tt),
                w.event.triggered = void 0,
                u && (i[c] = u)),
                t.result
            }
        },
        simulate: function(e, t, n) {
            var r = w.extend(new w.Event, n, {
                type: e,
                isSimulated: !0
            });
            w.event.trigger(r, null, t)
        }
    }),
    w.fn.extend({
        trigger: function(e, t) {
            return this.each(function() {
                w.event.trigger(e, t, this)
            })
        },
        triggerHandler: function(e, t) {
            var n = this[0];
            if (n)
                return w.event.trigger(e, t, n, !0)
        }
    }),
    h.focusin || w.each({
        focus: "focusin",
        blur: "focusout"
    }, function(e, t) {
        var n = function(e) {
            w.event.simulate(t, e.target, w.event.fix(e))
        };
        w.event.special[t] = {
            setup: function() {
                var r = this.ownerDocument || this
                  , i = J.access(r, t);
                i || r.addEventListener(e, n, !0),
                J.access(r, t, (i || 0) + 1)
            },
            teardown: function() {
                var r = this.ownerDocument || this
                  , i = J.access(r, t) - 1;
                i ? J.access(r, t, i) : (r.removeEventListener(e, n, !0),
                J.remove(r, t))
            }
        }
    });
    var Ct = e.location
      , Et = Date.now()
      , kt = /\?/;
    w.parseXML = function(t) {
        var n;
        if (!t || "string" != typeof t)
            return null;
        try {
            n = (new e.DOMParser).parseFromString(t, "text/xml")
        } catch (e) {
            n = void 0
        }
        return n && !n.getElementsByTagName("parsererror").length || w.error("Invalid XML: " + t),
        n
    }
    ;
    var St = /\[\]$/
      , Dt = /\r?\n/g
      , Nt = /^(?:submit|button|image|reset|file)$/i
      , At = /^(?:input|select|textarea|keygen)/i;
    function jt(e, t, n, r) {
        var i;
        if (Array.isArray(t))
            w.each(t, function(t, i) {
                n || St.test(e) ? r(e, i) : jt(e + "[" + ("object" == typeof i && null != i ? t : "") + "]", i, n, r)
            });
        else if (n || "object" !== x(t))
            r(e, t);
        else
            for (i in t)
                jt(e + "[" + i + "]", t[i], n, r)
    }
    w.param = function(e, t) {
        var n, r = [], i = function(e, t) {
            var n = g(t) ? t() : t;
            r[r.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n)
        };
        if (Array.isArray(e) || e.jquery && !w.isPlainObject(e))
            w.each(e, function() {
                i(this.name, this.value)
            });
        else
            for (n in e)
                jt(n, e[n], t, i);
        return r.join("&")
    }
    ,
    w.fn.extend({
        serialize: function() {
            return w.param(this.serializeArray())
        },
        serializeArray: function() {
            return this.map(function() {
                var e = w.prop(this, "elements");
                return e ? w.makeArray(e) : this
            }).filter(function() {
                var e = this.type;
                return this.name && !w(this).is(":disabled") && At.test(this.nodeName) && !Nt.test(e) && (this.checked || !pe.test(e))
            }).map(function(e, t) {
                var n = w(this).val();
                return null == n ? null : Array.isArray(n) ? w.map(n, function(e) {
                    return {
                        name: t.name,
                        value: e.replace(Dt, "\r\n")
                    }
                }) : {
                    name: t.name,
                    value: n.replace(Dt, "\r\n")
                }
            }).get()
        }
    });
    var qt = /%20/g
      , Lt = /#.*$/
      , Ht = /([?&])_=[^&]*/
      , Ot = /^(.*?):[ \t]*([^\r\n]*)$/gm
      , Pt = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/
      , Mt = /^(?:GET|HEAD)$/
      , Rt = /^\/\//
      , It = {}
      , Wt = {}
      , $t = "*/".concat("*")
      , Bt = r.createElement("a");
    Bt.href = Ct.href;
    function Ft(e) {
        return function(t, n) {
            "string" != typeof t && (n = t,
            t = "*");
            var r, i = 0, o = t.toLowerCase().match(M) || [];
            if (g(n))
                while (r = o[i++])
                    "+" === r[0] ? (r = r.slice(1) || "*",
                    (e[r] = e[r] || []).unshift(n)) : (e[r] = e[r] || []).push(n)
        }
    }
    function _t(e, t, n, r) {
        var i = {}
          , o = e === Wt;
        function a(s) {
            var u;
            return i[s] = !0,
            w.each(e[s] || [], function(e, s) {
                var l = s(t, n, r);
                return "string" != typeof l || o || i[l] ? o ? !(u = l) : void 0 : (t.dataTypes.unshift(l),
                a(l),
                !1)
            }),
            u
        }
        return a(t.dataTypes[0]) || !i["*"] && a("*")
    }
    function zt(e, t) {
        var n, r, i = w.ajaxSettings.flatOptions || {};
        for (n in t)
            void 0 !== t[n] && ((i[n] ? e : r || (r = {}))[n] = t[n]);
        return r && w.extend(!0, e, r),
        e
    }
    function Xt(e, t, n) {
        var r, i, o, a, s = e.contents, u = e.dataTypes;
        while ("*" === u[0])
            u.shift(),
            void 0 === r && (r = e.mimeType || t.getResponseHeader("Content-Type"));
        if (r)
            for (i in s)
                if (s[i] && s[i].test(r)) {
                    u.unshift(i);
                    break
                }
        if (u[0]in n)
            o = u[0];
        else {
            for (i in n) {
                if (!u[0] || e.converters[i + " " + u[0]]) {
                    o = i;
                    break
                }
                a || (a = i)
            }
            o = o || a
        }
        if (o)
            return o !== u[0] && u.unshift(o),
            n[o]
    }
    function Ut(e, t, n, r) {
        var i, o, a, s, u, l = {}, c = e.dataTypes.slice();
        if (c[1])
            for (a in e.converters)
                l[a.toLowerCase()] = e.converters[a];
        o = c.shift();
        while (o)
            if (e.responseFields[o] && (n[e.responseFields[o]] = t),
            !u && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
            u = o,
            o = c.shift())
                if ("*" === o)
                    o = u;
                else if ("*" !== u && u !== o) {
                    if (!(a = l[u + " " + o] || l["* " + o]))
                        for (i in l)
                            if ((s = i.split(" "))[1] === o && (a = l[u + " " + s[0]] || l["* " + s[0]])) {
                                !0 === a ? a = l[i] : !0 !== l[i] && (o = s[0],
                                c.unshift(s[1]));
                                break
                            }
                    if (!0 !== a)
                        if (a && e["throws"])
                            t = a(t);
                        else
                            try {
                                t = a(t)
                            } catch (e) {
                                return {
                                    state: "parsererror",
                                    error: a ? e : "No conversion from " + u + " to " + o
                                }
                            }
                }
        return {
            state: "success",
            data: t
        }
    }
    w.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: Ct.href,
            type: "GET",
            isLocal: Pt.test(Ct.protocol),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": $t,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            converters: {
                "* text": String,
                "text html": !0,
                "text json": JSON.parse,
                "text xml": w.parseXML
            },
            flatOptions: {
                url: !0,
                context: !0
            }
        },
        ajaxSetup: function(e, t) {
            return t ? zt(zt(e, w.ajaxSettings), t) : zt(w.ajaxSettings, e)
        },
        ajaxPrefilter: Ft(It),
        ajaxTransport: Ft(Wt),
        ajax: function(t, n) {
            "object" == typeof t && (n = t,
            t = void 0),
            n = n || {};
            var i, o, a, s, u, l, c, f, p, d, h = w.ajaxSetup({}, n), g = h.context || h, y = h.context && (g.nodeType || g.jquery) ? w(g) : w.event, v = w.Deferred(), m = w.Callbacks("once memory"), x = h.statusCode || {}, b = {}, T = {}, C = "canceled", E = {
                readyState: 0,
                getResponseHeader: function(e) {
                    var t;
                    if (c) {
                        if (!s) {
                            s = {};
                            while (t = Ot.exec(a))
                                s[t[1].toLowerCase()] = t[2]
                        }
                        t = s[e.toLowerCase()]
                    }
                    return null == t ? null : t
                },
                getAllResponseHeaders: function() {
                    return c ? a : null
                },
                setRequestHeader: function(e, t) {
                    return null == c && (e = T[e.toLowerCase()] = T[e.toLowerCase()] || e,
                    b[e] = t),
                    this
                },
                overrideMimeType: function(e) {
                    return null == c && (h.mimeType = e),
                    this
                },
                statusCode: function(e) {
                    var t;
                    if (e)
                        if (c)
                            E.always(e[E.status]);
                        else
                            for (t in e)
                                x[t] = [x[t], e[t]];
                    return this
                },
                abort: function(e) {
                    var t = e || C;
                    return i && i.abort(t),
                    k(0, t),
                    this
                }
            };
            if (v.promise(E),
            h.url = ((t || h.url || Ct.href) + "").replace(Rt, Ct.protocol + "//"),
            h.type = n.method || n.type || h.method || h.type,
            h.dataTypes = (h.dataType || "*").toLowerCase().match(M) || [""],
            null == h.crossDomain) {
                l = r.createElement("a");
                try {
                    l.href = h.url,
                    l.href = l.href,
                    h.crossDomain = Bt.protocol + "//" + Bt.host != l.protocol + "//" + l.host
                } catch (e) {
                    h.crossDomain = !0
                }
            }
            if (h.data && h.processData && "string" != typeof h.data && (h.data = w.param(h.data, h.traditional)),
            _t(It, h, n, E),
            c)
                return E;
            (f = w.event && h.global) && 0 == w.active++ && w.event.trigger("ajaxStart"),
            h.type = h.type.toUpperCase(),
            h.hasContent = !Mt.test(h.type),
            o = h.url.replace(Lt, ""),
            h.hasContent ? h.data && h.processData && 0 === (h.contentType || "").indexOf("application/x-www-form-urlencoded") && (h.data = h.data.replace(qt, "+")) : (d = h.url.slice(o.length),
            h.data && (h.processData || "string" == typeof h.data) && (o += (kt.test(o) ? "&" : "?") + h.data,
            delete h.data),
            !1 === h.cache && (o = o.replace(Ht, "$1"),
            d = (kt.test(o) ? "&" : "?") + "_=" + Et++ + d),
            h.url = o + d),
            h.ifModified && (w.lastModified[o] && E.setRequestHeader("If-Modified-Since", w.lastModified[o]),
            w.etag[o] && E.setRequestHeader("If-None-Match", w.etag[o])),
            (h.data && h.hasContent && !1 !== h.contentType || n.contentType) && E.setRequestHeader("Content-Type", h.contentType),
            E.setRequestHeader("Accept", h.dataTypes[0] && h.accepts[h.dataTypes[0]] ? h.accepts[h.dataTypes[0]] + ("*" !== h.dataTypes[0] ? ", " + $t + "; q=0.01" : "") : h.accepts["*"]);
            for (p in h.headers)
                E.setRequestHeader(p, h.headers[p]);
            if (h.beforeSend && (!1 === h.beforeSend.call(g, E, h) || c))
                return E.abort();
            if (C = "abort",
            m.add(h.complete),
            E.done(h.success),
            E.fail(h.error),
            i = _t(Wt, h, n, E)) {
                if (E.readyState = 1,
                f && y.trigger("ajaxSend", [E, h]),
                c)
                    return E;
                h.async && h.timeout > 0 && (u = e.setTimeout(function() {
                    E.abort("timeout")
                }, h.timeout));
                try {
                    c = !1,
                    i.send(b, k)
                } catch (e) {
                    if (c)
                        throw e;
                    k(-1, e)
                }
            } else
                k(-1, "No Transport");
            function k(t, n, r, s) {
                var l, p, d, b, T, C = n;
                c || (c = !0,
                u && e.clearTimeout(u),
                i = void 0,
                a = s || "",
                E.readyState = t > 0 ? 4 : 0,
                l = t >= 200 && t < 300 || 304 === t,
                r && (b = Xt(h, E, r)),
                b = Ut(h, b, E, l),
                l ? (h.ifModified && ((T = E.getResponseHeader("Last-Modified")) && (w.lastModified[o] = T),
                (T = E.getResponseHeader("etag")) && (w.etag[o] = T)),
                204 === t || "HEAD" === h.type ? C = "nocontent" : 304 === t ? C = "notmodified" : (C = b.state,
                p = b.data,
                l = !(d = b.error))) : (d = C,
                !t && C || (C = "error",
                t < 0 && (t = 0))),
                E.status = t,
                E.statusText = (n || C) + "",
                l ? v.resolveWith(g, [p, C, E]) : v.rejectWith(g, [E, C, d]),
                E.statusCode(x),
                x = void 0,
                f && y.trigger(l ? "ajaxSuccess" : "ajaxError", [E, h, l ? p : d]),
                m.fireWith(g, [E, C]),
                f && (y.trigger("ajaxComplete", [E, h]),
                --w.active || w.event.trigger("ajaxStop")))
            }
            return E
        },
        getJSON: function(e, t, n) {
            return w.get(e, t, n, "json")
        },
        getScript: function(e, t) {
            return w.get(e, void 0, t, "script")
        }
    }),
    w.each(["get", "post"], function(e, t) {
        w[t] = function(e, n, r, i) {
            return g(n) && (i = i || r,
            r = n,
            n = void 0),
            w.ajax(w.extend({
                url: e,
                type: t,
                dataType: i,
                data: n,
                success: r
            }, w.isPlainObject(e) && e))
        }
    }),
    w._evalUrl = function(e) {
        return w.ajax({
            url: e,
            type: "GET",
            dataType: "script",
            cache: !0,
            async: !1,
            global: !1,
            "throws": !0
        })
    }
    ,
    w.fn.extend({
        wrapAll: function(e) {
            var t;
            return this[0] && (g(e) && (e = e.call(this[0])),
            t = w(e, this[0].ownerDocument).eq(0).clone(!0),
            this[0].parentNode && t.insertBefore(this[0]),
            t.map(function() {
                var e = this;
                while (e.firstElementChild)
                    e = e.firstElementChild;
                return e
            }).append(this)),
            this
        },
        wrapInner: function(e) {
            return g(e) ? this.each(function(t) {
                w(this).wrapInner(e.call(this, t))
            }) : this.each(function() {
                var t = w(this)
                  , n = t.contents();
                n.length ? n.wrapAll(e) : t.append(e)
            })
        },
        wrap: function(e) {
            var t = g(e);
            return this.each(function(n) {
                w(this).wrapAll(t ? e.call(this, n) : e)
            })
        },
        unwrap: function(e) {
            return this.parent(e).not("body").each(function() {
                w(this).replaceWith(this.childNodes)
            }),
            this
        }
    }),
    w.expr.pseudos.hidden = function(e) {
        return !w.expr.pseudos.visible(e)
    }
    ,
    w.expr.pseudos.visible = function(e) {
        return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length)
    }
    ,
    w.ajaxSettings.xhr = function() {
        try {
            return new e.XMLHttpRequest
        } catch (e) {}
    }
    ;
    var Vt = {
        0: 200,
        1223: 204
    }
      , Gt = w.ajaxSettings.xhr();
    h.cors = !!Gt && "withCredentials"in Gt,
    h.ajax = Gt = !!Gt,
    w.ajaxTransport(function(t) {
        var n, r;
        if (h.cors || Gt && !t.crossDomain)
            return {
                send: function(i, o) {
                    var a, s = t.xhr();
                    if (s.open(t.type, t.url, t.async, t.username, t.password),
                    t.xhrFields)
                        for (a in t.xhrFields)
                            s[a] = t.xhrFields[a];
                    t.mimeType && s.overrideMimeType && s.overrideMimeType(t.mimeType),
                    t.crossDomain || i["X-Requested-With"] || (i["X-Requested-With"] = "XMLHttpRequest");
                    for (a in i)
                        s.setRequestHeader(a, i[a]);
                    n = function(e) {
                        return function() {
                            n && (n = r = s.onload = s.onerror = s.onabort = s.ontimeout = s.onreadystatechange = null,
                            "abort" === e ? s.abort() : "error" === e ? "number" != typeof s.status ? o(0, "error") : o(s.status, s.statusText) : o(Vt[s.status] || s.status, s.statusText, "text" !== (s.responseType || "text") || "string" != typeof s.responseText ? {
                                binary: s.response
                            } : {
                                text: s.responseText
                            }, s.getAllResponseHeaders()))
                        }
                    }
                    ,
                    s.onload = n(),
                    r = s.onerror = s.ontimeout = n("error"),
                    void 0 !== s.onabort ? s.onabort = r : s.onreadystatechange = function() {
                        4 === s.readyState && e.setTimeout(function() {
                            n && r()
                        })
                    }
                    ,
                    n = n("abort");
                    try {
                        s.send(t.hasContent && t.data || null)
                    } catch (e) {
                        if (n)
                            throw e
                    }
                },
                abort: function() {
                    n && n()
                }
            }
    }),
    w.ajaxPrefilter(function(e) {
        e.crossDomain && (e.contents.script = !1)
    }),
    w.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(e) {
                return w.globalEval(e),
                e
            }
        }
    }),
    w.ajaxPrefilter("script", function(e) {
        void 0 === e.cache && (e.cache = !1),
        e.crossDomain && (e.type = "GET")
    }),
    w.ajaxTransport("script", function(e) {
        if (e.crossDomain) {
            var t, n;
            return {
                send: function(i, o) {
                    t = w("<script>").prop({
                        charset: e.scriptCharset,
                        src: e.url
                    }).on("load error", n = function(e) {
                        t.remove(),
                        n = null,
                        e && o("error" === e.type ? 404 : 200, e.type)
                    }
                    ),
                    r.head.appendChild(t[0])
                },
                abort: function() {
                    n && n()
                }
            }
        }
    });
    var Yt = []
      , Qt = /(=)\?(?=&|$)|\?\?/;
    w.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var e = Yt.pop() || w.expando + "_" + Et++;
            return this[e] = !0,
            e
        }
    }),
    w.ajaxPrefilter("json jsonp", function(t, n, r) {
        var i, o, a, s = !1 !== t.jsonp && (Qt.test(t.url) ? "url" : "string" == typeof t.data && 0 === (t.contentType || "").indexOf("application/x-www-form-urlencoded") && Qt.test(t.data) && "data");
        if (s || "jsonp" === t.dataTypes[0])
            return i = t.jsonpCallback = g(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback,
            s ? t[s] = t[s].replace(Qt, "$1" + i) : !1 !== t.jsonp && (t.url += (kt.test(t.url) ? "&" : "?") + t.jsonp + "=" + i),
            t.converters["script json"] = function() {
                return a || w.error(i + " was not called"),
                a[0]
            }
            ,
            t.dataTypes[0] = "json",
            o = e[i],
            e[i] = function() {
                a = arguments
            }
            ,
            r.always(function() {
                void 0 === o ? w(e).removeProp(i) : e[i] = o,
                t[i] && (t.jsonpCallback = n.jsonpCallback,
                Yt.push(i)),
                a && g(o) && o(a[0]),
                a = o = void 0
            }),
            "script"
    }),
    h.createHTMLDocument = function() {
        var e = r.implementation.createHTMLDocument("").body;
        return e.innerHTML = "<form></form><form></form>",
        2 === e.childNodes.length
    }(),
    w.parseHTML = function(e, t, n) {
        if ("string" != typeof e)
            return [];
        "boolean" == typeof t && (n = t,
        t = !1);
        var i, o, a;
        return t || (h.createHTMLDocument ? ((i = (t = r.implementation.createHTMLDocument("")).createElement("base")).href = r.location.href,
        t.head.appendChild(i)) : t = r),
        o = A.exec(e),
        a = !n && [],
        o ? [t.createElement(o[1])] : (o = xe([e], t, a),
        a && a.length && w(a).remove(),
        w.merge([], o.childNodes))
    }
    ,
    w.fn.load = function(e, t, n) {
        var r, i, o, a = this, s = e.indexOf(" ");
        return s > -1 && (r = vt(e.slice(s)),
        e = e.slice(0, s)),
        g(t) ? (n = t,
        t = void 0) : t && "object" == typeof t && (i = "POST"),
        a.length > 0 && w.ajax({
            url: e,
            type: i || "GET",
            dataType: "html",
            data: t
        }).done(function(e) {
            o = arguments,
            a.html(r ? w("<div>").append(w.parseHTML(e)).find(r) : e)
        }).always(n && function(e, t) {
            a.each(function() {
                n.apply(this, o || [e.responseText, t, e])
            })
        }
        ),
        this
    }
    ,
    w.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(e, t) {
        w.fn[t] = function(e) {
            return this.on(t, e)
        }
    }),
    w.expr.pseudos.animated = function(e) {
        return w.grep(w.timers, function(t) {
            return e === t.elem
        }).length
    }
    ,
    w.offset = {
        setOffset: function(e, t, n) {
            var r, i, o, a, s, u, l, c = w.css(e, "position"), f = w(e), p = {};
            "static" === c && (e.style.position = "relative"),
            s = f.offset(),
            o = w.css(e, "top"),
            u = w.css(e, "left"),
            (l = ("absolute" === c || "fixed" === c) && (o + u).indexOf("auto") > -1) ? (a = (r = f.position()).top,
            i = r.left) : (a = parseFloat(o) || 0,
            i = parseFloat(u) || 0),
            g(t) && (t = t.call(e, n, w.extend({}, s))),
            null != t.top && (p.top = t.top - s.top + a),
            null != t.left && (p.left = t.left - s.left + i),
            "using"in t ? t.using.call(e, p) : f.css(p)
        }
    },
    w.fn.extend({
        offset: function(e) {
            if (arguments.length)
                return void 0 === e ? this : this.each(function(t) {
                    w.offset.setOffset(this, e, t)
                });
            var t, n, r = this[0];
            if (r)
                return r.getClientRects().length ? (t = r.getBoundingClientRect(),
                n = r.ownerDocument.defaultView,
                {
                    top: t.top + n.pageYOffset,
                    left: t.left + n.pageXOffset
                }) : {
                    top: 0,
                    left: 0
                }
        },
        position: function() {
            if (this[0]) {
                var e, t, n, r = this[0], i = {
                    top: 0,
                    left: 0
                };
                if ("fixed" === w.css(r, "position"))
                    t = r.getBoundingClientRect();
                else {
                    t = this.offset(),
                    n = r.ownerDocument,
                    e = r.offsetParent || n.documentElement;
                    while (e && (e === n.body || e === n.documentElement) && "static" === w.css(e, "position"))
                        e = e.parentNode;
                    e && e !== r && 1 === e.nodeType && ((i = w(e).offset()).top += w.css(e, "borderTopWidth", !0),
                    i.left += w.css(e, "borderLeftWidth", !0))
                }
                return {
                    top: t.top - i.top - w.css(r, "marginTop", !0),
                    left: t.left - i.left - w.css(r, "marginLeft", !0)
                }
            }
        },
        offsetParent: function() {
            return this.map(function() {
                var e = this.offsetParent;
                while (e && "static" === w.css(e, "position"))
                    e = e.offsetParent;
                return e || be
            })
        }
    }),
    w.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(e, t) {
        var n = "pageYOffset" === t;
        w.fn[e] = function(r) {
            return z(this, function(e, r, i) {
                var o;
                if (y(e) ? o = e : 9 === e.nodeType && (o = e.defaultView),
                void 0 === i)
                    return o ? o[t] : e[r];
                o ? o.scrollTo(n ? o.pageXOffset : i, n ? i : o.pageYOffset) : e[r] = i
            }, e, r, arguments.length)
        }
    }),
    w.each(["top", "left"], function(e, t) {
        w.cssHooks[t] = _e(h.pixelPosition, function(e, n) {
            if (n)
                return n = Fe(e, t),
                We.test(n) ? w(e).position()[t] + "px" : n
        })
    }),
    w.each({
        Height: "height",
        Width: "width"
    }, function(e, t) {
        w.each({
            padding: "inner" + e,
            content: t,
            "": "outer" + e
        }, function(n, r) {
            w.fn[r] = function(i, o) {
                var a = arguments.length && (n || "boolean" != typeof i)
                  , s = n || (!0 === i || !0 === o ? "margin" : "border");
                return z(this, function(t, n, i) {
                    var o;
                    return y(t) ? 0 === r.indexOf("outer") ? t["inner" + e] : t.document.documentElement["client" + e] : 9 === t.nodeType ? (o = t.documentElement,
                    Math.max(t.body["scroll" + e], o["scroll" + e], t.body["offset" + e], o["offset" + e], o["client" + e])) : void 0 === i ? w.css(t, n, s) : w.style(t, n, i, s)
                }, t, a ? i : void 0, a)
            }
        })
    }),
    w.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(e, t) {
        w.fn[t] = function(e, n) {
            return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t)
        }
    }),
    w.fn.extend({
        hover: function(e, t) {
            return this.mouseenter(e).mouseleave(t || e)
        }
    }),
    w.fn.extend({
        bind: function(e, t, n) {
            return this.on(e, null, t, n)
        },
        unbind: function(e, t) {
            return this.off(e, null, t)
        },
        delegate: function(e, t, n, r) {
            return this.on(t, e, n, r)
        },
        undelegate: function(e, t, n) {
            return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n)
        }
    }),
    w.proxy = function(e, t) {
        var n, r, i;
        if ("string" == typeof t && (n = e[t],
        t = e,
        e = n),
        g(e))
            return r = o.call(arguments, 2),
            i = function() {
                return e.apply(t || this, r.concat(o.call(arguments)))
            }
            ,
            i.guid = e.guid = e.guid || w.guid++,
            i
    }
    ,
    w.holdReady = function(e) {
        e ? w.readyWait++ : w.ready(!0)
    }
    ,
    w.isArray = Array.isArray,
    w.parseJSON = JSON.parse,
    w.nodeName = N,
    w.isFunction = g,
    w.isWindow = y,
    w.camelCase = G,
    w.type = x,
    w.now = Date.now,
    w.isNumeric = function(e) {
        var t = w.type(e);
        return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e))
    }
    ,
    "function" == typeof define && define.amd && define("jquery", [], function() {
        return w
    });
    var Jt = e.jQuery
      , Kt = e.$;
    return w.noConflict = function(t) {
        return e.$ === w && (e.$ = Kt),
        t && e.jQuery === w && (e.jQuery = Jt),
        w
    }
    ,
    t || (e.jQuery = e.$ = w),
    w
});

/*============================================================================
  Global - header
==============================================================================*/

var header = {
    init: function() {
        //remove duplicate header on update
        if ($('.mobile-header').length > 1) {
            var nav_menu = $("#nav").data("mmenu");
            nav_menu.close();
            $('.mobile-header:last, #nav:last').remove();
        }
        if ($('.header').length > 1) {
            $('.header.mm-slideout').remove();
        }

        //offscreen check for dropdown menu
        $('.sub-menu').on('mouseenter', function() {

            if ($(this).find('.submenu_list').is(':off-right')) {
                $(this).find('.dropdown').addClass('dropdown-left');
            }
        });

        //Promo banner
        if ($('.promo_banner').length) {

            var promo_banner = $.cookie('promo_banner');
            var promo_banner_height = $('.promo_banner').outerHeight();

            if (promo_banner != 'dismiss') {
                $('body').addClass('promo_banner--true');

                if ($('.promo_banner_mobile').is(':hidden') && $('.header--content-behind').length) {
                    $('.promo_banner--true').css('padding-top', promo_banner_height + 'px');
                }

                $('.promo_banner .icon-close, .promo_banner_mobile .icon-close').on('click', function() {
                    $('.promo_banner--true').attr('style', '');
                    $('body').removeClass('promo_banner--true');
                    $.cookie('promo_banner', 'dismiss', {
                        path: '/'
                    }, {
                        expires: 30
                    });
                    banner.init();
                });
            }
        }

        $('#nav').mmenu({
            searchfield: {
                add: $('#header').data('search-enabled'),
                search: false,
                placeholder: "Search"
            },
            navbars: [{
                "position": "top",
                "content": ["searchfield"]
            }, {
                "position": "top"
            }, {
                "position": "bottom",
                "content": [$(".js-social-icons").html()]
            }],
            "extensions": ["theme-white"],
            offCanvas: {
                pageSelector: "#content_wrapper"
            }
        }, {
            clone: false,
            searchfield: {
                "form": {
                    "action": "/search"
                },
                "input": {
                    "name": "q"
                }
            }
        });

        $('#nav .mm-search').append('<input type="hidden" name="type" value="product" />');

        if ($('.mobile-header:hidden') && $('.default-header').hasClass('behind-menu--true')) {
            $('.default-header').parent('.header-section').addClass('header--content-behind');
        }

        var $header = $(".header");

        if ($('.default-header').hasClass('mm-fixed-top')) {
            $(window).on("scroll", function() {
                if (!$('html').hasClass('mm-opened')) {
                    if ($header.hasClass('behind-menu--true') && $('.banner-section.wide_display--true').length && $('.transparent-header--true').length) {
                        $header.toggleClass('header_bar', $(window).scrollTop() > 0);
                    }

                    if ($header.hasClass('behind-menu--true') && $('.draggable-banner--true').children().first().find('.wide_display--true').length && $('.transparent-header--true').length) {
                        $header.toggleClass('header_bar', $(window).scrollTop() > 0);
                    }

                }
            });

            //offset scroll position
            if ($('.default-header').hasClass('mm-fixed-top')) {
                $('#menu li a[href^="#"], .flex-caption a[href^="#"]').on('click', function(e) {
                    e.preventDefault()
                    var anchorLink = $(this).attr('href');
                    var headerHeight = $('.header').outerHeight();
                    $('html, body').animate({
                        scrollTop: $(anchorLink).offset().top - headerHeight
                    }, 2000);
                });
            }
        }
        ;
        $('#cart').mmenu({
            navbar: {
                add: false
            },
            offCanvas: {
                position: 'right',
                pageSelector: "#content_wrapper"
            },
            "extensions": ["theme-white"]
        });
        $('.icon-cart, .icon-menu').on("click", function(e) {
            $('#search').hide();
        });

        $(".icon-search").on('click', function(e) {
            $(this).parent('form').submit();
        });

        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && $(window).width() >= 798) {
            $(document).on('click', '.menu li.sub-menu > a', function(e) {
                var $dropdownUrl = $(this).attr('href');
                //console.log($(this));
                if ($(this).hasClass('click-active')) {
                    window.location.href = $dropdownUrl
                    $('.mobile_hidden ul li a').removeClass('click-active');
                } else {
                    $('.mobile_hidden ul li a').removeClass('click-active');
                    $(this).addClass('click-active');
                    console.log($('.click-active'));
                }
                e.preventDefault();
                return false;
            });
        }

        $('body').on('mouseover', '.sub-menu', function() {
            $(this).attr('aria-expanded', true);
        });
        $('body').on('mouseout', '.sub-menu', function() {
            $(this).attr('aria-expanded', false);
        });

        banner.init();
    },
    unload: function($target) {
        $('a[href^="#"]').off('click');
    }
}

/*============================================================================
  FAQ
==============================================================================*/
var faqAccordion = {
    init: function() {
        var flg = 0;
        var $faqHeading = $('.faqAccordion > dt > button');
        $('.faqAccordion > dd').attr('aria-hidden', true);
        $faqHeading.attr('aria-expanded', false);
        $faqHeading.on('click activate', function() {
            if (flg)
                return false;
            flg = 1;
            var state = $(this).attr('aria-expanded') === 'false' ? true : false;
            $(this).attr('aria-expanded', state);
            $(this).parent().next().slideToggle(function() {
                flg = 0;
            });
            $(this).parent().next().attr('aria-hidden', !state);
            return false;
        });
        $faqHeading.on('keydown', function(event) {
            var keyCode = event.keyCode || e.which;
            if (keyCode === 13) {
                $(this).trigger('activate');
            }
        });
    }
}

/*============================================================================
  All pages - banners
==============================================================================*/

var banner = {
    init: function() {

        if ($(window).width() >= 798) {

            if ($('[data-secondary-logo]').length) {
                $('.header .logo').addClass('secondary-logo--true');
                var totalHeaderHeight = $('.header').outerHeight();
            } else {
                $('.header .logo').addClass('secondary-logo--false');
                var totalHeaderHeight = $('.header').outerHeight();
            }
        }

        // Add space for header so banner images display directly below
        if ($('.behind-menu--false').length && $('.banner-section.wide_display--true').length) {
            $('.shadow-header').css('height', totalHeaderHeight);
        }

        //Pages without banner images display the default header style
        if ($('.banner-section.wide_display--true').length == 0 && $('.draggable-banner--true').length == 0) {
            $('.header').addClass('header_bar');
        }

        //Page.details and index templates - possible for wide-display banner to be top section
        if ($('.behind-menu--false').length && $('.draggable-banner--true').children().first().find('.wide_display--true').length) {
            $('.shadow-header').css('height', totalHeaderHeight);
            if ($(window).width() < 798) {
                $('.draggable-banner--true').children().first().addClass('main_content_area');
            }
        } else if ($('.draggable-banner--true').children().first().find('.wide_display--true').length == 0) {
            $('.draggable-banner--true').children().first().addClass('main_content_area');
            $('.draggable-banner--true').parents('body').find('.header').addClass('header_bar');
            if ($(window).width() < 798) {
                $('.draggable-banner--true').parents('body').find('.header').addClass('header_bar');
            }
        }

    },
    unload: function($target) {
        if ($('.banner-section.wide_display--true').length == 0 && $('.draggable-banner--true').length == 0) {
            $('.header').removeClass('header_bar');
        }

        $('.banner-section').attr('style', '');
        $('.shadow-header').attr('style', '');
        $('.draggable-banner--true').children().removeClass('main_content_area');
    }
}

/*============================================================================
  Home page - slideshow
==============================================================================*/

var slideshow = {
    init: function() {
        $('.homepage_slider').each(function(index, value) {
            var homepageSlider = $(this);
            var slideshowAnimation = homepageSlider.data('slideshow-animation');
            var slideshowSpeed = homepageSlider.data('slideshow-speed');
            homepageSlider.flexslider({
                touch: true,
                controlNav: true,
                animation: slideshowAnimation,
                slideshowSpeed: slideshowSpeed ? slideshowSpeed * 1000 : 10 * 1000,
                fadeFirstSlide: false
            });

            if ($('.slides li', homepageSlider).length == 1) {
                $('.flex-direction-nav', homepageSlider).hide();
            }
            ;

        });

    },
    unload: function($target) {
        var slider = $target.find('.homepage_slider');
        destroySlider(slider);
    }
}

/*============================================================================
  Home page - video
==============================================================================*/

//check to see if HTML5 video is supported
var supports_video = function() {
    return !!document.createElement('video').canPlayType;
}

var homepageVideo = {
    unload: function($target) {
        $target.find('[data-play-video]').off('click');
    },
    getVideoDetails: function(settings) {
        var videoDetails = {
            id: settings.header.attr('data-video-src'),
            aspectRatio: settings.header.attr('data-aspect-ratio').split(":"),
            provider: settings.header.attr('data-provider'),
            videoMP4: settings.header.attr('data-video-mp4'),
            videoOGV: settings.header.attr('data-video-ogv')
        }
        return videoDetails;
    },
    createFrame: function(settings, videoDetails) {

        if (videoDetails.provider === 'youtube') {
            if (settings.autoloop) {
                var autoloop = '1&iv_load_policy=3&playlist=' + videoDetails.id;
            } else {
                var autoloop = 0;
            }

            var html = '<iframe src="//www.youtube.com/embed/' + videoDetails.id + '?&autoplay=1&loop=' + autoloop + '&rel=0&hd=1&showinfo=0&color=white&controls=0" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>';
        } else if (videoDetails.provider === 'vimeo') {
            if (settings.autoloop) {
                var autoloop = 1;
            } else {
                var autoloop = 0;
            }
            var html = '<iframe src="//player.vimeo.com/video/' + videoDetails.id + '?loop=' + autoloop + '&amp;title=0&amp;byline=0&amp;portrait=0&amp;color=3d96d2&autoplay=1" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>';
        } else if (videoDetails.provider === 'html5') {
            if (settings.autoloop) {
                var autoloop = 'loop="loop"';
            }

            var html = '<video autoplay="true" ' + autoloop + ' id="video"><source src="' + videoDetails.videoMP4 + '" type="video/mp4"><source src="' + videoDetails.videoOGV + '" type="video/ogg" ></video>';
        } else if (videoDetails.provider === 'empty') {
            if (settings.autoloop) {
                var autoloop = '1&iv_load_policy=3&playlist=' + '_9VUPq3SxOc';
            } else {
                var autoloop = 0;
            }

            var html = '<iframe src="//www.youtube.com/embed/' + '_9VUPq3SxOc' + '?&autoplay=1&loop=' + autoloop + '&rel=0&hd=1&showinfo=0&color=white&controls=0" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>';
        }
        return html;
    },
    appendFrame: function(settings, videoDetails) {
        var addVideo = function() {
            //only add video if there are no videos already in the section
            if (settings.container.find('.mediaWrapper').length < 1 && settings.container.find('#video').length < 1) {
                settings.container.find('.js-append-video').append(homepageVideo.createFrame(settings, videoDetails));
            }

            if (videoDetails.provider != 'html5') {
                settings.container.find('iframe').mediaWrapper({
                    intrinsic: false,
                    baseWidth: videoDetails.aspectRatio[0],
                    baseHeight: videoDetails.aspectRatio[1]
                });
            }
        }

        if (!homepageVideo.isMobile()) {
            addVideo();
            var mediaWrapper = settings.container.find('.mediaWrapper');
            settings.container.height(mediaWrapper.outerHeight());
            settings.posterImage.addClass('fadeOut animated');

            if (settings.bannerVideoText) {
                settings.videoText.addClass('text-on-video');
            } else {
                settings.videoText.hide();
            }

            settings.header.next().fadeIn('slow');
            if (videoDetails.provider != 'html5') {
                mediaWrapper.find('iframe').show();
            } else {
                settings.header.next().show();
                settings.container.find('.homepage-video__placeholder').hide();
                settings.container.find('.homepage-video__image').hide();
            }

            settings.videoTrigger.removeAttr('data-play-video');

        }
    },
    isMobile: function() {
        return false;
        //initiate as false
        // device detection
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4)))
            return true;
    }
}

var video = {
    init: function() {

        //Check for videos that are set to autoplay
        $('.homepage-video').each(function(index, value) {
            if ($('.homepage-video').length && supports_video()) {

                var $videoElement = $(this);
                var settings = {
                    container: $videoElement,
                    header: $videoElement.find('.homepage-video--media'),
                    posterImage: $videoElement.find('.homepage-video img[data-play-video]'),
                    videoText: $videoElement.find('.homepage-video--media .caption'),
                    videoTrigger: $videoElement.find("[data-play-video]"),
                    autoPlayVideo: $videoElement.data('autoplay'),
                    bannerVideoText: $videoElement.data('video-text'),
                    autoloop: $videoElement.data('autoloop')
                }
                var videoDetails = homepageVideo.getVideoDetails(settings);

                if (settings.autoPlayVideo && !homepageVideo.isMobile()) {
                    homepageVideo.appendFrame(settings, videoDetails);
                }

            }
        });

        //Attach event listener for videos
        $(document).on('click', '[data-play-video]', function(e) {
            var $videoElement = $(this).parents('.homepage-video');
            var settings = {
                container: $videoElement,
                header: $videoElement.find('.homepage-video--media'),
                posterImage: $videoElement.find('.homepage-video img[data-play-video]'),
                videoText: $videoElement.find('.homepage-video--media .caption'),
                videoTrigger: $videoElement.find("[data-play-video]"),
                autoPlayVideo: $videoElement.data('autoplay'),
                bannerVideoText: $videoElement.data('video-text'),
                autoloop: $videoElement.data('autoloop')
            }
            var videoDetails = homepageVideo.getVideoDetails(settings);

            homepageVideo.appendFrame(settings, videoDetails);
        });
    }
}

/*============================================================================
  Home page - testimonials
==============================================================================*/

var testimonials = {
    init: function() {
        $('.testimonial_slider').each(function(index, value) {
            var testimonialSlider = $(this);

            testimonialSlider.flexslider({
                touch: true,
                animation: 'slide',
                slideshowSpeed: 10 * 1000,
                fadeFirstSlide: false
            });
        });

    },
    unload: function($target) {
        var slider = $target.find('.testimonial_slider');
        destroySlider(slider);
    }
}

/*============================================================================
  Home page - social media
==============================================================================*/

var social = {
    twitter: function() {
        if (window.twttr) {
            window.twttr.ready(function(twttr) {
                twttr.widgets.load();
            });
        }
    },
    unload: function() {
    }
}

/*============================================================================
  Product
==============================================================================*/

var product = {
    init: function() {
        var $productSection = $('.product_slider').parents('.product_section');
        var thumbnailPosition = $productSection.data('thumbnail');
        var slideshowAnimation = $productSection.data('slideshow-animation');
        var slideshowSpeed = $productSection.data('slideshow-speed');
        var $notify_form = $('.notify_form .contact-form');

        if (slideshowAnimation == 'zoom') {
            $('.image__container img', $productSection).wrap('<div></div>').parent().append('<div class="transition-helper"></div>').zoom({
                magnify: 1
            });
        }

        var slider = $('.product_slider').flexslider({
            startAt: parseInt($('.featured_image', $(this)).data('index'), 10),
            touch: true,
            pauseOnHover: true,
            controlNav: thumbnailPosition == "no-thumbnails" ? false : "thumbnails",
            directionNav: thumbnailPosition == "no-thumbnails" ? true : false,
            animation: slideshowAnimation == 'none' || slideshowAnimation == 'zoom' ? 'fade' : slideshowAnimation,
            slideshow: slideshowAnimation == 'none' || slideshowAnimation == 'zoom' ? false : true,
            slideshowSpeed: slideshowSpeed ? slideshowSpeed * 1000 : 10 * 1000,
            start: function(slider) {
                slider.resize();
            },
            after: function(slider) {
                var sliderHeight = $(slider).find('.slides > li.flex-active-slide').height();
                $(slider).find('ul.slides').css({
                    'height': sliderHeight
                });
            }
        });

        if ($('.slides li:not(.clone)', $productSection).length == 1) {
            $('.flex-direction-nav', slider).hide();
        }

        $('.product_form.product_form_options.init').each(function() {
            new Shopify.OptionSelectors($(this).data("select-id"),{
                product: $(this).data("product"),
                onVariantSelected: selectCallback,
                enableHistoryState: $(this).data("enable-state")
            });
        });

        $notify_form.each(function() {
            var $nf = $(this);
            $nf.on("submit", function(e) {
                if ($('input[name="challenge"]', $nf).val() !== "true") {
                    $.ajax({
                        type: $nf.attr('method'),
                        url: $nf.attr('action'),
                        data: $nf.serialize(),
                        success: function(data) {
                            $nf.fadeOut("slow", function() {
                                $nf.prev('.message').html("Thanks! We will notify you when this product becomes available!");
                            });
                        },
                        error: function(data) {
                            $('input[name="challenge"]', $nf).val('true');
                            $nf.submit();
                        }
                    });
                    e.preventDefault();
                }
            });
        });

        $('.product_form').addClass('is-visible');
        $('.swatch :radio').change(function() {
            var optionIndex = $(this).closest('.swatch').attr('data-option-index');
            var optionValue = $(this).val();
            $(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');

        });

    },
    unload: function($target) {
        var slider = $target.find('.product_slider');
        destroySlider(slider);
    }
}

/*============================================================================
  Collection
==============================================================================*/

var collection = {
    init: function() {

        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            $(".quick_shop").remove();
        } else {
            $('.thumbnail').hover(function() {
                $(this).find('.quick_shop').show();

                if ($(this).find('.secondary').length) {
                    var imgHeights = $(this).find('.product_image img').map(function() {
                        return $(this).outerHeight(true);
                    }).get();

                    var maxHeight = Math.max.apply(null, imgHeights);

                    $(this).addClass('swap');
                    $(this).find('.product_image').css('height', maxHeight);
                }

            }, function() {
                $(this).find('.quick_shop').hide();

                if ($(this).find('.secondary').length) {
                    $(this).removeClass('swap');
                    $(this).find('.product_image').css('height', 'auto');
                }
            })

            var modal_width = '860px';
            if ($(window).width() >= 1200 || $('html').hasClass('ie')) {
                modal_width = '1080px'
            }
            $(".quick_shop").fancybox({
                width: modal_width,
                height: 'auto',
                autoSize: false,
                padding: [20, 20, 20, 20],
                afterShow: function(e) {
                    var selector = $('.fancybox-opened').find('.selector-wrapper select');
                    selector.trigger('change');
                },
                beforeShow: function(e) {
                    var $gallery = $('.' + $(this.element).data('gallery'));
                    var $productSection = $gallery.parents('.product_section');
                    var $product = $(this.element).data("fancybox-href");
                    var thumbnailPosition = $productSection.data('thumbnail');
                    var slideshowAnimation = $productSection.data('slideshow-animation');
                    var slideshowSpeed = $productSection.data('slideshow-speed');

                    $gallery.flexslider({
                        startAt: parseInt($('.featured_image', $(this)).data('index'), 10),
                        touch: true,
                        pauseOnHover: true,
                        controlNav: thumbnailPosition == "no-thumbnails" ? false : "thumbnails",
                        directionNav: thumbnailPosition == "no-thumbnails" ? true : false,
                        animation: slideshowAnimation == 'none' || slideshowAnimation == 'zoom' ? 'fade' : slideshowAnimation,
                        slideshow: slideshowAnimation == 'none' || slideshowAnimation == 'zoom' ? false : true,
                        slideshowSpeed: slideshowSpeed ? slideshowSpeed * 1000 : 10 * 1000,
                        start: function(slider) {
                            slider.resize();
                        }
                    });

                    if ($('.slides li:not(.clone)', $productSection).length == 1) {
                        $('.flex-direction-nav', $gallery).hide();
                    }

                    if (slideshowAnimation == 'zoom') {
                        $('.image__container img', $productSection).wrap('<div></div>').parent().zoom({
                            magnify: 1
                        });
                    }

                }
            });
        }

        $('#sort-by').val($('#sort-by').data('default-sort'));

        $('body').on('change', '#tag_filter, #sort-by', function() {
            var sortValue = $('#sort-by').val();
            var filterValue = $('#tag_filter').val();

            Shopify.queryParams.sort_by = sortValue;
            sortUrl = $.param(Shopify.queryParams);

            if (sortValue && filterValue) {
                window.location = filterValue + '?sort_by=' + sortValue;
            } else if (sortValue && !filterValue) {
                window.location = '?' + sortUrl;
            } else if (!sortValue && filterValue) {
                window.location = filterValue;
            }
        });
    },
    unload: function($target) {
        $target.find('.thumbnail').off('mouseenter mouseleave');
        $('body').off('change', '#tag_filter, #sort-by');
        $target.find('.quick_shop').unbind('click.fb');
    }
}

/*============================================================================
  Page Banner Template
==============================================================================*/

var pageBanner = {
    init: function() {
        $('.banner-flexslider').flexslider({
            touch: false,
            controlNav: false,
            directionNav: false,
            animation: "fade"
        });
    },
    unload: function($target) {
        var slider = $target.find('.banner-flexslider');
        destroySlider(slider);
    }
}

/*============================================================================
  Map
==============================================================================*/

var map = {
    init: function() {
        if ($(".map-section .map, .contact-template-section .map, .page-details-section .map, .product-details-section .map").hasClass('js-api-map')) {
            var mapsToLoad = [];

            //Create map settings array
            $('.map').each(function(i, obj) {
                mapsToLoad.push(this);
                mapsToLoad[i].sectionid = $(this).data('id');
                mapsToLoad[i].address = $(this).data('address');
                mapsToLoad[i].directions = $(this).data('directions-address');
                mapsToLoad[i].zoom = $(this).data('zoom');
                mapsToLoad[i].mapstyle = $(this).data('style');
                mapsToLoad[i].showpin = $(this).data('pin');
                mapsToLoad[i].apikey = $(this).data('api-key');
            });

            $.each(mapsToLoad, function(i, instance) {

                //Enable caching to avoid duplicate google maps files
                $.ajaxSetup({
                    cache: true
                });

                //Load maps script and find location coordinates
                $.getScript('https://maps.googleapis.com/maps/api/js?key=' + mapsToLoad[i].apikey).then(function() {
                    map.findLocation(mapsToLoad[i]);
                    $.ajaxSetup({
                        cache: false
                    });
                });
            });
        }
    },

    findLocation: function(mapArray) {
        var geoLat;
        var geoLng;
        var geocoder = new google.maps.Geocoder();

        //Find and set coordinates
        geocoder.geocode({
            'address': mapArray.address
        }, function(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {

                geoLat = results[0].geometry.location.lat();
                geoLng = results[0].geometry.location.lng();

                //Create map
                map.initMap(geoLat, geoLng, mapArray);

            }
        });
    },

    initMap: function(lat, lng, mapArray) {

        var location = {
            lat: lat,
            lng: lng
        };
        var styleJson = [];

        //Set style JSON
        if (mapArray.mapstyle == 'aubergine') {
            styleJson = [{
                "elementType": "geometry",
                "stylers": [{
                    "color": "#1d2c4d"
                }]
            }, {
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#8ec3b9"
                }]
            }, {
                "elementType": "labels.text.stroke",
                "stylers": [{
                    "color": "#1a3646"
                }]
            }, {
                "featureType": "administrative.country",
                "elementType": "geometry.stroke",
                "stylers": [{
                    "color": "#4b6878"
                }]
            }, {
                "featureType": "administrative.land_parcel",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#64779e"
                }]
            }, {
                "featureType": "administrative.province",
                "elementType": "geometry.stroke",
                "stylers": [{
                    "color": "#4b6878"
                }]
            }, {
                "featureType": "landscape.man_made",
                "elementType": "geometry.stroke",
                "stylers": [{
                    "color": "#334e87"
                }]
            }, {
                "featureType": "landscape.natural",
                "elementType": "geometry",
                "stylers": [{
                    "color": "#023e58"
                }]
            }, {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [{
                    "color": "#283d6a"
                }]
            }, {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#6f9ba5"
                }]
            }, {
                "featureType": "poi",
                "elementType": "labels.text.stroke",
                "stylers": [{
                    "color": "#1d2c4d"
                }]
            }, {
                "featureType": "poi.park",
                "elementType": "geometry.fill",
                "stylers": [{
                    "color": "#023e58"
                }]
            }, {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#3C7680"
                }]
            }, {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [{
                    "color": "#304a7d"
                }]
            }, {
                "featureType": "road",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#98a5be"
                }]
            }, {
                "featureType": "road",
                "elementType": "labels.text.stroke",
                "stylers": [{
                    "color": "#1d2c4d"
                }]
            }, {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [{
                    "color": "#2c6675"
                }]
            }, {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [{
                    "color": "#255763"
                }]
            }, {
                "featureType": "road.highway",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#b0d5ce"
                }]
            }, {
                "featureType": "road.highway",
                "elementType": "labels.text.stroke",
                "stylers": [{
                    "color": "#023e58"
                }]
            }, {
                "featureType": "transit",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#98a5be"
                }]
            }, {
                "featureType": "transit",
                "elementType": "labels.text.stroke",
                "stylers": [{
                    "color": "#1d2c4d"
                }]
            }, {
                "featureType": "transit.line",
                "elementType": "geometry.fill",
                "stylers": [{
                    "color": "#283d6a"
                }]
            }, {
                "featureType": "transit.station",
                "elementType": "geometry",
                "stylers": [{
                    "color": "#3a4762"
                }]
            }, {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [{
                    "color": "#0e1626"
                }]
            }, {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#4e6d70"
                }]
            }];
        } else if (mapArray.mapstyle == 'retro') {
            styleJson = [{
                "elementType": "geometry",
                "stylers": [{
                    "color": "#ebe3cd"
                }]
            }, {
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#523735"
                }]
            }, {
                "elementType": "labels.text.stroke",
                "stylers": [{
                    "color": "#f5f1e6"
                }]
            }, {
                "featureType": "administrative",
                "elementType": "geometry.stroke",
                "stylers": [{
                    "color": "#c9b2a6"
                }]
            }, {
                "featureType": "administrative.land_parcel",
                "elementType": "geometry.stroke",
                "stylers": [{
                    "color": "#dcd2be"
                }]
            }, {
                "featureType": "administrative.land_parcel",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#ae9e90"
                }]
            }, {
                "featureType": "landscape.natural",
                "elementType": "geometry",
                "stylers": [{
                    "color": "#dfd2ae"
                }]
            }, {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [{
                    "color": "#dfd2ae"
                }]
            }, {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#93817c"
                }]
            }, {
                "featureType": "poi.park",
                "elementType": "geometry.fill",
                "stylers": [{
                    "color": "#a5b076"
                }]
            }, {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#447530"
                }]
            }, {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [{
                    "color": "#f5f1e6"
                }]
            }, {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [{
                    "color": "#fdfcf8"
                }]
            }, {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [{
                    "color": "#f8c967"
                }]
            }, {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [{
                    "color": "#e9bc62"
                }]
            }, {
                "featureType": "road.highway.controlled_access",
                "elementType": "geometry",
                "stylers": [{
                    "color": "#e98d58"
                }]
            }, {
                "featureType": "road.highway.controlled_access",
                "elementType": "geometry.stroke",
                "stylers": [{
                    "color": "#db8555"
                }]
            }, {
                "featureType": "road.local",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#806b63"
                }]
            }, {
                "featureType": "transit.line",
                "elementType": "geometry",
                "stylers": [{
                    "color": "#dfd2ae"
                }]
            }, {
                "featureType": "transit.line",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#8f7d77"
                }]
            }, {
                "featureType": "transit.line",
                "elementType": "labels.text.stroke",
                "stylers": [{
                    "color": "#ebe3cd"
                }]
            }, {
                "featureType": "transit.station",
                "elementType": "geometry",
                "stylers": [{
                    "color": "#dfd2ae"
                }]
            }, {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [{
                    "color": "#b9d3c2"
                }]
            }, {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#92998d"
                }]
            }];
        } else if (mapArray.mapstyle == 'silver') {
            styleJson = [{
                "elementType": "geometry",
                "stylers": [{
                    "color": "#f5f5f5"
                }]
            }, {
                "elementType": "labels.icon",
                "stylers": [{
                    "visibility": "off"
                }]
            }, {
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#616161"
                }]
            }, {
                "elementType": "labels.text.stroke",
                "stylers": [{
                    "color": "#f5f5f5"
                }]
            }, {
                "featureType": "administrative.land_parcel",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#bdbdbd"
                }]
            }, {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [{
                    "color": "#eeeeee"
                }]
            }, {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#757575"
                }]
            }, {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [{
                    "color": "#e5e5e5"
                }]
            }, {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#9e9e9e"
                }]
            }, {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [{
                    "color": "#ffffff"
                }]
            }, {
                "featureType": "road.arterial",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#757575"
                }]
            }, {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [{
                    "color": "#dadada"
                }]
            }, {
                "featureType": "road.highway",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#616161"
                }]
            }, {
                "featureType": "road.local",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#9e9e9e"
                }]
            }, {
                "featureType": "transit.line",
                "elementType": "geometry",
                "stylers": [{
                    "color": "#e5e5e5"
                }]
            }, {
                "featureType": "transit.station",
                "elementType": "geometry",
                "stylers": [{
                    "color": "#eeeeee"
                }]
            }, {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [{
                    "color": "#c9c9c9"
                }]
            }, {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#9e9e9e"
                }]
            }];
        } else if (mapArray.mapstyle == 'night') {
            styleJson = [{
                "elementType": "geometry",
                "stylers": [{
                    "color": "#242f3e"
                }]
            }, {
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#746855"
                }]
            }, {
                "elementType": "labels.text.stroke",
                "stylers": [{
                    "color": "#242f3e"
                }]
            }, {
                "featureType": "administrative.locality",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#d59563"
                }]
            }, {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#d59563"
                }]
            }, {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [{
                    "color": "#263c3f"
                }]
            }, {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#6b9a76"
                }]
            }, {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [{
                    "color": "#38414e"
                }]
            }, {
                "featureType": "road",
                "elementType": "geometry.stroke",
                "stylers": [{
                    "color": "#212a37"
                }]
            }, {
                "featureType": "road",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#9ca5b3"
                }]
            }, {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [{
                    "color": "#746855"
                }]
            }, {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [{
                    "color": "#1f2835"
                }]
            }, {
                "featureType": "road.highway",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#f3d19c"
                }]
            }, {
                "featureType": "transit",
                "elementType": "geometry",
                "stylers": [{
                    "color": "#2f3948"
                }]
            }, {
                "featureType": "transit.station",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#d59563"
                }]
            }, {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [{
                    "color": "#17263c"
                }]
            }, {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#515c6d"
                }]
            }, {
                "featureType": "water",
                "elementType": "labels.text.stroke",
                "stylers": [{
                    "color": "#17263c"
                }]
            }];
        } else {
            styleJson = [];
        }

        //Create google maps link
        $('.js-map-link').attr('href', 'https://www.google.com/maps/place/' + mapArray.directions + '/@' + lat + ',' + lng);

        //Set map options
        var mapOptions = {
            zoom: mapArray.zoom,
            center: location,
            styles: styleJson,
            disableDefaultUI: false
        };

        //Create map
        var map = new google.maps.Map(document.getElementById(mapArray.sectionid),mapOptions);

        //Show pin
        if (mapArray.showpin == true) {
            var marker = new google.maps.Marker({
                position: location,
                map: map
            });
        }
    }
}

/*============================================================================
  Product form
==============================================================================*/

// var productFormListeners = {
//     init: function() {
//         $(document).on("click", ".minus", function(e) {
//             var quantity = parseInt($(this).next("input").val());
//             quantity -= 50;
//             $(this).next("input").val(quantity);
//             if (quantity == 0) {
//                 $(this).closest('li.cart_item').slideUp("fast");
//                 var itemToRemove = $(this).next().data('id');
//                 $('.item--' + itemToRemove).remove();
//                 var cartItem = $(this).closest(".cart_item");
//                 setTimeout(function() {
//                     cartItem.remove();
//                     if (jQuery(".mm-panel .cart_item").length < 1) {
//                         ajaxSubmitCart();
//                     }
//                 }, 300);
//             }
//             $(this).next("input").trigger('change');
//             e.stopPropagation();
//             e.preventDefault();
//             return false;
//         });

//         $(document).on("click", ".plus", function(e) {
//             var quantity = parseInt($(this).prev("input").val());
//             quantity += 50;
//             $(this).prev("input").val(quantity).trigger('change');

//             e.stopPropagation();
//             e.preventDefault();
//             return false;
//         });

//         /*    $(document).on("change", "#cart_form input[type='number']", function() {
//       $("#cart_form").submit();
//     }).delay(200); */

//         if ($('.tos_agree').length) {
//             $('body').on('click', 'input[type="submit"]', function() {
//                 if ($(this).parents('form').find('.tos_agree').length) {
//                     if (!$(this).parents('form').find('.tos_agree').is(':checked')) {
//                         alert("You must agree with the Terms of Use to checkout.");
//                         return false;
//                     } 
//                 }

//                 if ($(".finish_option_checkbox input[type=\"checkbox\"]:checked").length > 0) {
//                     if ($(".custom_finish_type_content input[type=\"radio\"]:checked").length == 0) {
//                         alert("You must select the Finish Type to checkout.");
//                         return false;
//                     }

//                     if ($(".custom_finish_graphics_content").find("[class^='custom_']").length == 0) {
//                         alert("You must select the Finish Graphics to checkout.");
//                         return false;
//                     }
//                 }

//                 $(this).submit();
//             });
//         }
//     },
//     unload: function() {
//     }
// }

var productFormListeners = {
    init: function() {
        // Quantity minus button
        $(document).on("click", ".minus", function(e) {
            var $input = $(this).next("input");
            var quantity = parseInt($input.val()) || 0;
            quantity -= 50;
            $input.val(quantity);

            if (quantity <= 0) {
                var $cartItem = $(this).closest('li.cart_item');
                var itemToRemove = $input.data('id');

                $('.item--' + itemToRemove).remove();

                $cartItem.slideUp("fast");
                setTimeout(function() {
                    $cartItem.remove();
                    if ($(".mm-panel .cart_item").length < 1) {
                        ajaxSubmitCart();
                    }
                }, 300);
            }

            $input.trigger('change');
            e.stopPropagation();
            e.preventDefault();
            return false;
        });

        // Quantity plus button
        $(document).on("click", ".plus", function(e) {
            var $input = $(this).prev("input");
            var quantity = parseInt($input.val()) || 0;
            quantity += 50;
            $input.val(quantity).trigger('change');

            e.stopPropagation();
            e.preventDefault();
            return false;
        });

        // Disable sticker inputs if sticker section does not exist
        if ($('.sticker-extras-content').length === 0) {
            $('.custom_finish_type_content input[type="radio"]').prop('checked', false).prop('disabled', true).removeAttr('name');
            $('.custom_finish_graphics_content input[type="checkbox"]').prop('checked', false).prop('disabled', true).removeAttr('name');
        } else {
            // Enable inputs if sticker exists and restore name attributes
            $('.custom_finish_type_content input[type="radio"]').prop('disabled', false).attr('name','attributes[Finish]');
            $('.custom_finish_graphics_content input[type="checkbox"]').prop('disabled', false).each(function(index){
                var originalName = 'attributes[Finish Graphics ' + (index+1) + ']';
                $(this).attr('name', originalName);
            });
        }

        // Checkout / Submit validation
        $('body').on('click', 'input[type="submit"]', function(e) {
            var form = $(this).parents('form');

            // TOS validation
            if (form.find('.tos_agree').length && !form.find('.tos_agree').is(':checked')) {
                alert("You must agree with the Terms of Use to checkout.");
                return false;
            }

            // Sticker extras validation (only if sticker section exists)
            if ($('.sticker-extras-content').length) {
                // Finish Type
                var finishTypeRadios = $('.custom_finish_type_content input[type="radio"]:enabled');
                if (finishTypeRadios.length > 0 && finishTypeRadios.filter(':checked').length === 0) {
                    alert("You must select the Finish Type to checkout.");
                    return false;
                }

                // Finish Graphics
                var finishGraphicsCheckboxes = $('.custom_finish_graphics_content input[type="checkbox"]:enabled');
                if (finishGraphicsCheckboxes.length > 0 && finishGraphicsCheckboxes.filter(':checked').length === 0) {
                    alert("You must select at least one Finish Graphics to checkout.");
                    return false;
                }   
            }

            // Everything is fine, allow submission
            return true;
        });
    },

    unload: function() {
        // Cleanup if needed
    }
};

/*============================================================================
  Cart
==============================================================================*/

var ajaxCart = {
    init: function() {
    $('body').on('submit', '.product_form form', function(e) {
      e.preventDefault();
      var $addToCartForm = $(this);
      var $addToCartBtn = $addToCartForm.find('.add_to_cart');
  
      // Initialize an empty array to store variant IDs and names
      var variantsData = [];
  
      // For each <option> in the <select> element (the different variant options)
      $addToCartForm.find('select[name="id"] option').each(function() {
          var variantId = $(this).val();  // This is the variant ID (e.g., 46246802784426)
          var variantName = $(this).text();  // This is the variant name (e.g., "Small", "Large")
  
          // Push the variant data into the variantsData array
          variantsData.push({
              id: variantId,
              name: variantName
          });
      });
  
      // Initialize an empty object for the line item properties
      var lineItemProperties = {};
  
      // Loop through the variantsData array and add the data to lineItemProperties
      variantsData.forEach(function(variant) {
          lineItemProperties['Variant ID ' + variant.name] = variant.id;
          lineItemProperties['Variant Name ' + variant.name] = variant.name;
      });
  
      // Append the variant information to the form data as properties
      var formData = $addToCartForm.serialize() + '&' + $.param({ properties: lineItemProperties });
  
      $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          cache: false,
          type: 'post',
          data: formData,  // Include the variant information in the request
          beforeSend: function() {
              $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
              $addToCartBtn.find('span').removeClass("zoomIn").addClass('animated zoomOut');
          },
          success: function(itemData) {
            console.log('app1');
              $addToCartBtn.find('span').text("Added").removeClass('zoomOut').addClass('fadeIn');
  
              window.setTimeout(function() {
                  $addToCartBtn.removeAttr('disabled').removeClass('disabled');
                  $addToCartBtn.find('span').addClass("fadeOut").text($addToCartBtn.data('label')).removeClass('fadeIn').removeClass("fadeOut").addClass('zoomIn');
              }, 1000);
  
              $.ajax({
                  url: '/cart.js',
                  dataType: "json",
                  cache: false,
                  success: function(cart) {
                      refreshCart(cart);
                      window.setTimeout(function() {
                          $.fancybox.close();
                          $('.cart-button').click();
                      }, 500);
                  }
              });
          },
          error: function(XMLHttpRequest) {
              var response = eval('(' + XMLHttpRequest.responseText + ')');
              response = response.description;
              $('.warning').remove();
  
              var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
              $addToCartForm.after(warning);
              $addToCartBtn.removeAttr('disabled').removeClass('disabled');
              $addToCartBtn.find('span').text("Add to Cart").removeClass('zoomOut').addClass('zoomIn');
          }
      });
  
      return false;
  });




    },
    unload: function() {
    }
}

/*============================================================================
  Utils
==============================================================================*/
var utils = {
    initializeTabs: function() {
        var tabs = $('ul.tabs');
        tabs.each(function(i) {
            var tab = $(this).find('> li > a');
            tab.on('click', function(e) {
                var contentLocation = $(this).attr('href');
                if (contentLocation.charAt(0) == "#") {
                    e.preventDefault();
                    tab.removeClass('active');
                    $(this).addClass('active');
                    $(this).parents('ul.tabs').next().find(contentLocation).show().css({
                        'display': 'block'
                    }).addClass('active').siblings().hide().removeClass('active');
                }
            });
        });
    },
    initializeAccordions: function() {
        var allPanels = $('.accordion > dd');

        for (i = 0; i < allPanels.length; i++) {
            $(allPanels[i]).css('height', $(allPanels[i]).outerHeight());
        }

        allPanels.hide();

        $('.accordion > dt > a').on('click', function() {
            if (!$(this).parent().next().is(":visible")) {
                allPanels.slideUp();
                $(this).parent().next().slideDown();
                $('.accordion small.right').html('&#9668;');
                $(this).find('small.right').html('&#9660;');
            }
            return false;
        });
        $($('.accordion dd')[0]).show();
    },
    unload: function($target) {
        $('ul.tabs > li > a').off('click');
        $('.accordion > dt > a').off('click');
    }
}

var toggleSidebarBlocks = function($toggle) {
    if ($toggle.next('ul').is(':visible')) {
        $toggle.next('ul').slideUp();
        $toggle.children('span').html('+');
        $toggle.attr('aria-expanded', false);
    } else {
        $toggle.next('ul').slideDown();
        $toggle.children('span').html('-');
        $toggle.attr('aria-expanded', true);
    }
}

var toggleSidebarMenus = function($toggle) {
    var $menu = $toggle.parent('li');
    var $toggleIcon = $menu.children('.menu-toggle');

    $menu.toggleClass('submenu--active');

    var iconType = $menu.hasClass('submenu--active') ? '-' : '+';
    $toggleIcon.html(iconType);

    $menu.children('ul').slideToggle();
    $toggleIcon.attr('aria-expanded', $toggleIcon.attr('aria-expanded') == 'true' ? 'false' : 'true');

}

var sliderBlock = {
    select: function(blockId, $parentSection) {
        var $blocks = $parentSection.find('li[data-block-id]:not(".clone")');
        var blockIdsArray = $blocks.map(function() {
            return String($(this).data('block-id'));
        });

        var slider = $parentSection.find('.flexslider').data('flexslider');

        slider.pause();

        for (var i = 0; i < blockIdsArray.length; i++) {
            if (blockIdsArray[i] === blockId) {
                var currentSlide = i;
                if (currentSlide !== slider.currentSlide) {
                    slider.flexAnimate(parseInt(currentSlide));
                }
            }
        }
    },
    deselect: function($parentSection) {
        var slider = $parentSection.find('.flexslider').data('flexslider');
        if (slider) {
            slider.play();
        }
    }
}

//Document ready
$(function() {

    window.lazySizesConfig = window.lazySizesConfig || {};
    window.lazySizesConfig.expand = 1500;
    window.lazySizesConfig.loadMode = 1;

    //Load sections
    slideshow.init();
    header.init();
    map.init();
    testimonials.init();
    product.init();
    faqAccordion.init();
    collection.init();
    productFormListeners.init();
    video.init();
    banner.init();

    //Sidebar toggle
    $(document).on('click', '.menu-toggle, .parent-link--false', function(e) {
        toggleSidebarMenus($(this));
    });

    var sidebarTouched = false;
    $(document).on('touchstart', '.toggle', function(e) {
        if ($(window).width() <= 798 || $(this).parents('.sidebar').hasClass('toggle-all--true')) {
            var $toggle = $(this);
            toggleSidebarBlocks($toggle);
            sidebarTouched = true;
            e.preventDefault();
            return false;
        }
    });
    $(document).on('click', '.toggle', function(e) {
        if ($(window).width() <= 798 || $(this).parents('.sidebar').hasClass('toggle-all--true')) {
            var $toggle = $(this);
            if (!sidebarTouched) {
                toggleSidebarBlocks($toggle);
                e.preventDefault();
                return false;
            }
        }
    });

    if ($('.header-section .logo-below').length > 0) {
        $('#content .index-sections').removeClass('adjust-header');
    } else {
        $('#content .index-sections').addClass('adjust-header');
    }

    // Load Accordions
    utils.initializeAccordions();

    // Load Tabs
    utils.initializeTabs();

    $('.slider').flexslider({
        touch: false,
        directionNav: false,
        controlNav: false,
        animation: "fade",
        fadeFirstSlide: false
    });

    $('.slider-no-nav').flexslider({
        touch: false,
        controlNav: false,
        directionNav: false,
        animation: "fade",
        fadeFirstSlide: false
    });

    $('.slider-no-nav-quick').flexslider({
        touch: false,
        controlNav: false,
        directionNav: false,
        animation: "fade",
        slideshowSpeed: 4000,
        fadeFirstSlide: false
    });

    $("body").on("click", '.continue', function() {

        var cart = $("#cart").data("mmenu");
        cart.close();

        var nav = $("#nav").data("mmenu");
        nav.close();

    });

    $("body").on("click", '#search-toggle, .search-close', function(e) {
        $('.search-close').css('padding-top', $('.header').height() + 100 + 'px')
        if ($('#search').is(":visible") && $(window).scrollTop() == 0) {
            $(".index .header").removeClass('header_bar');
            $('.index .header .logo img').attr('src', $('.logo img').data('src-home'));
        } else {
            $(".index .header").addClass('header_bar');
            $('.index .header .logo img').attr('src', $('.logo img').data('src'));
        }

        $('#search').fadeToggle('fast').find('input').focus();
        e.stopPropagation();
        e.preventDefault();
    });

    if ($('.flexslider img').length == 1) {
        $('.flexslider .flex-direction-nav').hide()
    }
    $(".search-submit").on('click', function(e) {
        $(this).parent('form').submit();
    });
    $('.lightbox').fancybox();

    if ($(window).width() >= 959) {

        var modal_width = '860px';

        $('.thumbnail').hover(function() {
            $('.quick_shop', this).show();
        }, function() {
            $('.quick_shop', this).hide();
        })

        if ($(window).width() >= 1200 || $('html').hasClass('ie')) {
            modal_width = '1100px'
        }
    }

    $(".fancybox").fancybox({
        padding: 0,
        wrapCSS: 'gallery'
    });

    $('#tag_filter').change(function() {
        window.location = $('#tag_filter option:selected').val();
    });

    Shopify.queryParams = {};
    if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
            aKeyValue = aCouples[i].split('=');
            if (aKeyValue.length > 1) {
                Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
            }
        }
    }

    if ($('.shopify-section.page-details-section, .product_gallery').length) {// Don't apply mediaWrapper
    } else if ($('body').hasClass('index')) {
        $('.featured-products-section iframe[src*=youtube], .featured-products-section iframe[src*=vimeo]').mediaWrapper({
            intrinsic: true
        });
    } else {
        $('iframe[src*=youtube]:not(.shogun-video-embed), iframe[src*=vimeo]:not(.shogun-video-embed)').mediaWrapper({
            intrinsic: true
        });
    }
    var $contact_form = $('.newsletter .contact-form');
    $contact_form.each(function() {
        var $cf = $(this);
        $cf.on('submit', function(e) {
            if ($('input[name="challenge"]', $cf).val() !== "true") {
                $.ajax({
                    type: $cf.attr('method'),
                    url: $cf.attr('action'),
                    data: $cf.serialize(),
                    success: function(data) {
                        $cf.fadeOut("slow", function() {
                            $cf.prev('.message').html("Thank you for joining our mailing list!");
                        });
                    },
                    error: function(data) {
                        $('input[name="challenge"]', $cf).val('true');
                        $cf.submit();
                    }
                });
                e.preventDefault();
            }
        });
    });

    $('.swatch :radio').change(function() {
        var optionIndex = $(this).closest('.swatch').attr('data-option-index');
        var optionValue = $(this).val();
        $(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
    });

    $('.maps').on('click', function() {
        $('.maps iframe').css("pointer-events", "auto");
    });

    /*============================================================================
    Home page - social media
  ==============================================================================*/

    //Initialize twitter feed
    window.twttr = (function(d, s, id) {
        var t, js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id))
            return;
        js = d.createElement(s);
        js.id = id;
        js.src = "https://platform.twitter.com/widgets.js";
        fjs.parentNode.insertBefore(js, fjs);
        return window.twttr || (t = {
            _e: [],
            ready: function(f) {
                t._e.push(f)
            }
        });
    }(document, "script", "twitter-wjs"));

    $('.twitter-feed-wrap').each(function(index, value) {
        social.twitter();
    });

    $('.instagram-feed-wrap').each(function(index, value) {
        var $target = $(this).find(".js-instafeed");
        instagram.loadContent({
            el: $target,
            clientID: $target.data('client-id'),
            limit: $target.data('count')
        });
    });

    $('body').on("change", "#cart input.quantity:not(.custom-quantity)", function() {
        var qty = $(this).val();
        window.lastClickTime = (new Date()).getTime();
        ajaxUpdateCart($(this).data('key'), qty, window.lastClickTime);
    });

    $('body').on("change", "#cart #cart-note", function() {
        ajaxSubmitCart();
    });

    ajaxCart.init();

});

/*============================================================================
  Start of cart-related functionality
==============================================================================*/
function ajaxSubmitCart(refresh=true) {
    $cart = $("#cart");
    $.ajax({
        url: '/cart/update.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $cart.serialize(),
        success: function(data) {
            if (refresh) {
                $.ajax({
                    url: '/cart.js',
                    dataType: "json",
                    cache: false,
                    success: function(cart) {
                        refreshCart(cart);
                    }
                });
            }
        }
    });
}
/**------------------------------------------------------------------------------------------------ */
/**
 * Refreshes main cart qty once cart changes are done.
 */

function ajaxUpdateCart(key, quantity, currentClickTime, notes) {
    var data = {
        quantity: quantity,
        id: key
    };
    if (notes) {
        data.properties = {
            "Notes for our Design Team": notes
        };
    }
    $.ajax({
        url: '/cart/change.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: data,
        success: function(data) {
            if (currentClickTime >= window.lastClickTime) {
                $.ajax({
                    url: '/cart.js',
                    dataType: "json",
                    cache: false,
                    success: function(cart) {
                        refreshCart(cart);
                    }
                });

            }

        }
    });
}

/**
   * Adds &shy to the long words so that they dont break the UI(without messing up urls, emojis and tags). And truncates the large paragraphs.
   */

function pleaseBeShyWords(target, breakLen=10, textLimit=100, ellipsis=true) {
    target.each((idx,el)=>{
        var text = jQuery(el).html();
        if (text.length < breakLen) {
            return;
        }

        if (text.length > textLimit && ellipsis) {
            text = text.slice(0, textLimit) + '...';
        }
        text = text.replace(new RegExp('(?![^\\s]{0,' + breakLen + '}([[:^print:]]))(?![^<>]*target="_blank")([^\\s]{' + breakLen + '})(?=[^\\s])(?![a-z\/]{0,10}\>)','g'), "$2" + "&shy;");

        jQuery(el).html(text);
    }
    );
}

function refreshCart(cart, options={
    dispatchCartEvent: true
}) {

    // Bold:Subs
    if(typeof window.BOLD !== 'undefined'
    && typeof window.BOLD.common !== 'undefined'
    && typeof window.BOLD.common.cartDoctor !== 'undefined') {
      // NOTE: "cart" should be the variable containing the cart json data
      cart = window.BOLD.common.cartDoctor.fix(cart);
    }
    // Bold:Subs

    $cartBtn = $(".icon-cart:not(.counter-hidden)");
    if ($cartBtn) {
        var $cartCount = $cartBtn.find('.cart_count');
        var $mobileCartCount = $('.mobile-header .icon-cart span');
        var value = $cartCount.text() || '0';
        var cart_items_html = "";
        var $cart = $("#cart ul");

        var real_cart_item_count = cart.item_count;
        cart.items.forEach(function(item) {
            if (item.product_id === 7814742507690) {
                real_cart_item_count -= item.quantity;
            }
        });
        
        if ($cartCount && $cartCount.length && $($mobileCartCount).is(":hidden")) {
            $cartCount.text(value.replace(/[0-9]+/, real_cart_item_count));
        } else if ($($mobileCartCount).is(":visible")) {
            $mobileCartCount.text(value.replace(/[0-9]+/, real_cart_item_count));
        } else {
            $cartBtn.children('.cart_count').remove();
            $cartBtn.prepend('<div class="cart_count">' + real_cart_item_count + '</div>');
        }

        $cart.find('li:not(:first)').remove();

        if (cart.item_count == 0) {
            $cart.append('<li class="mm-label empty_cart"><a href="/cart">Your Cart is Empty</a></li>');
            $cartCount.remove();
        } else {
            $('.action_button.edit_cart').remove();
            cart_items_html += '<li class="proceed-to-checkout">' + '<a href="/cart" class="action_button edit_cart right slideout-checkout">Proceed to Checkout</a>' + '</li>';
        
            $.each(cart.items, function(index, item) {
              
              if (item.product_id !== 7814742507690) {
                  var line_id = index + 1;
                  cart_items_html += '<li class="cart_item">' + 
                      '<span class="icon-close remove_cart_item"></span>' + 
                      '<p class="mm-counter quantity_selector">' + 
                      '<span class="minus">-</span>' + 
                      '<input type="number" min="0" step="50" class="updates quantity" name="updates[]" id="updates_' + item.id + '" data-key="' + item.key + '" data-id="' + item.id + '" value="' + item.quantity + '" data-line-id="' + line_id + '" readonly />' + 
                      '<span class="plus">+</span>' + 
                      '</p>' + 
                      //'<a href="' + item.url + '">';
                      '<a href="javascript:void(0)">';
          
                  // Check if the item has an image and add it
                  if (item.image) {
                      cart_items_html += '<div class="cart_image">' + 
                          '<img src="' + item.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' + 
                          '</div>';
                  }
          
                  cart_items_html += '<div class="item_info">' + item.title;
          
                  // Bold:POv2 - Add variant information outside the anchor tag
                  if (item.properties) {
                      // Create dropdown for variants
                      var variantDropdownHtml = '<div class="variant-dropdown">';
                      var variantOptions = [];
                      var selectedVariantId = item.variant_id; // Get the variant_id from the item
                      // Loop through the properties to find Variant IDs and Names
                      $.each(item.properties, function(key, value) {
                          if (key.includes("Variant ID")) {
                              // Add variant name and ID pairs to the dropdown
                              var variantNameKey = key.replace("Variant ID", "Variant Name");
                              var variantName = item.properties[variantNameKey];
                              if (variantName) {
                                  variantOptions.push({ id: value, name: variantName });
                              }
                          }
                      });
          
                      // If we have variant options, create the dropdown
                      if (variantOptions.length > 0) {
                          variantDropdownHtml += '<label for="variant-selector-' + item.id + '">Select Variant:</label>';
                          variantDropdownHtml += '<select id="variant-selector-' + item.id + '" class="variant-selector">';
          
                          // Loop through the variant options to create the dropdown items
                          $.each(variantOptions, function(_, option) {
                              // Check if the current option's ID matches the item's variant_id
                              var isSelected = (option.id == selectedVariantId) ? 'selected' : '';                                                       
                              variantDropdownHtml += '<option value="' + option.id + '" data-variant-' + option.name + '="' + option.id + '" ' + isSelected + '>' + option.name + '</option>';
                          });
          
                          variantDropdownHtml += '</select>';
                      }
                      variantDropdownHtml += '</div>';
          
                      cart_items_html += variantDropdownHtml;
                  }
                  // Bold:POv2  
          
                  cart_items_html += '<div class="price"><span class="money">' + Shopify.formatMoney(item.price, $('body').data('money-format')) + '</span></div></div></a></li>';
              }
          });

        
            cart_items_html += '<li class="mm-subtitle clearfix">';
        
            $('#cart_form .subtotal_amount .money').empty().append(Shopify.formatMoney(cart.total_price, $cart.data('money-format')));
        
            $cart.append(cart_items_html);
        
            // update on cart page
            $("#cart_form .quantity:not(.custom-quantity)").each(function() {
                $(this).change(function() {
                    var thisLineID = $(this).data("line-id");
                    var lineToMatch = $('#cart .cart_item .quantity[data-line-id="' + thisLineID + '"]').val();
                    $(this).val(lineToMatch);
                }).change();
            });
          // Store the current variant IDs when the cart is initially loaded
          
          $(document).ready(function() {
              // Loop through each cart item to store the initial selected variant ID and properties
              $('.cart_item').each(function() {
                  var selectedVariantId = $(this).find('.variant-selector').val();
                  var properties = getVariantProperties($(this));  // Function to fetch properties
                  // Store the variant ID and properties in the cart item data attribute
                  $(this).data('variant-id', selectedVariantId);
                  $(this).data('variant-properties', properties);
              });
          });
          
          // Event listener for variant change
         $(document).on('change', '.variant-selector', function(e) {
           $('.cart_item').css({
              'filter': 'blur(60px)'
            });

            e.preventDefault();  // Prevent the default form submission or page refresh
            
            var select = $(this);
            var newVariantId = select.val(); // Get the selected variant ID
            var cartItem = select.closest('.cart_item'); // Find the parent cart item
            var oldVariantId = cartItem.data('variant-id'); // Get the current variant ID from the cart item
            var quantity = parseInt(cartItem.find('.quantity').val(), 10); // Get the quantity of the item
                
            var smallVariantId = select.find('option[data-variant-small]').attr('data-variant-small');
            var largeVariantId = select.find('option[data-variant-large]').attr('data-variant-large');
        
            // Only proceed if the selected variant is different from the current one
            if (newVariantId !== oldVariantId) {
                
                // Prepare the line item properties object
                  var lineItemProperties = {};
              
                  // Add small and large variant information to lineItemProperties
                  lineItemProperties['Small Variant ID'] = smallVariantId;
                  lineItemProperties['Large Variant ID'] = largeVariantId;
                  lineItemProperties['Small Variant Name'] = 'Small';  // Customize this if needed
                  lineItemProperties['Large Variant Name'] = 'Large';  // Customize this if needed
        
        
                // Add the new variant to the cart with the same quantity and properties
                // addVariantToCart(newVariantId, quantity, lineItemProperties);
                addVariantToCart(newVariantId, quantity, lineItemProperties, cartItem);

                // Trigger the click event on the close icon to remove the old item
                // var removeIcon = cartItem.find('.icon-close.remove_cart_item');
                // removeIcon.trigger('click');
                
                // Update the cart item with the new variant ID
                cartItem.data('variant-id', newVariantId);
            }
        });

          if (!document.getElementById('loader')) {
    const loader = document.createElement('div');
    loader.id = 'loader';
    loader.style.display = 'none'; // Initially hidden
    loader.style.position = 'fixed';
    loader.style.top = '50%';
    loader.style.right = '1%';
    loader.style.transform = 'translate(-50%, -50%)';
    loader.style.zIndex = '9999';
   // loader.style.background = 'rgba(0, 0, 0, 0.5)';
    loader.style.color = 'white';
    // loader.style.padding = '20px';
    loader.style.borderRadius = '10px';
    loader.style.fontSize = '18px';
    loader.text = 'Loading...';
    loader.innerHTML = '<img src="//stickerpack.com/cdn/shop/t/38/assets/ct-loader.gif?v=127651174446042363011726461223" alt="">';
    document.body.appendChild(loader);
}
         	
  function toggleLoader(show) {
      const loader = document.getElementById('loader');
      if (loader) {
          loader.style.display = show ? 'block' : 'none';
      }
  }
          
          // Function to add the new variant to the cart using Shopify's AJAX API
            // function addVariantToCart(variantId, quantity, lineItemProperties) {
          function addVariantToCart(variantId, quantity, lineItemProperties, cartItem) {
              $.ajax({
                  type: "POST",
                  url: "/cart/add.js",
                  data: {
                      form_type: 'product',
                      id: variantId,  // The selected variant ID
                      quantity: quantity,
                      properties: lineItemProperties  // Send the small and large variant IDs as properties
                  },
                  dataType: "json",
                  beforeSend: function() {
                  toggleLoader(true);
                  },
                  success: function(response) {
                      console.log("Added new variant:", variantId);
                      // Optionally, update the cart UI with new data
                    var removeIcon = cartItem.find('.icon-close.remove_cart_item');
                    removeIcon.trigger('click');
                      //updateCartUI(response);
                      setTimeout(function() {
                // window.location.reload();
            }, 2000);  // 2000 milliseconds = 2 seconds
                  },
                  error: function(xhr, status, error) {
                      console.error("Error adding variant to cart:", error);
                  },
                  complete: function() {
                    setTimeout(function() {
                  toggleLoader(false);
                      }, 1500);
                  }
              });
          }
        }

    }

    if (window.BOLD && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function') {
        BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
    }

    pleaseBeShyWords(jQuery(".line-item .bold_line_value"));

    if (options.dispatchCartEvent) {
        var refreshCartEvent = document.createEvent("Event");
        refreshCartEvent.initEvent('cartChanged', true, true);
        refreshCartEvent.cart = cart;
        document.querySelector("body").dispatchEvent(refreshCartEvent);
    }
if (window.BOLD && BOLD.common && BOLD.common.eventEmitter &&
                  typeof BOLD.common.eventEmitter.emit === 'function'){
                BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
 }


}

selectCallback = function(variant, selector) {

    var $product = $('.product-' + selector.product.id);
    var $notify_form = $('.notify-form-' + selector.product.id);
    var $productForm = $('.product_form', $product);
    var variantInventory = $productForm.data('variant-inventory');

    var $notifyFormInputs = $('.notify_form__inputs');

    var notifyEmail = "Enter your email address...";
    var notifyEmailValue = "";
    var notifySend = "Send";

    if (variant) {
        if (variant.title != null) {
            var notifyMessage = $notifyFormInputs.data('body') + ' - ' + variant.title;
        } else {
            var notifyMessage = $notifyFormInputs.data('body');
        }
    }

    if ($notifyFormInputs.hasClass('customer--true')) {
        var notifyCustomerEmail = "";
        var notifyEmailInput = '<input type="hidden" class="notify_email" name="contact[email]" id="contact[email]" value="' + notifyCustomerEmail + '" />'
    } else {
        var notifyEmailInput = '<input required type="email" class="notify_email" name="contact[email]" id="contact[email]" placeholder="' + notifyEmail + '" value="' + notifyEmailValue + '" />';
    }
    var notifyFormHTML = notifyEmailInput + '<input type="hidden" name="challenge" value="false" /><input type="hidden" name="contact[body]" class="notify_form_message" data-body="' + notifyMessage + '" value="' + notifyMessage + '" /><input class="action_button" type="submit" value="' + notifySend + '" style="margin-bottom:0px" />';

    if (variant && variant.featured_image && $product.is(":visible")) {
        var $sliders = $('.product_gallery', $product);
        $sliders.each(function() {
            var $slider = $(this);
            if ($slider.is(":visible")) {
                $slider.flexslider($('[data-image-id="' + variant.featured_image.id + '"]').data('index'));
            }
        });
    }

    if (variant) {
        if (variantInventory) {
            variantInventory.forEach(function(v) {
                if (v.id === variant.id) {
                    variant.inventory_quantity = v.inventory_quantity;
                    variant.inventory_management = v.inventory_management;
                    variant.inventory_policy = v.inventory_policy;
                }
            });
        }

        $('.sku span', $product).text(variant.sku);
        $(".notify_form_message", $product).attr("value", $(".notify_form_message", $product).data('body') + " - " + variant.title);

        for (var i = 0, length = variant.options.length; i < length; i++) {
            var radioButton = $productForm.find('.swatch[data-option-index="' + escape(i) + '"] :radio[value="' + variant.options[i].replace(/\"/g, '\\"') + '"]');
            if (radioButton.length) {
                radioButton.get(0).checked = true;
            }
        }

    }

    if (variant && variant.available == true) {

        if (variant.price < variant.compare_at_price) {
            $('.was_price', $product).html('<span class="money">' + Shopify.formatMoney(variant.compare_at_price, $('body').data('money-format')) + '</span>');
            $('.current_price', $product).parent().addClass('sale');
        } else {
            $('.was_price', $product).html('')
            $('.current_price', $product).parent().removeClass('sale');
        }

        if (variant.inventory_management && variant.inventory_quantity > 0) {
        } else {
            $('.items_left', $product).text('');
            $('.quantity', $product).removeAttr('max');
        }

        $('.sold_out', $product).text('');
        if (variant.price > 0) {
            $('.current_price', $product).html('<span class="money">' + Shopify.formatMoney(variant.price, $('body').data('money-format')) + '</span>');
        } else {
            $('.current_price', $product).html("Free");
        }
        $('.add_to_cart', $product).removeClass('disabled').removeAttr('disabled').find('span').text($('.add_to_cart', $product).data('label'));
        $('.shopify-payment-button', $product).show();
        $notify_form.hide();
    } else {
        var message = variant ? "Sold Out" : "Unavailable";
        $('.was_price', $product).html('');
        $('.current_price', $product).html('');
        $('.items_left', $product).text('');
        $('.quantity', $product).removeAttr('max');
        $('.sold_out', $product).text(message);
        $('.add_to_cart', $product).addClass('disabled').attr('disabled', 'disabled').find('span').text(message);
        $('.shopify-payment-button', $product).hide();
        $notify_form.hide();
        $notifyFormInputs.empty();
        if (variant && !variant.available) {
            $notify_form.fadeIn();
            $notifyFormInputs.empty();
            $notifyFormInputs.append(notifyFormHTML);
        }
    }

    $productForm.removeClass("init");
}
;

function htmlEncode(value) {
    if (value) {
        return $('<div/>').text(value).html();
    } else {
        return '';
    }
}

// mediaWrapper.js: Simple responsive iframes
// MIT license http://www.opensource.org/licenses/mit-license.php/
// @author Matthew A. K. Smith http://www.akselkreis.com

!function(t) {
    t.fn.mediaWrapper = function(i) {
        var e = t.extend({
            intrinsic: !0,
            baseWidth: 16,
            baseHeight: 9
        }, i);
        return this.each(function() {
            var i = "";
            i = 1 == e.intrinsic && "" !== t(this).attr("width") && "" !== t(this).attr("height") ? t(this).attr("height") / t(this).attr("width") * 100 : e.baseHeight / e.baseWidth * 100,
            t(this).wrap('<div class="mediaWrapper" style="position: relative; width: 100%; height: 0; padding: ' + i + '% 0 0 0; " />').css({
                position: "absolute",
                width: "100%",
                height: "100%",
                top: "0",
                left: "0"
            })
        })
    }
}(jQuery);

/*
 * Pointer Events Polyfill: Adds support for the style attribute "pointer-events: none" to browsers without this feature (namely, IE).
 * (c) 2013, Kent Mewhort, licensed under BSD. See LICENSE.txt for details.
 */

function PointerEventsPolyfill(t) {
    if (this.options = {
        selector: "*",
        mouseEvents: ["click", "dblclick", "mousedown", "mouseup"],
        usePolyfillIf: function() {
            if ("Microsoft Internet Explorer" == navigator.appName) {
                var t = navigator.userAgent;
                if (null != t.match(/MSIE ([0-9]{1,}[\.0-9]{0,})/)) {
                    var e = parseFloat(RegExp.$1);
                    if (11 > e)
                        return !0
                }
            }
            return !1
        }
    },
    t) {
        var e = this;
        $.each(t, function(t, n) {
            e.options[t] = n
        })
    }
    this.options.usePolyfillIf() && this.register_mouse_events()
}
PointerEventsPolyfill.initialize = function(t) {
    return null == PointerEventsPolyfill.singleton && (PointerEventsPolyfill.singleton = new PointerEventsPolyfill(t)),
    PointerEventsPolyfill.singleton
}
,
PointerEventsPolyfill.prototype.register_mouse_events = function() {
    $(document).on(this.options.mouseEvents.join(" "), this.options.selector, function(t) {
        if ("none" == $(this).css("pointer-events")) {
            var e = $(this).css("display");
            $(this).css("display", "none");
            var n = document.elementFromPoint(t.clientX, t.clientY);
            return e ? $(this).css("display", e) : $(this).css("display", ""),
            t.target = n,
            $(n).trigger(t),
            !1
        }
        return !0
    })
}
;

/* option_selection.js */
function floatToString(t, e) {
    var o = t.toFixed(e).toString();
    return o.match(/^\.\d+/) ? "0" + o : o
}
if ("undefined" == typeof Shopify)
    var Shopify = {};
Shopify.each = function(t, e) {
    for (var o = 0; o < t.length; o++)
        e(t[o], o)
}
,
Shopify.map = function(t, e) {
    for (var o = [], i = 0; i < t.length; i++)
        o.push(e(t[i], i));
    return o
}
,
Shopify.arrayIncludes = function(t, e) {
    for (var o = 0; o < t.length; o++)
        if (t[o] == e)
            return !0;
    return !1
}
,
Shopify.uniq = function(t) {
    for (var e = [], o = 0; o < t.length; o++)
        Shopify.arrayIncludes(e, t[o]) || e.push(t[o]);
    return e
}
,
Shopify.isDefined = function(t) {
    return "undefined" == typeof t ? !1 : !0
}
,
Shopify.getClass = function(t) {
    return Object.prototype.toString.call(t).slice(8, -1)
}
,
Shopify.extend = function(t, e) {
    function o() {}
    o.prototype = e.prototype,
    t.prototype = new o,
    t.prototype.constructor = t,
    t.baseConstructor = e,
    t.superClass = e.prototype
}
,
Shopify.locationSearch = function() {
    return window.location.search
}
,
Shopify.locationHash = function() {
    return window.location.hash
}
,
Shopify.replaceState = function(t) {
    window.history.replaceState({}, document.title, t)
}
,
Shopify.urlParam = function(t) {
    var e = RegExp("[?&]" + t + "=([^&#]*)").exec(Shopify.locationSearch());
    return e && decodeURIComponent(e[1].replace(/\+/g, " "))
}
,
Shopify.newState = function(t, e) {
    var o;
    return o = Shopify.urlParam(t) ? Shopify.locationSearch().replace(RegExp("(" + t + "=)[^&#]+"), "$1" + e) : "" === Shopify.locationSearch() ? "?" + t + "=" + e : Shopify.locationSearch() + "&" + t + "=" + e,
    o + Shopify.locationHash()
}
,
Shopify.setParam = function(t, e) {
    Shopify.replaceState(Shopify.newState(t, e))
}
,
Shopify.Product = function(t) {
    Shopify.isDefined(t) && this.update(t)
}
,
Shopify.Product.prototype.update = function(t) {
    for (property in t)
        this[property] = t[property]
}
,
Shopify.Product.prototype.optionNames = function() {
    return "Array" == Shopify.getClass(this.options) ? this.options : []
}
,
Shopify.Product.prototype.optionValues = function(t) {
    if (!Shopify.isDefined(this.variants))
        return null;
    var e = Shopify.map(this.variants, function(e) {
        var o = "option" + (t + 1);
        return void 0 == e[o] ? null : e[o]
    });
    return null == e[0] ? null : Shopify.uniq(e)
}
,
Shopify.Product.prototype.getVariant = function(t) {
    var e = null;
    return t.length != this.options.length ? e : (Shopify.each(this.variants, function(o) {
        for (var i = !0, r = 0; r < t.length; r++) {
            var n = "option" + (r + 1);
            o[n] != t[r] && (i = !1)
        }
        return 1 == i ? void (e = o) : void 0
    }),
    e)
}
,
Shopify.Product.prototype.getVariantById = function(t) {
    for (var e = 0; e < this.variants.length; e++) {
        var o = this.variants[e];
        if (t == o.id)
            return o
    }
    return null
}
,
Shopify.money_format = "$",
Shopify.formatMoney = function(t, e) {
    function o(t, e) {
        return "undefined" == typeof t ? e : t
    }
    function i(t, e, i, r) {
        if (e = o(e, 2),
        i = o(i, ","),
        r = o(r, "."),
        isNaN(t) || null == t)
            return 0;
        t = (t / 100).toFixed(e);
        var n = t.split(".")
          , a = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i)
          , s = n[1] ? r + n[1] : "";
        return a + s
    }
    "string" == typeof t && (t = t.replace(".", ""));
    var r = ""
      , n = /\{\{\s*(\w+)\s*\}\}/
      , a = e || this.money_format;
    switch (a.match(n)[1]) {
    case "amount":
        r = i(t, 2);
        break;
    case "amount_no_decimals":
        r = i(t, 0);
        break;
    case "amount_with_comma_separator":
        r = i(t, 2, ".", ",");
        break;
    case "amount_with_apostrophe_separator":
        r = i(t, 2);
        break;
    case "amount_no_decimals_with_comma_separator":
        r = i(t, 0, ".", ",")
    }
    return a.replace(n, r)
}
,
Shopify.OptionSelectors = function(t, e) {
    return this.selectorDivClass = "selector-wrapper",
    this.selectorClass = "single-option-selector",
    this.variantIdFieldIdSuffix = "-variant-id",
    this.variantIdField = null,
    this.historyState = null,
    this.selectors = [],
    this.domIdPrefix = t,
    this.product = new Shopify.Product(e.product),
    this.onVariantSelected = Shopify.isDefined(e.onVariantSelected) ? e.onVariantSelected : function() {}
    ,
    this.replaceSelector(t),
    this.initDropdown(),
    e.enableHistoryState && (this.historyState = new Shopify.OptionSelectors.HistoryState(this)),
    !0
}
,
Shopify.OptionSelectors.prototype.initDropdown = function() {
    var t = {
        initialLoad: !0
    }
      , e = this.selectVariantFromDropdown(t);
    if (!e) {
        var o = this;
        setTimeout(function() {
            o.selectVariantFromParams(t) || o.fireOnChangeForFirstDropdown.call(o, t)
        })
    }
}
,
Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function(t) {
    this.selectors[0].element.onchange(t)
}
,
Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function(t) {
    var e = this.selectVariantFromParams(t);
    e || this.selectVariantFromDropdown(t)
}
,
Shopify.OptionSelectors.prototype.replaceSelector = function(t) {
    var e = document.getElementById(t)
      , o = e.parentNode;
    Shopify.each(this.buildSelectors(), function(t) {
        o.insertBefore(t, e)
    }),
    e.style.display = "none",
    this.variantIdField = e
}
,
Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function(t) {
    var e = document.getElementById(this.domIdPrefix).querySelector("[selected]");
    if (e || (e = document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')),
    !e)
        return !1;
    var o = e.value;
    return this.selectVariant(o, t)
}
,
Shopify.OptionSelectors.prototype.selectVariantFromParams = function(t) {
    var e = Shopify.urlParam("variant");
    return this.selectVariant(e, t)
}
,
Shopify.OptionSelectors.prototype.selectVariant = function(t, e) {
    var o = this.product.getVariantById(t);
    if (null == o)
        return !1;
    for (var i = 0; i < this.selectors.length; i++) {
        var r = this.selectors[i].element
          , n = r.getAttribute("data-option")
          , a = o[n];
        null != a && this.optionExistInSelect(r, a) && (r.value = a)
    }
    return "undefined" != typeof jQuery ? jQuery(this.selectors[0].element).trigger("change", e) : this.selectors[0].element.onchange(e),
    !0
}
,
Shopify.OptionSelectors.prototype.optionExistInSelect = function(t, e) {
    for (var o = 0; o < t.options.length; o++)
        if (t.options[o].value == e)
            return !0
}
,
Shopify.OptionSelectors.prototype.insertSelectors = function(t, e) {
    Shopify.isDefined(e) && this.setMessageElement(e),
    this.domIdPrefix = "product-" + this.product.id + "-variant-selector";
    var o = document.getElementById(t);
    Shopify.each(this.buildSelectors(), function(t) {
        o.appendChild(t)
    })
}
,
Shopify.OptionSelectors.prototype.buildSelectors = function() {
    for (var t = 0; t < this.product.optionNames().length; t++) {
        var e = new Shopify.SingleOptionSelector(this,t,this.product.optionNames()[t],this.product.optionValues(t));
        e.element.disabled = !1,
        this.selectors.push(e)
    }
    var o = this.selectorDivClass
      , i = this.product.optionNames()
      , r = Shopify.map(this.selectors, function(t) {
        var e = document.createElement("div");
        if (e.setAttribute("class", o),
        i.length > 1) {
            var r = document.createElement("label");
            r.htmlFor = t.element.id,
            r.innerHTML = t.name,
            e.appendChild(r)
        }
        return e.appendChild(t.element),
        e
    });
    return r
}
,
Shopify.OptionSelectors.prototype.selectedValues = function() {
    for (var t = [], e = 0; e < this.selectors.length; e++) {
        var o = this.selectors[e].element.value;
        t.push(o)
    }
    return t
}
,
Shopify.OptionSelectors.prototype.updateSelectors = function(t, e) {
    var o = this.selectedValues()
      , i = this.product.getVariant(o);
    i ? (this.variantIdField.disabled = !1,
    this.variantIdField.value = i.id) : this.variantIdField.disabled = !0,
    this.onVariantSelected(i, this, e),
    null != this.historyState && this.historyState.onVariantChange(i, this, e)
}
,
Shopify.OptionSelectorsFromDOM = function(t, e) {
    var o = e.optionNames || []
      , i = e.priceFieldExists || !0
      , r = e.delimiter || "/"
      , n = this.createProductFromSelector(t, o, i, r);
    e.product = n,
    Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, t, e)
}
,
Shopify.extend(Shopify.OptionSelectorsFromDOM, Shopify.OptionSelectors),
Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function(t, e, o, i) {
    if (!Shopify.isDefined(o))
        var o = !0;
    if (!Shopify.isDefined(i))
        var i = "/";
    var r = document.getElementById(t)
      , n = r.childNodes
      , a = (r.parentNode,
    e.length)
      , s = [];
    Shopify.each(n, function(t, r) {
        if (1 == t.nodeType && "option" == t.tagName.toLowerCase()) {
            var n = t.innerHTML.split(new RegExp("\\s*\\" + i + "\\s*"));
            0 == e.length && (a = n.length - (o ? 1 : 0));
            var p = n.slice(0, a)
              , l = o ? n[a] : ""
              , c = (t.getAttribute("value"),
            {
                available: t.disabled ? !1 : !0,
                id: parseFloat(t.value),
                price: l,
                option1: p[0],
                option2: p[1],
                option3: p[2]
            });
            s.push(c)
        }
    });
    var p = {
        variants: s
    };
    if (0 == e.length) {
        p.options = [];
        for (var l = 0; a > l; l++)
            p.options[l] = "option " + (l + 1)
    } else
        p.options = e;
    return p
}
,
Shopify.SingleOptionSelector = function(t, e, o, i) {
    this.multiSelector = t,
    this.values = i,
    this.index = e,
    this.name = o,
    this.element = document.createElement("select");
    for (var r = 0; r < i.length; r++) {
        var n = document.createElement("option");
        n.value = i[r],
        n.innerHTML = i[r],
        this.element.appendChild(n)
    }
    return this.element.setAttribute("class", this.multiSelector.selectorClass),
    this.element.setAttribute("data-option", "option" + (e + 1)),
    this.element.id = t.domIdPrefix + "-option-" + e,
    this.element.onchange = function(o, i) {
        i = i || {},
        t.updateSelectors(e, i)
    }
    ,
    !0
}
,
Shopify.Image = {
    preload: function(t, e) {
        for (var o = 0; o < t.length; o++) {
            var i = t[o];
            this.loadImage(this.getSizedImageUrl(i, e))
        }
    },
    loadImage: function(t) {
        (new Image).src = t
    },
    switchImage: function(t, e, o) {
        if (t && e) {
            var i = this.imageSize(e.src)
              , r = this.getSizedImageUrl(t.src, i);
            o ? o(r, t, e) : e.src = r
        }
    },
    imageSize: function(t) {
        var e = t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);
        return null != e ? e[1] : null
    },
    getSizedImageUrl: function(t, e) {
        if (null == e)
            return t;
        if ("master" == e)
            return this.removeProtocol(t);
        var o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (null != o) {
            var i = t.split(o[0])
              , r = o[0];
            return this.removeProtocol(i[0] + "_" + e + r)
        }
        return null
    },
    removeProtocol: function(t) {
        return t.replace(/http(s)?:/, "")
    }
},
Shopify.OptionSelectors.HistoryState = function(t) {
    this.browserSupports() && this.register(t)
}
,
Shopify.OptionSelectors.HistoryState.prototype.register = function(t) {
    window.addEventListener("popstate", function(e) {
        t.selectVariantFromParamsOrDropdown({
            popStateCall: !0
        })
    })
}
,
Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function(t, e, o) {
    this.browserSupports() && (!t || o.initialLoad || o.popStateCall || Shopify.setParam("variant", t.id))
}
,
Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function() {
    return window.history && window.history.replaceState
}
;

/*! fancyBox v2.1.5 fancyapps.com | fancyapps.com/fancybox/#license */
(function(r, G, f, v) {
    var J = f("html")
      , n = f(r)
      , p = f(G)
      , b = f.fancybox = function() {
        b.open.apply(this, arguments)
    }
      , I = navigator.userAgent.match(/msie/i)
      , B = null
      , s = G.createTouch !== v
      , t = function(a) {
        return a && a.hasOwnProperty && a instanceof f
    }
      , q = function(a) {
        return a && "string" === f.type(a)
    }
      , E = function(a) {
        return q(a) && 0 < a.indexOf("%")
    }
      , l = function(a, d) {
        var e = parseInt(a, 10) || 0;
        d && E(a) && (e *= b.getViewport()[d] / 100);
        return Math.ceil(e)
    }
      , w = function(a, b) {
        return l(a, b) + "px"
    };
    f.extend(b, {
        version: "2.1.5",
        defaults: {
            padding: 15,
            margin: 20,
            width: 800,
            height: 600,
            minWidth: 100,
            minHeight: 100,
            maxWidth: 9999,
            maxHeight: 9999,
            pixelRatio: 1,
            autoSize: !0,
            autoHeight: !1,
            autoWidth: !1,
            autoResize: !0,
            autoCenter: !s,
            fitToView: !0,
            aspectRatio: !1,
            topRatio: 0.5,
            leftRatio: 0.5,
            scrolling: "auto",
            wrapCSS: "",
            arrows: !0,
            closeBtn: !0,
            closeClick: !1,
            nextClick: !1,
            mouseWheel: !0,
            autoPlay: !1,
            playSpeed: 3E3,
            preload: 3,
            modal: !1,
            loop: !0,
            ajax: {
                dataType: "html",
                headers: {
                    "X-fancyBox": !0
                }
            },
            iframe: {
                scrolling: "auto",
                preload: !0
            },
            swf: {
                wmode: "transparent",
                allowfullscreen: "true",
                allowscriptaccess: "always"
            },
            keys: {
                next: {
                    13: "left",
                    34: "up",
                    39: "left",
                    40: "up"
                },
                prev: {
                    8: "right",
                    33: "down",
                    37: "right",
                    38: "down"
                },
                close: [27],
                play: [32],
                toggle: [70]
            },
            direction: {
                next: "left",
                prev: "right"
            },
            scrollOutside: !0,
            index: 0,
            type: null,
            href: null,
            content: null,
            title: null,
            tpl: {
                wrap: '<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',
                image: '<img class="fancybox-image" src="{href}" alt="" />',
                iframe: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen' + (I ? ' allowtransparency="true"' : "") + "></iframe>",
                error: '<p class="fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>',
                closeBtn: '<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"><span class="icon-close"></span></a>',
                next: '<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><span class="icon-arrow-right"></span></a>',
                prev: '<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><span class="icon-arrow-left"></span></a>'
            },
            openEffect: "fade",
            openSpeed: 250,
            openEasing: "swing",
            openOpacity: !0,
            openMethod: "zoomIn",
            closeEffect: "fade",
            closeSpeed: 250,
            closeEasing: "swing",
            closeOpacity: !0,
            closeMethod: "zoomOut",
            nextEffect: "elastic",
            nextSpeed: 250,
            nextEasing: "swing",
            nextMethod: "changeIn",
            prevEffect: "elastic",
            prevSpeed: 250,
            prevEasing: "swing",
            prevMethod: "changeOut",
            helpers: {
                overlay: !0,
                title: !0
            },
            onCancel: f.noop,
            beforeLoad: f.noop,
            afterLoad: f.noop,
            beforeShow: f.noop,
            afterShow: f.noop,
            beforeChange: f.noop,
            beforeClose: f.noop,
            afterClose: f.noop
        },
        group: {},
        opts: {},
        previous: null,
        coming: null,
        current: null,
        isActive: !1,
        isOpen: !1,
        isOpened: !1,
        wrap: null,
        skin: null,
        outer: null,
        inner: null,
        player: {
            timer: null,
            isActive: !1
        },
        ajaxLoad: null,
        imgPreload: null,
        transitions: {},
        helpers: {},
        open: function(a, d) {
            if (a && (f.isPlainObject(d) || (d = {}),
            !1 !== b.close(!0)))
                return f.isArray(a) || (a = t(a) ? f(a).get() : [a]),
                f.each(a, function(e, c) {
                    var k = {}, g, h, j, m, l;
                    "object" === f.type(c) && (c.nodeType && (c = f(c)),
                    t(c) ? (k = {
                        href: c.data("fancybox-href") || c.attr("href"),
                        title: c.data("fancybox-title") || c.attr("title"),
                        isDom: !0,
                        element: c
                    },
                    f.metadata && f.extend(!0, k, c.metadata())) : k = c);
                    g = d.href || k.href || (q(c) ? c : null);
                    h = d.title !== v ? d.title : k.title || "";
                    m = (j = d.content || k.content) ? "html" : d.type || k.type;
                    !m && k.isDom && (m = c.data("fancybox-type"),
                    m || (m = (m = c.prop("class").match(/fancybox\.(\w+)/)) ? m[1] : null));
                    q(g) && (m || (b.isImage(g) ? m = "image" : b.isSWF(g) ? m = "swf" : "#" === g.charAt(0) ? m = "inline" : q(c) && (m = "html",
                    j = c)),
                    "ajax" === m && (l = g.split(/\s+/, 2),
                    g = l.shift(),
                    l = l.shift()));
                    j || ("inline" === m ? g ? j = f(q(g) ? g.replace(/.*(?=#[^\s]+$)/, "") : g) : k.isDom && (j = c) : "html" === m ? j = g : !m && (!g && k.isDom) && (m = "inline",
                    j = c));
                    f.extend(k, {
                        href: g,
                        type: m,
                        content: j,
                        title: h,
                        selector: l
                    });
                    a[e] = k
                }),
                b.opts = f.extend(!0, {}, b.defaults, d),
                d.keys !== v && (b.opts.keys = d.keys ? f.extend({}, b.defaults.keys, d.keys) : !1),
                b.group = a,
                b._start(b.opts.index)
        },
        cancel: function() {
            var a = b.coming;
            a && !1 !== b.trigger("onCancel") && (b.hideLoading(),
            b.ajaxLoad && b.ajaxLoad.abort(),
            b.ajaxLoad = null,
            b.imgPreload && (b.imgPreload.onload = b.imgPreload.onerror = null),
            a.wrap && a.wrap.stop(!0, !0).trigger("onReset").remove(),
            b.coming = null,
            b.current || b._afterZoomOut(a))
        },
        close: function(a) {
            b.cancel();
            !1 !== b.trigger("beforeClose") && (b.unbindEvents(),
            b.isActive && (!b.isOpen || !0 === a ? (f(".fancybox-wrap").stop(!0).trigger("onReset").remove(),
            b._afterZoomOut()) : (b.isOpen = b.isOpened = !1,
            b.isClosing = !0,
            f(".fancybox-item, .fancybox-nav").remove(),
            b.wrap.stop(!0, !0).removeClass("fancybox-opened"),
            b.transitions[b.current.closeMethod]())))
        },
        play: function(a) {
            var d = function() {
                clearTimeout(b.player.timer)
            }
              , e = function() {
                d();
                b.current && b.player.isActive && (b.player.timer = setTimeout(b.next, b.current.playSpeed))
            }
              , c = function() {
                d();
                p.unbind(".player");
                b.player.isActive = !1;
                b.trigger("onPlayEnd")
            };
            if (!0 === a || !b.player.isActive && !1 !== a) {
                if (b.current && (b.current.loop || b.current.index < b.group.length - 1))
                    b.player.isActive = !0,
                    p.bind({
                        "onCancel.player beforeClose.player": c,
                        "onUpdate.player": e,
                        "beforeLoad.player": d
                    }),
                    e(),
                    b.trigger("onPlayStart")
            } else
                c()
        },
        next: function(a) {
            var d = b.current;
            d && (q(a) || (a = d.direction.next),
            b.jumpto(d.index + 1, a, "next"))
        },
        prev: function(a) {
            var d = b.current;
            d && (q(a) || (a = d.direction.prev),
            b.jumpto(d.index - 1, a, "prev"))
        },
        jumpto: function(a, d, e) {
            var c = b.current;
            c && (a = l(a),
            b.direction = d || c.direction[a >= c.index ? "next" : "prev"],
            b.router = e || "jumpto",
            c.loop && (0 > a && (a = c.group.length + a % c.group.length),
            a %= c.group.length),
            c.group[a] !== v && (b.cancel(),
            b._start(a)))
        },
        reposition: function(a, d) {
            var e = b.current, c = e ? e.wrap : null, k;
            c && (k = b._getPosition(d),
            a && "scroll" === a.type ? (delete k.position,
            c.stop(!0, !0).animate(k, 200)) : (c.css(k),
            e.pos = f.extend({}, e.dim, k)))
        },
        update: function(a) {
            var d = a && a.type
              , e = !d || "orientationchange" === d;
            e && (clearTimeout(B),
            B = null);
            b.isOpen && !B && (B = setTimeout(function() {
                var c = b.current;
                c && !b.isClosing && (b.wrap.removeClass("fancybox-tmp"),
                (e || "load" === d || "resize" === d && c.autoResize) && b._setDimension(),
                "scroll" === d && c.canShrink || b.reposition(a),
                b.trigger("onUpdate"),
                B = null)
            }, e && !s ? 0 : 300))
        },
        toggle: function(a) {
            b.isOpen && (b.current.fitToView = "boolean" === f.type(a) ? a : !b.current.fitToView,
            s && (b.wrap.removeAttr("style").addClass("fancybox-tmp"),
            b.trigger("onUpdate")),
            b.update())
        },
        hideLoading: function() {
            p.unbind(".loading");
            f("#fancybox-loading").remove()
        },
        showLoading: function() {
            var a, d;
            b.hideLoading();
            a = f('<div id="fancybox-loading"><div></div></div>').click(b.cancel).appendTo("body");
            p.bind("keydown.loading", function(a) {
                if (27 === (a.which || a.keyCode))
                    a.preventDefault(),
                    b.cancel()
            });
            b.defaults.fixed || (d = b.getViewport(),
            a.css({
                position: "absolute",
                top: 0.5 * d.h + d.y,
                left: 0.5 * d.w + d.x
            }))
        },
        getViewport: function() {
            var a = b.current && b.current.locked || !1
              , d = {
                x: n.scrollLeft(),
                y: n.scrollTop()
            };
            a ? (d.w = a[0].clientWidth,
            d.h = a[0].clientHeight) : (d.w = s && r.innerWidth ? r.innerWidth : n.width(),
            d.h = s && r.innerHeight ? r.innerHeight : n.height());
            return d
        },
        unbindEvents: function() {
            b.wrap && t(b.wrap) && b.wrap.unbind(".fb");
            p.unbind(".fb");
            n.unbind(".fb")
        },
        bindEvents: function() {
            var a = b.current, d;
            a && (n.bind("orientationchange.fb" + (s ? "" : " resize.fb") + (a.autoCenter && !a.locked ? " scroll.fb" : ""), b.update),
            (d = a.keys) && p.bind("keydown.fb", function(e) {
                var c = e.which || e.keyCode
                  , k = e.target || e.srcElement;
                if (27 === c && b.coming)
                    return !1;
                !e.ctrlKey && (!e.altKey && !e.shiftKey && !e.metaKey && (!k || !k.type && !f(k).is("[contenteditable]"))) && f.each(d, function(d, k) {
                    if (1 < a.group.length && k[c] !== v)
                        return b[d](k[c]),
                        e.preventDefault(),
                        !1;
                    if (-1 < f.inArray(c, k))
                        return b[d](),
                        e.preventDefault(),
                        !1
                })
            }),
            f.fn.mousewheel && a.mouseWheel && b.wrap.bind("mousewheel.fb", function(d, c, k, g) {
                for (var h = f(d.target || null), j = !1; h.length && !j && !h.is(".fancybox-skin") && !h.is(".fancybox-wrap"); )
                    j = h[0] && !(h[0].style.overflow && "hidden" === h[0].style.overflow) && (h[0].clientWidth && h[0].scrollWidth > h[0].clientWidth || h[0].clientHeight && h[0].scrollHeight > h[0].clientHeight),
                    h = f(h).parent();
                if (0 !== c && !j && 1 < b.group.length && !a.canShrink) {
                    if (0 < g || 0 < k)
                        b.prev(0 < g ? "down" : "left");
                    else if (0 > g || 0 > k)
                        b.next(0 > g ? "up" : "right");
                    d.preventDefault()
                }
            }))
        },
        trigger: function(a, d) {
            var e, c = d || b.coming || b.current;
            if (c) {
                f.isFunction(c[a]) && (e = c[a].apply(c, Array.prototype.slice.call(arguments, 1)));
                if (!1 === e)
                    return !1;
                c.helpers && f.each(c.helpers, function(d, e) {
                    if (e && b.helpers[d] && f.isFunction(b.helpers[d][a]))
                        b.helpers[d][a](f.extend(!0, {}, b.helpers[d].defaults, e), c)
                });
                p.trigger(a)
            }
        },
        isImage: function(a) {
            return q(a) && a.match(/(^data:image\/.*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg)((\?|#).*)?$)/i)
        },
        isSWF: function(a) {
            return q(a) && a.match(/\.(swf)((\?|#).*)?$/i)
        },
        _start: function(a) {
            var d = {}, e, c;
            a = l(a);
            e = b.group[a] || null;
            if (!e)
                return !1;
            d = f.extend(!0, {}, b.opts, e);
            e = d.margin;
            c = d.padding;
            "number" === f.type(e) && (d.margin = [e, e, e, e]);
            "number" === f.type(c) && (d.padding = [c, c, c, c]);
            d.modal && f.extend(!0, d, {
                closeBtn: !1,
                closeClick: !1,
                nextClick: !1,
                arrows: !1,
                mouseWheel: !1,
                keys: null,
                helpers: {
                    overlay: {
                        closeClick: !1
                    }
                }
            });
            d.autoSize && (d.autoWidth = d.autoHeight = !0);
            "auto" === d.width && (d.autoWidth = !0);
            "auto" === d.height && (d.autoHeight = !0);
            d.group = b.group;
            d.index = a;
            b.coming = d;
            if (!1 === b.trigger("beforeLoad"))
                b.coming = null;
            else {
                c = d.type;
                e = d.href;
                if (!c)
                    return b.coming = null,
                    b.current && b.router && "jumpto" !== b.router ? (b.current.index = a,
                    b[b.router](b.direction)) : !1;
                b.isActive = !0;
                if ("image" === c || "swf" === c)
                    d.autoHeight = d.autoWidth = !1,
                    d.scrolling = "visible";
                "image" === c && (d.aspectRatio = !0);
                "iframe" === c && s && (d.scrolling = "scroll");
                d.wrap = f(d.tpl.wrap).addClass("fancybox-" + (s ? "mobile" : "desktop") + " fancybox-type-" + c + " fancybox-tmp " + d.wrapCSS).appendTo(d.parent || "body");
                f.extend(d, {
                    skin: f(".fancybox-skin", d.wrap),
                    outer: f(".fancybox-outer", d.wrap),
                    inner: f(".fancybox-inner", d.wrap)
                });
                f.each(["Top", "Right", "Bottom", "Left"], function(a, b) {
                    d.skin.css("padding" + b, w(d.padding[a]))
                });
                b.trigger("onReady");
                if ("inline" === c || "html" === c) {
                    if (!d.content || !d.content.length)
                        return b._error("content")
                } else if (!e)
                    return b._error("href");
                "image" === c ? b._loadImage() : "ajax" === c ? b._loadAjax() : "iframe" === c ? b._loadIframe() : b._afterLoad()
            }
        },
        _error: function(a) {
            f.extend(b.coming, {
                type: "html",
                autoWidth: !0,
                autoHeight: !0,
                minWidth: 0,
                minHeight: 0,
                scrolling: "no",
                hasError: a,
                content: b.coming.tpl.error
            });
            b._afterLoad()
        },
        _loadImage: function() {
            var a = b.imgPreload = new Image;
            a.onload = function() {
                this.onload = this.onerror = null;
                b.coming.width = this.width / b.opts.pixelRatio;
                b.coming.height = this.height / b.opts.pixelRatio;
                b._afterLoad()
            }
            ;
            a.onerror = function() {
                this.onload = this.onerror = null;
                b._error("image")
            }
            ;
            a.src = b.coming.href;
            !0 !== a.complete && b.showLoading()
        },
        _loadAjax: function() {
            var a = b.coming;
            b.showLoading();
            b.ajaxLoad = f.ajax(f.extend({}, a.ajax, {
                url: a.href,
                error: function(a, e) {
                    b.coming && "abort" !== e ? b._error("ajax", a) : b.hideLoading()
                },
                success: function(d, e) {
                    "success" === e && (a.content = d,
                    b._afterLoad())
                }
            }))
        },
        _loadIframe: function() {
            var a = b.coming
              , d = f(a.tpl.iframe.replace(/\{rnd\}/g, (new Date).getTime())).attr("scrolling", s ? "auto" : a.iframe.scrolling).attr("src", a.href);
            f(a.wrap).bind("onReset", function() {
                try {
                    f(this).find("iframe").hide().attr("src", "//about:blank").end().empty()
                } catch (a) {}
            });
            a.iframe.preload && (b.showLoading(),
            d.one("load", function() {
                f(this).data("ready", 1);
                s || f(this).bind("load.fb", b.update);
                f(this).parents(".fancybox-wrap").width("100%").removeClass("fancybox-tmp").show();
                b._afterLoad()
            }));
            a.content = d.appendTo(a.inner);
            a.iframe.preload || b._afterLoad()
        },
        _preloadImages: function() {
            var a = b.group, d = b.current, e = a.length, c = d.preload ? Math.min(d.preload, e - 1) : 0, f, g;
            for (g = 1; g <= c; g += 1)
                f = a[(d.index + g) % e],
                "image" === f.type && f.href && ((new Image).src = f.href)
        },
        _afterLoad: function() {
            var a = b.coming, d = b.current, e, c, k, g, h;
            b.hideLoading();
            if (a && !1 !== b.isActive)
                if (!1 === b.trigger("afterLoad", a, d))
                    a.wrap.stop(!0).trigger("onReset").remove(),
                    b.coming = null;
                else {
                    d && (b.trigger("beforeChange", d),
                    d.wrap.stop(!0).removeClass("fancybox-opened").find(".fancybox-item, .fancybox-nav").remove());
                    b.unbindEvents();
                    e = a.content;
                    c = a.type;
                    k = a.scrolling;
                    f.extend(b, {
                        wrap: a.wrap,
                        skin: a.skin,
                        outer: a.outer,
                        inner: a.inner,
                        current: a,
                        previous: d
                    });
                    g = a.href;
                    switch (c) {
                    case "inline":
                    case "ajax":
                    case "html":
                        a.selector ? e = f("<div>").html(e).find(a.selector) : t(e) && (e.data("fancybox-placeholder") || e.data("fancybox-placeholder", f('<div class="fancybox-placeholder"></div>').insertAfter(e).hide()),
                        e = e.show().detach(),
                        a.wrap.bind("onReset", function() {
                            f(this).find(e).length && e.hide().replaceAll(e.data("fancybox-placeholder")).data("fancybox-placeholder", !1)
                        }));
                        break;
                    case "image":
                        e = a.tpl.image.replace("{href}", g);
                        break;
                    case "swf":
                        e = '<object id="fancybox-swf" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="100%" height="100%"><param name="movie" value="' + g + '"></param>',
                        h = "",
                        f.each(a.swf, function(a, b) {
                            e += '<param name="' + a + '" value="' + b + '"></param>';
                            h += " " + a + '="' + b + '"'
                        }),
                        e += '<embed src="' + g + '" type="application/x-shockwave-flash" width="100%" height="100%"' + h + "></embed></object>"
                    }
                    (!t(e) || !e.parent().is(a.inner)) && a.inner.append(e);
                    b.trigger("beforeShow");
                    a.inner.css("overflow", "yes" === k ? "scroll" : "no" === k ? "hidden" : k);
                    b._setDimension();
                    b.reposition();
                    b.isOpen = !1;
                    b.coming = null;
                    b.bindEvents();
                    if (b.isOpened) {
                        if (d.prevMethod)
                            b.transitions[d.prevMethod]()
                    } else
                        f(".fancybox-wrap").not(a.wrap).stop(!0).trigger("onReset").remove();
                    b.transitions[b.isOpened ? a.nextMethod : a.openMethod]();
                    b._preloadImages()
                }
        },
        _setDimension: function() {
            var a = b.getViewport(), d = 0, e = !1, c = !1, e = b.wrap, k = b.skin, g = b.inner, h = b.current, c = h.width, j = h.height, m = h.minWidth, u = h.minHeight, n = h.maxWidth, p = h.maxHeight, s = h.scrolling, q = h.scrollOutside ? h.scrollbarWidth : 0, x = h.margin, y = l(x[1] + x[3]), r = l(x[0] + x[2]), v, z, t, C, A, F, B, D, H;
            e.add(k).add(g).width("auto").height("auto").removeClass("fancybox-tmp");
            x = l(k.outerWidth(!0) - k.width());
            v = l(k.outerHeight(!0) - k.height());
            z = y + x;
            t = r + v;
            C = E(c) ? (a.w - z) * l(c) / 100 : c;
            A = E(j) ? (a.h - t) * l(j) / 100 : j;
            if ("iframe" === h.type) {
                if (H = h.content,
                h.autoHeight && 1 === H.data("ready"))
                    try {
                        H[0].contentWindow.document.location && (g.width(C).height(9999),
                        F = H.contents().find("body"),
                        q && F.css("overflow-x", "hidden"),
                        A = F.outerHeight(!0))
                    } catch (G) {}
            } else if (h.autoWidth || h.autoHeight)
                g.addClass("fancybox-tmp"),
                h.autoWidth || g.width(C),
                h.autoHeight || g.height(A),
                h.autoWidth && (C = g.width()),
                h.autoHeight && (A = g.height()),
                g.removeClass("fancybox-tmp");
            c = l(C);
            j = l(A);
            D = C / A;
            m = l(E(m) ? l(m, "w") - z : m);
            n = l(E(n) ? l(n, "w") - z : n);
            u = l(E(u) ? l(u, "h") - t : u);
            p = l(E(p) ? l(p, "h") - t : p);
            F = n;
            B = p;
            h.fitToView && (n = Math.min(a.w - z, n),
            p = Math.min(a.h - t, p));
            z = a.w - y;
            r = a.h - r;
            h.aspectRatio ? (c > n && (c = n,
            j = l(c / D)),
            j > p && (j = p,
            c = l(j * D)),
            c < m && (c = m,
            j = l(c / D)),
            j < u && (j = u,
            c = l(j * D))) : (c = Math.max(m, Math.min(c, n)),
            h.autoHeight && "iframe" !== h.type && (g.width(c),
            j = g.height()),
            j = Math.max(u, Math.min(j, p)));
            if (h.fitToView)
                if (g.width(c).height(j),
                e.width(c + x),
                a = e.width(),
                y = e.height(),
                h.aspectRatio)
                    for (; (a > z || y > r) && (c > m && j > u) && !(19 < d++); )
                        j = Math.max(u, Math.min(p, j - 10)),
                        c = l(j * D),
                        c < m && (c = m,
                        j = l(c / D)),
                        c > n && (c = n,
                        j = l(c / D)),
                        g.width(c).height(j),
                        e.width(c + x),
                        a = e.width(),
                        y = e.height();
                else
                    c = Math.max(m, Math.min(c, c - (a - z))),
                    j = Math.max(u, Math.min(j, j - (y - r)));
            q && ("auto" === s && j < A && c + x + q < z) && (c += q);
            g.width(c).height(j);
            e.width(c + x);
            a = e.width();
            y = e.height();
            e = (a > z || y > r) && c > m && j > u;
            c = h.aspectRatio ? c < F && j < B && c < C && j < A : (c < F || j < B) && (c < C || j < A);
            f.extend(h, {
                dim: {
                    width: w(a),
                    height: w(y)
                },
                origWidth: C,
                origHeight: A,
                canShrink: e,
                canExpand: c,
                wPadding: x,
                hPadding: v,
                wrapSpace: y - k.outerHeight(!0),
                skinSpace: k.height() - j
            });
            !H && (h.autoHeight && j > u && j < p && !c) && g.height("auto")
        },
        _getPosition: function(a) {
            var d = b.current
              , e = b.getViewport()
              , c = d.margin
              , f = b.wrap.width() + c[1] + c[3]
              , g = b.wrap.height() + c[0] + c[2]
              , c = {
                position: "absolute",
                top: c[0],
                left: c[3]
            };
            d.autoCenter && d.fixed && !a && g <= e.h && f <= e.w ? c.position = "fixed" : d.locked || (c.top += e.y,
            c.left += e.x);
            c.top = w(Math.max(c.top, c.top + (e.h - g) * d.topRatio));
            c.left = w(Math.max(c.left, c.left + (e.w - f) * d.leftRatio));
            return c
        },
        _afterZoomIn: function() {
            var a = b.current;
            a && (b.isOpen = b.isOpened = !0,
            b.wrap.css("overflow", "visible").addClass("fancybox-opened"),
            b.update(),
            (a.closeClick || a.nextClick && 1 < b.group.length) && b.inner.css("cursor", "pointer").bind("click.fb", function(d) {
                !f(d.target).is("a") && !f(d.target).parent().is("a") && (d.preventDefault(),
                b[a.closeClick ? "close" : "next"]())
            }),
            a.closeBtn && f(a.tpl.closeBtn).appendTo(b.skin).bind("click.fb", function(a) {
                a.preventDefault();
                b.close()
            }),
            a.arrows && 1 < b.group.length && ((a.loop || 0 < a.index) && f(a.tpl.prev).appendTo(b.outer).bind("click.fb", b.prev),
            (a.loop || a.index < b.group.length - 1) && f(a.tpl.next).appendTo(b.outer).bind("click.fb", b.next)),
            b.trigger("afterShow"),
            !a.loop && a.index === a.group.length - 1 ? b.play(!1) : b.opts.autoPlay && !b.player.isActive && (b.opts.autoPlay = !1,
            b.play()))
        },
        _afterZoomOut: function(a) {
            a = a || b.current;
            f(".fancybox-wrap").trigger("onReset").remove();
            f.extend(b, {
                group: {},
                opts: {},
                router: !1,
                current: null,
                isActive: !1,
                isOpened: !1,
                isOpen: !1,
                isClosing: !1,
                wrap: null,
                skin: null,
                outer: null,
                inner: null
            });
            b.trigger("afterClose", a)
        }
    });
    b.transitions = {
        getOrigPosition: function() {
            var a = b.current
              , d = a.element
              , e = a.orig
              , c = {}
              , f = 50
              , g = 50
              , h = a.hPadding
              , j = a.wPadding
              , m = b.getViewport();
            !e && (a.isDom && d.is(":visible")) && (e = d.find("img:first"),
            e.length || (e = d));
            t(e) ? (c = e.offset(),
            e.is("img") && (f = e.outerWidth(),
            g = e.outerHeight())) : (c.top = m.y + (m.h - g) * a.topRatio,
            c.left = m.x + (m.w - f) * a.leftRatio);
            if ("fixed" === b.wrap.css("position") || a.locked)
                c.top -= m.y,
                c.left -= m.x;
            return c = {
                top: w(c.top - h * a.topRatio),
                left: w(c.left - j * a.leftRatio),
                width: w(f + j),
                height: w(g + h)
            }
        },
        step: function(a, d) {
            var e, c, f = d.prop;
            c = b.current;
            var g = c.wrapSpace
              , h = c.skinSpace;
            if ("width" === f || "height" === f)
                e = d.end === d.start ? 1 : (a - d.start) / (d.end - d.start),
                b.isClosing && (e = 1 - e),
                c = "width" === f ? c.wPadding : c.hPadding,
                c = a - c,
                b.skin[f](l("width" === f ? c : c - g * e)),
                b.inner[f](l("width" === f ? c : c - g * e - h * e))
        },
        zoomIn: function() {
            var a = b.current
              , d = a.pos
              , e = a.openEffect
              , c = "elastic" === e
              , k = f.extend({
                opacity: 1
            }, d);
            delete k.position;
            c ? (d = this.getOrigPosition(),
            a.openOpacity && (d.opacity = 0.1)) : "fade" === e && (d.opacity = 0.1);
            b.wrap.css(d).animate(k, {
                duration: "none" === e ? 0 : a.openSpeed,
                easing: a.openEasing,
                step: c ? this.step : null,
                complete: b._afterZoomIn
            })
        },
        zoomOut: function() {
            var a = b.current
              , d = a.closeEffect
              , e = "elastic" === d
              , c = {
                opacity: 0.1
            };
            e && (c = this.getOrigPosition(),
            a.closeOpacity && (c.opacity = 0.1));
            b.wrap.animate(c, {
                duration: "none" === d ? 0 : a.closeSpeed,
                easing: a.closeEasing,
                step: e ? this.step : null,
                complete: b._afterZoomOut
            })
        },
        changeIn: function() {
            var a = b.current, d = a.nextEffect, e = a.pos, c = {
                opacity: 1
            }, f = b.direction, g;
            e.opacity = 0.1;
            "elastic" === d && (g = "down" === f || "up" === f ? "top" : "left",
            "down" === f || "right" === f ? (e[g] = w(l(e[g]) - 200),
            c[g] = "+=200px") : (e[g] = w(l(e[g]) + 200),
            c[g] = "-=200px"));
            "none" === d ? b._afterZoomIn() : b.wrap.css(e).animate(c, {
                duration: a.nextSpeed,
                easing: a.nextEasing,
                complete: b._afterZoomIn
            })
        },
        changeOut: function() {
            var a = b.previous
              , d = a.prevEffect
              , e = {
                opacity: 0.1
            }
              , c = b.direction;
            "elastic" === d && (e["down" === c || "up" === c ? "top" : "left"] = ("up" === c || "left" === c ? "-" : "+") + "=200px");
            a.wrap.animate(e, {
                duration: "none" === d ? 0 : a.prevSpeed,
                easing: a.prevEasing,
                complete: function() {
                    f(this).trigger("onReset").remove()
                }
            })
        }
    };
    b.helpers.overlay = {
        defaults: {
            closeClick: !0,
            speedOut: 200,
            showEarly: !0,
            css: {},
            locked: !s,
            fixed: !0
        },
        overlay: null,
        fixed: !1,
        el: f("html"),
        create: function(a) {
            a = f.extend({}, this.defaults, a);
            this.overlay && this.close();
            this.overlay = f('<div class="fancybox-overlay"></div>').appendTo(b.coming ? b.coming.parent : a.parent);
            this.fixed = !1;
            a.fixed && b.defaults.fixed && (this.overlay.addClass("fancybox-overlay-fixed"),
            this.fixed = !0)
        },
        open: function(a) {
            var d = this;
            a = f.extend({}, this.defaults, a);
            this.overlay ? this.overlay.unbind(".overlay").width("auto").height("auto") : this.create(a);
            this.fixed || (n.bind("resize.overlay", f.proxy(this.update, this)),
            this.update());
            a.closeClick && this.overlay.bind("click.overlay", function(a) {
                if (f(a.target).hasClass("fancybox-overlay"))
                    return b.isActive ? b.close() : d.close(),
                    !1
            });
            this.overlay.css(a.css).show()
        },
        close: function() {
            var a, b;
            n.unbind("resize.overlay");
            this.el.hasClass("fancybox-lock") && (f(".fancybox-margin").removeClass("fancybox-margin"),
            a = n.scrollTop(),
            b = n.scrollLeft(),
            this.el.removeClass("fancybox-lock"),
            n.scrollTop(a).scrollLeft(b));
            f(".fancybox-overlay").remove().hide();
            f.extend(this, {
                overlay: null,
                fixed: !1
            })
        },
        update: function() {
            var a = "100%", b;
            this.overlay.width(a).height("100%");
            I ? (b = Math.max(G.documentElement.offsetWidth, G.body.offsetWidth),
            p.width() > b && (a = p.width())) : p.width() > n.width() && (a = p.width());
            this.overlay.width(a).height(p.height())
        },
        onReady: function(a, b) {
            var e = this.overlay;
            f(".fancybox-overlay").stop(!0, !0);
            e || this.create(a);
            a.locked && (this.fixed && b.fixed) && (e || (this.margin = p.height() > n.height() ? f("html").css("margin-right").replace("px", "") : !1),
            b.locked = this.overlay.append(b.wrap),
            b.fixed = !1);
            !0 === a.showEarly && this.beforeShow.apply(this, arguments)
        },
        beforeShow: function(a, b) {
            var e, c;
            b.locked && (!1 !== this.margin && (f("*").filter(function() {
                return "fixed" === f(this).css("position") && !f(this).hasClass("fancybox-overlay") && !f(this).hasClass("fancybox-wrap")
            }).addClass("fancybox-margin"),
            this.el.addClass("fancybox-margin")),
            e = n.scrollTop(),
            c = n.scrollLeft(),
            this.el.addClass("fancybox-lock"),
            n.scrollTop(e).scrollLeft(c));
            this.open(a)
        },
        onUpdate: function() {
            this.fixed || this.update()
        },
        afterClose: function(a) {
            this.overlay && !b.coming && this.overlay.fadeOut(a.speedOut, f.proxy(this.close, this))
        }
    };
    b.helpers.title = {
        defaults: {
            type: "float",
            position: "bottom"
        },
        beforeShow: function(a) {
            var d = b.current
              , e = d.title
              , c = a.type;
            f.isFunction(e) && (e = e.call(d.element, d));
            if (q(e) && "" !== f.trim(e)) {
                d = f('<div class="fancybox-title fancybox-title-' + c + '-wrap">' + e + "</div>");
                switch (c) {
                case "inside":
                    c = b.skin;
                    break;
                case "outside":
                    c = b.wrap;
                    break;
                case "over":
                    c = b.inner;
                    break;
                default:
                    c = b.skin,
                    d.appendTo("body"),
                    I && d.width(d.width()),
                    d.wrapInner('<span class="child"></span>'),
                    b.current.margin[2] += Math.abs(l(d.css("margin-bottom")))
                }
                d["top" === a.position ? "prependTo" : "appendTo"](c)
            }
        }
    };
    f.fn.fancybox = function(a) {
        var d, e = f(this), c = this.selector || "", k = function(g) {
            var h = f(this).blur(), j = d, k, l;
            !g.ctrlKey && (!g.altKey && !g.shiftKey && !g.metaKey) && !h.is(".fancybox-wrap") && (k = a.groupAttr || "data-fancybox-group",
            l = h.attr(k),
            l || (k = "rel",
            l = h.get(0)[k]),
            l && ("" !== l && "nofollow" !== l) && (h = c.length ? f(c) : e,
            h = h.filter("[" + k + '="' + l + '"]'),
            j = h.index(this)),
            a.index = j,
            !1 !== b.open(h, a) && g.preventDefault())
        };
        a = a || {};
        d = a.index || 0;
        !c || !1 === a.live ? e.unbind("click.fb-start").bind("click.fb-start", k) : p.undelegate(c, "click.fb-start").delegate(c + ":not('.fancybox-item, .fancybox-nav')", "click.fb-start", k);
        this.filter("[data-fancybox-start=1]").trigger("click");
        return this
    }
    ;
    p.ready(function() {
        var a, d;
        f.scrollbarWidth === v && (f.scrollbarWidth = function() {
            var a = f('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo("body")
              , b = a.children()
              , b = b.innerWidth() - b.height(99).innerWidth();
            a.remove();
            return b
        }
        );
        if (f.support.fixedPosition === v) {
            a = f.support;
            d = f('<div style="position:fixed;top:20px;"></div>').appendTo("body");
            var e = 20 === d[0].offsetTop || 15 === d[0].offsetTop;
            d.remove();
            a.fixedPosition = e
        }
        f.extend(b.defaults, {
            scrollbarWidth: f.scrollbarWidth(),
            fixed: f.support.fixedPosition,
            parent: f("body")
        });
        a = f(r).width();
        J.addClass("fancybox-lock-test");
        d = f(r).width();
        J.removeClass("fancybox-lock-test");
        f("<style type='text/css'>.fancybox-margin{margin-right:" + (d - a) + "px;}</style>").appendTo("head")
    })
}
)(window, document, jQuery);

var destroySlider = function(slider) {

    if (slider && slider.data('flexslider')) {
        var slider = slider.data('flexslider');
        var classNamespace = '.' + slider.vars.namespace;
        // Namespaced class selector
        if (slider.vars.controlNav)
            slider.controlNav.closest(classNamespace + 'control-nav').remove();
        // Remove control elements if present
        if (slider.vars.directionNav)
            slider.directionNav.closest(classNamespace + 'direction-nav').remove();
        // Remove direction-nav elements if present
        if (slider.vars.pausePlay)
            slider.pausePlay.closest(classNamespace + 'pauseplay').remove();
        // Remove pauseplay elements if present
        slider.find('.clone').remove();
        // Remove any flexslider clones
        slider.unbind(slider.vars.eventNamespace);
        // Remove events on slider
        if (slider.vars.animation != "fade")
            slider.container.unwrap();
        // Remove the .flex-viewport div
        slider.container.removeAttr('style')
        // Remove generated CSS (could collide with 3rd parties)
        slider.container.unbind(slider.vars.eventNamespace);
        // Remove events on slider
        slider.slides.removeAttr('style');
        // Remove generated CSS (could collide with 3rd parties)
        slider.slides.filter(classNamespace + 'active-slide').removeClass(slider.vars.namespace + 'active-slide');
        // Remove slide active class
        slider.slides.unbind(slider.vars.eventNamespace);
        // Remove events on slides
        $(document).unbind(slider.vars.eventNamespace + "-" + slider.id);
        // Remove events from document for this instance only
        $(window).unbind(slider.vars.eventNamespace + "-" + slider.id);
        // Remove events from window for this instance only
        slider.stop();
        // Stop the interval
        slider.removeData('flexslider');
        // Remove data
    }
}

/*
 * jQuery FlexSlider v2.7.1
 * Copyright 2012 WooThemes
 * Contributing Author: Tyler Smith
 */
!function($) {
    var e = !0;
    $.flexslider = function(t, a) {
        var n = $(t);
        void 0 === a.rtl && "rtl" == $("html").attr("dir") && (a.rtl = !0),
        n.vars = $.extend({}, $.flexslider.defaults, a);
        var i = n.vars.namespace, r = window.navigator && window.navigator.msPointerEnabled && window.MSGesture, s = ("ontouchstart"in window || r || window.DocumentTouch && document instanceof DocumentTouch) && n.vars.touch, o = "click touchend MSPointerUp keyup", l = "", c, d = "vertical" === n.vars.direction, u = n.vars.reverse, v = n.vars.itemWidth > 0, p = "fade" === n.vars.animation, m = "" !== n.vars.asNavFor, f = {};
        $.data(t, "flexslider", n),
        f = {
            init: function() {
                n.animating = !1,
                n.currentSlide = parseInt(n.vars.startAt ? n.vars.startAt : 0, 10),
                isNaN(n.currentSlide) && (n.currentSlide = 0),
                n.animatingTo = n.currentSlide,
                n.atEnd = 0 === n.currentSlide || n.currentSlide === n.last,
                n.containerSelector = n.vars.selector.substr(0, n.vars.selector.search(" ")),
                n.slides = $(n.vars.selector, n),
                n.container = $(n.containerSelector, n),
                n.count = n.slides.length,
                n.syncExists = $(n.vars.sync).length > 0,
                "slide" === n.vars.animation && (n.vars.animation = "swing"),
                n.prop = d ? "top" : n.vars.rtl ? "marginRight" : "marginLeft",
                n.args = {},
                n.manualPause = !1,
                n.stopped = !1,
                n.started = !1,
                n.startTimeout = null,
                n.transitions = !n.vars.video && !p && n.vars.useCSS && function() {
                    var e = document.createElement("div")
                      , t = ["perspectiveProperty", "WebkitPerspective", "MozPerspective", "OPerspective", "msPerspective"];
                    for (var a in t)
                        if (void 0 !== e.style[t[a]])
                            return n.pfx = t[a].replace("Perspective", "").toLowerCase(),
                            n.prop = "-" + n.pfx + "-transform",
                            !0;
                    return !1
                }(),
                n.isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1,
                n.ensureAnimationEnd = "",
                "" !== n.vars.controlsContainer && (n.controlsContainer = $(n.vars.controlsContainer).length > 0 && $(n.vars.controlsContainer)),
                "" !== n.vars.manualControls && (n.manualControls = $(n.vars.manualControls).length > 0 && $(n.vars.manualControls)),
                "" !== n.vars.customDirectionNav && (n.customDirectionNav = 2 === $(n.vars.customDirectionNav).length && $(n.vars.customDirectionNav)),
                n.vars.randomize && (n.slides.sort(function() {
                    return Math.round(Math.random()) - .5
                }),
                n.container.empty().append(n.slides)),
                n.doMath(),
                n.setup("init"),
                n.vars.controlNav && f.controlNav.setup(),
                n.vars.directionNav && f.directionNav.setup(),
                n.vars.keyboard && (1 === $(n.containerSelector).length || n.vars.multipleKeyboard) && $(document).bind("keyup", function(e) {
                    var t = e.keyCode;
                    if (!n.animating && (39 === t || 37 === t)) {
                        var a = n.vars.rtl ? 37 === t ? n.getTarget("next") : 39 === t && n.getTarget("prev") : 39 === t ? n.getTarget("next") : 37 === t && n.getTarget("prev");
                        n.flexAnimate(a, n.vars.pauseOnAction)
                    }
                }),
                n.vars.mousewheel && n.bind("mousewheel", function(e, t, a, i) {
                    e.preventDefault();
                    var r = t < 0 ? n.getTarget("next") : n.getTarget("prev");
                    n.flexAnimate(r, n.vars.pauseOnAction)
                }),
                n.vars.pausePlay && f.pausePlay.setup(),
                n.vars.slideshow && n.vars.pauseInvisible && f.pauseInvisible.init(),
                n.vars.slideshow && (n.vars.pauseOnHover && n.hover(function() {
                    n.manualPlay || n.manualPause || n.pause()
                }, function() {
                    n.manualPause || n.manualPlay || n.stopped || n.play()
                }),
                n.vars.pauseInvisible && f.pauseInvisible.isHidden() || (n.vars.initDelay > 0 ? n.startTimeout = setTimeout(n.play, n.vars.initDelay) : n.play())),
                m && f.asNav.setup(),
                s && n.vars.touch && f.touch(),
                (!p || p && n.vars.smoothHeight) && $(window).bind("resize orientationchange focus", f.resize),
                n.find("img").attr("draggable", "false"),
                setTimeout(function() {
                    n.vars.start(n)
                }, 200)
            },
            asNav: {
                setup: function() {
                    n.asNav = !0,
                    n.animatingTo = Math.floor(n.currentSlide / n.move),
                    n.currentItem = n.currentSlide,
                    n.slides.removeClass(i + "active-slide").eq(n.currentItem).addClass(i + "active-slide"),
                    r ? (t._slider = n,
                    n.slides.each(function() {
                        var e = this;
                        e._gesture = new MSGesture,
                        e._gesture.target = e,
                        e.addEventListener("MSPointerDown", function(e) {
                            e.preventDefault(),
                            e.currentTarget._gesture && e.currentTarget._gesture.addPointer(e.pointerId)
                        }, !1),
                        e.addEventListener("MSGestureTap", function(e) {
                            e.preventDefault();
                            var t = $(this)
                              , a = t.index();
                            $(n.vars.asNavFor).data("flexslider").animating || t.hasClass("active") || (n.direction = n.currentItem < a ? "next" : "prev",
                            n.flexAnimate(a, n.vars.pauseOnAction, !1, !0, !0))
                        })
                    })) : n.slides.on(o, function(e) {
                        e.preventDefault();
                        var t = $(this), a = t.index(), r;
                        r = n.vars.rtl ? -1 * (t.offset().right - $(n).scrollLeft()) : t.offset().left - $(n).scrollLeft(),
                        r <= 0 && t.hasClass(i + "active-slide") ? n.flexAnimate(n.getTarget("prev"), !0) : $(n.vars.asNavFor).data("flexslider").animating || t.hasClass(i + "active-slide") || (n.direction = n.currentItem < a ? "next" : "prev",
                        n.flexAnimate(a, n.vars.pauseOnAction, !1, !0, !0))
                    })
                }
            },
            controlNav: {
                setup: function() {
                    n.manualControls ? f.controlNav.setupManual() : f.controlNav.setupPaging()
                },
                setupPaging: function() {
                    var e = "thumbnails" === n.vars.controlNav ? "control-thumbs" : "control-paging", t = 1, a, r;
                    if (n.controlNavScaffold = $('<ol class="' + i + "control-nav " + i + e + '"></ol>'),
                    n.pagingCount > 1)
                        for (var s = 0; s < n.pagingCount; s++) {
                            r = n.slides.eq(s),
                            void 0 === r.attr("data-thumb-alt") && r.attr("data-thumb-alt", "");
                            var c = "" !== r.attr("data-thumb-alt") ? c = ' alt="' + r.attr("data-thumb-alt") + '"' : "";
                            if (a = "thumbnails" === n.vars.controlNav ? '<img src="' + r.attr("data-thumb") + '"' + c + "/>" : '<a href="#">' + t + "</a>",
                            "thumbnails" === n.vars.controlNav && !0 === n.vars.thumbCaptions) {
                                var d = r.attr("data-thumbcaption");
                                "" !== d && void 0 !== d && (a += '<span class="' + i + 'caption">' + d + "</span>")
                            }
                            n.controlNavScaffold.append("<li>" + a + "</li>"),
                            t++
                        }
                    n.controlsContainer ? $(n.controlsContainer).append(n.controlNavScaffold) : n.append(n.controlNavScaffold),
                    f.controlNav.set(),
                    f.controlNav.active(),
                    n.controlNavScaffold.delegate("a, img", o, function(e) {
                        if (e.preventDefault(),
                        "" === l || l === e.type) {
                            var t = $(this)
                              , a = n.controlNav.index(t);
                            t.hasClass(i + "active") || (n.direction = a > n.currentSlide ? "next" : "prev",
                            n.flexAnimate(a, n.vars.pauseOnAction))
                        }
                        "" === l && (l = e.type),
                        f.setToClearWatchedEvent()
                    })
                },
                setupManual: function() {
                    n.controlNav = n.manualControls,
                    f.controlNav.active(),
                    n.controlNav.bind(o, function(e) {
                        if (e.preventDefault(),
                        "" === l || l === e.type) {
                            var t = $(this)
                              , a = n.controlNav.index(t);
                            t.hasClass(i + "active") || (a > n.currentSlide ? n.direction = "next" : n.direction = "prev",
                            n.flexAnimate(a, n.vars.pauseOnAction))
                        }
                        "" === l && (l = e.type),
                        f.setToClearWatchedEvent()
                    })
                },
                set: function() {
                    var e = "thumbnails" === n.vars.controlNav ? "img" : "a";
                    n.controlNav = $("." + i + "control-nav li " + e, n.controlsContainer ? n.controlsContainer : n)
                },
                active: function() {
                    n.controlNav.removeClass(i + "active").eq(n.animatingTo).addClass(i + "active")
                },
                update: function(e, t) {
                    n.pagingCount > 1 && "add" === e ? n.controlNavScaffold.append($('<li><a href="#">' + n.count + "</a></li>")) : 1 === n.pagingCount ? n.controlNavScaffold.find("li").remove() : n.controlNav.eq(t).closest("li").remove(),
                    f.controlNav.set(),
                    n.pagingCount > 1 && n.pagingCount !== n.controlNav.length ? n.update(t, e) : f.controlNav.active()
                }
            },
            directionNav: {
                setup: function() {
                    var e = $('<ul class="' + i + 'direction-nav"><li class="' + i + 'nav-prev"><a class="' + i + 'prev" href="#">' + n.vars.prevText + '</a></li><li class="' + i + 'nav-next"><a class="' + i + 'next" href="#">' + n.vars.nextText + "</a></li></ul>");
                    n.customDirectionNav ? n.directionNav = n.customDirectionNav : n.controlsContainer ? ($(n.controlsContainer).append(e),
                    n.directionNav = $("." + i + "direction-nav li a", n.controlsContainer)) : (n.append(e),
                    n.directionNav = $("." + i + "direction-nav li a", n)),
                    f.directionNav.update(),
                    n.directionNav.bind(o, function(e) {
                        e.preventDefault();
                        var t;
                        "" !== l && l !== e.type || (t = $(this).hasClass(i + "next") ? n.getTarget("next") : n.getTarget("prev"),
                        n.flexAnimate(t, n.vars.pauseOnAction)),
                        "" === l && (l = e.type),
                        f.setToClearWatchedEvent()
                    })
                },
                update: function() {
                    var e = i + "disabled";
                    1 === n.pagingCount ? n.directionNav.addClass(e).attr("tabindex", "-1") : n.vars.animationLoop ? n.directionNav.removeClass(e).removeAttr("tabindex") : 0 === n.animatingTo ? n.directionNav.removeClass(e).filter("." + i + "prev").addClass(e).attr("tabindex", "-1") : n.animatingTo === n.last ? n.directionNav.removeClass(e).filter("." + i + "next").addClass(e).attr("tabindex", "-1") : n.directionNav.removeClass(e).removeAttr("tabindex")
                }
            },
            pausePlay: {
                setup: function() {
                    var e = $('<div class="' + i + 'pauseplay"><a href="#"></a></div>');
                    n.controlsContainer ? (n.controlsContainer.append(e),
                    n.pausePlay = $("." + i + "pauseplay a", n.controlsContainer)) : (n.append(e),
                    n.pausePlay = $("." + i + "pauseplay a", n)),
                    f.pausePlay.update(n.vars.slideshow ? i + "pause" : i + "play"),
                    n.pausePlay.bind(o, function(e) {
                        e.preventDefault(),
                        "" !== l && l !== e.type || ($(this).hasClass(i + "pause") ? (n.manualPause = !0,
                        n.manualPlay = !1,
                        n.pause()) : (n.manualPause = !1,
                        n.manualPlay = !0,
                        n.play())),
                        "" === l && (l = e.type),
                        f.setToClearWatchedEvent()
                    })
                },
                update: function(e) {
                    "play" === e ? n.pausePlay.removeClass(i + "pause").addClass(i + "play").html(n.vars.playText) : n.pausePlay.removeClass(i + "play").addClass(i + "pause").html(n.vars.pauseText)
                }
            },
            touch: function() {
                function e(e) {
                    e.stopPropagation(),
                    n.animating ? e.preventDefault() : (n.pause(),
                    t._gesture.addPointer(e.pointerId),
                    w = 0,
                    c = d ? n.h : n.w,
                    f = Number(new Date),
                    l = v && u && n.animatingTo === n.last ? 0 : v && u ? n.limit - (n.itemW + n.vars.itemMargin) * n.move * n.animatingTo : v && n.currentSlide === n.last ? n.limit : v ? (n.itemW + n.vars.itemMargin) * n.move * n.currentSlide : u ? (n.last - n.currentSlide + n.cloneOffset) * c : (n.currentSlide + n.cloneOffset) * c)
                }
                function a(e) {
                    e.stopPropagation();
                    var a = e.target._slider;
                    if (a) {
                        var n = -e.translationX
                          , i = -e.translationY;
                        if (w += d ? i : n,
                        m = (a.vars.rtl ? -1 : 1) * w,
                        x = d ? Math.abs(w) < Math.abs(-n) : Math.abs(w) < Math.abs(-i),
                        e.detail === e.MSGESTURE_FLAG_INERTIA)
                            return void setImmediate(function() {
                                t._gesture.stop()
                            });
                        (!x || Number(new Date) - f > 500) && (e.preventDefault(),
                        !p && a.transitions && (a.vars.animationLoop || (m = w / (0 === a.currentSlide && w < 0 || a.currentSlide === a.last && w > 0 ? Math.abs(w) / c + 2 : 1)),
                        a.setProps(l + m, "setTouch")))
                    }
                }
                function i(e) {
                    e.stopPropagation();
                    var t = e.target._slider;
                    if (t) {
                        if (t.animatingTo === t.currentSlide && !x && null !== m) {
                            var a = u ? -m : m
                              , n = a > 0 ? t.getTarget("next") : t.getTarget("prev");
                            t.canAdvance(n) && (Number(new Date) - f < 550 && Math.abs(a) > 50 || Math.abs(a) > c / 2) ? t.flexAnimate(n, t.vars.pauseOnAction) : p || t.flexAnimate(t.currentSlide, t.vars.pauseOnAction, !0)
                        }
                        s = null,
                        o = null,
                        m = null,
                        l = null,
                        w = 0
                    }
                }
                var s, o, l, c, m, f, g, h, S, x = !1, y = 0, b = 0, w = 0;
                r ? (t.style.msTouchAction = "none",
                t._gesture = new MSGesture,
                t._gesture.target = t,
                t.addEventListener("MSPointerDown", e, !1),
                t._slider = n,
                t.addEventListener("MSGestureChange", a, !1),
                t.addEventListener("MSGestureEnd", i, !1)) : (g = function(e) {
                    n.animating ? e.preventDefault() : (window.navigator.msPointerEnabled || 1 === e.touches.length) && (n.pause(),
                    c = d ? n.h : n.w,
                    f = Number(new Date),
                    y = e.touches[0].pageX,
                    b = e.touches[0].pageY,
                    l = v && u && n.animatingTo === n.last ? 0 : v && u ? n.limit - (n.itemW + n.vars.itemMargin) * n.move * n.animatingTo : v && n.currentSlide === n.last ? n.limit : v ? (n.itemW + n.vars.itemMargin) * n.move * n.currentSlide : u ? (n.last - n.currentSlide + n.cloneOffset) * c : (n.currentSlide + n.cloneOffset) * c,
                    s = d ? b : y,
                    o = d ? y : b,
                    t.addEventListener("touchmove", h, !1),
                    t.addEventListener("touchend", S, !1))
                }
                ,
                h = function(e) {
                    y = e.touches[0].pageX,
                    b = e.touches[0].pageY,
                    m = d ? s - b : (n.vars.rtl ? -1 : 1) * (s - y),
                    x = d ? Math.abs(m) < Math.abs(y - o) : Math.abs(m) < Math.abs(b - o);
                    var t = 500;
                    (!x || Number(new Date) - f > 500) && (e.preventDefault(),
                    !p && n.transitions && (n.vars.animationLoop || (m /= 0 === n.currentSlide && m < 0 || n.currentSlide === n.last && m > 0 ? Math.abs(m) / c + 2 : 1),
                    n.setProps(l + m, "setTouch")))
                }
                ,
                S = function(e) {
                    if (t.removeEventListener("touchmove", h, !1),
                    n.animatingTo === n.currentSlide && !x && null !== m) {
                        var a = u ? -m : m
                          , i = a > 0 ? n.getTarget("next") : n.getTarget("prev");
                        n.canAdvance(i) && (Number(new Date) - f < 550 && Math.abs(a) > 50 || Math.abs(a) > c / 2) ? n.flexAnimate(i, n.vars.pauseOnAction) : p || n.flexAnimate(n.currentSlide, n.vars.pauseOnAction, !0)
                    }
                    t.removeEventListener("touchend", S, !1),
                    s = null,
                    o = null,
                    m = null,
                    l = null
                }
                ,
                t.addEventListener("touchstart", g, !1))
            },
            resize: function() {
                !n.animating && n.is(":visible") && (v || n.doMath(),
                p ? f.smoothHeight() : v ? (n.slides.width(n.computedW),
                n.update(n.pagingCount),
                n.setProps()) : d ? (n.viewport.height(n.h),
                n.setProps(n.h, "setTotal")) : (n.vars.smoothHeight && f.smoothHeight(),
                n.newSlides.width(n.computedW),
                n.setProps(n.computedW, "setTotal")))
            },
            smoothHeight: function(e) {
                if (!d || p) {
                    var t = p ? n : n.viewport;
                    e ? t.animate({
                        height: n.slides.eq(n.animatingTo).innerHeight()
                    }, e) : t.innerHeight(n.slides.eq(n.animatingTo).innerHeight())
                }
            },
            sync: function(e) {
                var t = $(n.vars.sync).data("flexslider")
                  , a = n.animatingTo;
                switch (e) {
                case "animate":
                    t.flexAnimate(a, n.vars.pauseOnAction, !1, !0);
                    break;
                case "play":
                    t.playing || t.asNav || t.play();
                    break;
                case "pause":
                    t.pause();
                    break
                }
            },
            uniqueID: function(e) {
                return e.filter("[id]").add(e.find("[id]")).each(function() {
                    var e = $(this);
                    e.attr("id", e.attr("id") + "_clone")
                }),
                e
            },
            pauseInvisible: {
                visProp: null,
                init: function() {
                    var e = f.pauseInvisible.getHiddenProp();
                    if (e) {
                        var t = e.replace(/[H|h]idden/, "") + "visibilitychange";
                        document.addEventListener(t, function() {
                            f.pauseInvisible.isHidden() ? n.startTimeout ? clearTimeout(n.startTimeout) : n.pause() : n.started ? n.play() : n.vars.initDelay > 0 ? setTimeout(n.play, n.vars.initDelay) : n.play()
                        })
                    }
                },
                isHidden: function() {
                    var e = f.pauseInvisible.getHiddenProp();
                    return !!e && document[e]
                },
                getHiddenProp: function() {
                    var e = ["webkit", "moz", "ms", "o"];
                    if ("hidden"in document)
                        return "hidden";
                    for (var t = 0; t < e.length; t++)
                        if (e[t] + "Hidden"in document)
                            return e[t] + "Hidden";
                    return null
                }
            },
            setToClearWatchedEvent: function() {
                clearTimeout(c),
                c = setTimeout(function() {
                    l = ""
                }, 3e3)
            }
        },
        n.flexAnimate = function(e, t, a, r, o) {
            if (n.vars.animationLoop || e === n.currentSlide || (n.direction = e > n.currentSlide ? "next" : "prev"),
            m && 1 === n.pagingCount && (n.direction = n.currentItem < e ? "next" : "prev"),
            !n.animating && (n.canAdvance(e, o) || a) && n.is(":visible")) {
                if (m && r) {
                    var l = $(n.vars.asNavFor).data("flexslider");
                    if (n.atEnd = 0 === e || e === n.count - 1,
                    l.flexAnimate(e, !0, !1, !0, o),
                    n.direction = n.currentItem < e ? "next" : "prev",
                    l.direction = n.direction,
                    Math.ceil((e + 1) / n.visible) - 1 === n.currentSlide || 0 === e)
                        return n.currentItem = e,
                        n.slides.removeClass(i + "active-slide").eq(e).addClass(i + "active-slide"),
                        !1;
                    n.currentItem = e,
                    n.slides.removeClass(i + "active-slide").eq(e).addClass(i + "active-slide"),
                    e = Math.floor(e / n.visible)
                }
                if (n.animating = !0,
                n.animatingTo = e,
                t && n.pause(),
                n.vars.before(n),
                n.syncExists && !o && f.sync("animate"),
                n.vars.controlNav && f.controlNav.active(),
                v || n.slides.removeClass(i + "active-slide").eq(e).addClass(i + "active-slide"),
                n.atEnd = 0 === e || e === n.last,
                n.vars.directionNav && f.directionNav.update(),
                e === n.last && (n.vars.end(n),
                n.vars.animationLoop || n.pause()),
                p)
                    s ? (n.slides.eq(n.currentSlide).css({
                        opacity: 0,
                        zIndex: 1
                    }),
                    n.slides.eq(e).css({
                        opacity: 1,
                        zIndex: 2
                    }),
                    n.wrapup(c)) : (n.slides.eq(n.currentSlide).css({
                        zIndex: 1
                    }).animate({
                        opacity: 0
                    }, n.vars.animationSpeed, n.vars.easing),
                    n.slides.eq(e).css({
                        zIndex: 2
                    }).animate({
                        opacity: 1
                    }, n.vars.animationSpeed, n.vars.easing, n.wrapup));
                else {
                    var c = d ? n.slides.filter(":first").height() : n.computedW, g, h, S;
                    v ? (g = n.vars.itemMargin,
                    S = (n.itemW + g) * n.move * n.animatingTo,
                    h = S > n.limit && 1 !== n.visible ? n.limit : S) : h = 0 === n.currentSlide && e === n.count - 1 && n.vars.animationLoop && "next" !== n.direction ? u ? (n.count + n.cloneOffset) * c : 0 : n.currentSlide === n.last && 0 === e && n.vars.animationLoop && "prev" !== n.direction ? u ? 0 : (n.count + 1) * c : u ? (n.count - 1 - e + n.cloneOffset) * c : (e + n.cloneOffset) * c,
                    n.setProps(h, "", n.vars.animationSpeed),
                    n.transitions ? (n.vars.animationLoop && n.atEnd || (n.animating = !1,
                    n.currentSlide = n.animatingTo),
                    n.container.unbind("webkitTransitionEnd transitionend"),
                    n.container.bind("webkitTransitionEnd transitionend", function() {
                        clearTimeout(n.ensureAnimationEnd),
                        n.wrapup(c)
                    }),
                    clearTimeout(n.ensureAnimationEnd),
                    n.ensureAnimationEnd = setTimeout(function() {
                        n.wrapup(c)
                    }, n.vars.animationSpeed + 100)) : n.container.animate(n.args, n.vars.animationSpeed, n.vars.easing, function() {
                        n.wrapup(c)
                    })
                }
                n.vars.smoothHeight && f.smoothHeight(n.vars.animationSpeed)
            }
        }
        ,
        n.wrapup = function(e) {
            p || v || (0 === n.currentSlide && n.animatingTo === n.last && n.vars.animationLoop ? n.setProps(e, "jumpEnd") : n.currentSlide === n.last && 0 === n.animatingTo && n.vars.animationLoop && n.setProps(e, "jumpStart")),
            n.animating = !1,
            n.currentSlide = n.animatingTo,
            n.vars.after(n)
        }
        ,
        n.animateSlides = function() {
            !n.animating && e && n.flexAnimate(n.getTarget("next"))
        }
        ,
        n.pause = function() {
            clearInterval(n.animatedSlides),
            n.animatedSlides = null,
            n.playing = !1,
            n.vars.pausePlay && f.pausePlay.update("play"),
            n.syncExists && f.sync("pause")
        }
        ,
        n.play = function() {
            n.playing && clearInterval(n.animatedSlides),
            n.animatedSlides = n.animatedSlides || setInterval(n.animateSlides, n.vars.slideshowSpeed),
            n.started = n.playing = !0,
            n.vars.pausePlay && f.pausePlay.update("pause"),
            n.syncExists && f.sync("play")
        }
        ,
        n.stop = function() {
            n.pause(),
            n.stopped = !0
        }
        ,
        n.canAdvance = function(e, t) {
            var a = m ? n.pagingCount - 1 : n.last;
            return !!t || (!(!m || n.currentItem !== n.count - 1 || 0 !== e || "prev" !== n.direction) || (!m || 0 !== n.currentItem || e !== n.pagingCount - 1 || "next" === n.direction) && (!(e === n.currentSlide && !m) && (!!n.vars.animationLoop || (!n.atEnd || 0 !== n.currentSlide || e !== a || "next" === n.direction) && (!n.atEnd || n.currentSlide !== a || 0 !== e || "next" !== n.direction))))
        }
        ,
        n.getTarget = function(e) {
            return n.direction = e,
            "next" === e ? n.currentSlide === n.last ? 0 : n.currentSlide + 1 : 0 === n.currentSlide ? n.last : n.currentSlide - 1
        }
        ,
        n.setProps = function(e, t, a) {
            var i = function() {
                var a = e || (n.itemW + n.vars.itemMargin) * n.move * n.animatingTo;
                return function() {
                    if (v)
                        return "setTouch" === t ? e : u && n.animatingTo === n.last ? 0 : u ? n.limit - (n.itemW + n.vars.itemMargin) * n.move * n.animatingTo : n.animatingTo === n.last ? n.limit : a;
                    switch (t) {
                    case "setTotal":
                        return u ? (n.count - 1 - n.currentSlide + n.cloneOffset) * e : (n.currentSlide + n.cloneOffset) * e;
                    case "setTouch":
                        return e;
                    case "jumpEnd":
                        return u ? e : n.count * e;
                    case "jumpStart":
                        return u ? n.count * e : e;
                    default:
                        return e
                    }
                }() * (n.vars.rtl ? 1 : -1) + "px"
            }();
            n.transitions && (i = n.isFirefox ? d ? "translate3d(0," + i + ",0)" : "translate3d(" + parseInt(i) + "px,0,0)" : d ? "translate3d(0," + i + ",0)" : "translate3d(" + (n.vars.rtl ? -1 : 1) * parseInt(i) + "px,0,0)",
            a = void 0 !== a ? a / 1e3 + "s" : "0s",
            n.container.css("-" + n.pfx + "-transition-duration", a),
            n.container.css("transition-duration", a)),
            n.args[n.prop] = i,
            (n.transitions || void 0 === a) && n.container.css(n.args),
            n.container.css("transform", i)
        }
        ,
        n.setup = function(e) {
            if (p)
                n.vars.rtl ? n.slides.css({
                    width: "100%",
                    float: "right",
                    marginLeft: "-100%",
                    position: "relative"
                }) : n.slides.css({
                    width: "100%",
                    float: "left",
                    marginRight: "-100%",
                    position: "relative"
                }),
                "init" === e && (s ? n.slides.css({
                    opacity: 0,
                    display: "block",
                    webkitTransition: "opacity " + n.vars.animationSpeed / 1e3 + "s ease",
                    zIndex: 1
                }).eq(n.currentSlide).css({
                    opacity: 1,
                    zIndex: 2
                }) : 0 == n.vars.fadeFirstSlide ? n.slides.css({
                    opacity: 0,
                    display: "block",
                    zIndex: 1
                }).eq(n.currentSlide).css({
                    zIndex: 2
                }).css({
                    opacity: 1
                }) : n.slides.css({
                    opacity: 0,
                    display: "block",
                    zIndex: 1
                }).eq(n.currentSlide).css({
                    zIndex: 2
                }).animate({
                    opacity: 1
                }, n.vars.animationSpeed, n.vars.easing)),
                n.vars.smoothHeight && f.smoothHeight();
            else {
                var t, a;
                "init" === e && (n.viewport = $('<div class="' + i + 'viewport"></div>').css({
                    overflow: "hidden",
                    position: "relative"
                }).appendTo(n).append(n.container),
                n.cloneCount = 0,
                n.cloneOffset = 0,
                u && (a = $.makeArray(n.slides).reverse(),
                n.slides = $(a),
                n.container.empty().append(n.slides))),
                n.vars.animationLoop && !v && (n.cloneCount = 2,
                n.cloneOffset = 1,
                "init" !== e && n.container.find(".clone").remove(),
                n.container.append(f.uniqueID(n.slides.first().clone().addClass("clone")).attr("aria-hidden", "true")).prepend(f.uniqueID(n.slides.last().clone().addClass("clone")).attr("aria-hidden", "true"))),
                n.newSlides = $(n.vars.selector, n),
                t = u ? n.count - 1 - n.currentSlide + n.cloneOffset : n.currentSlide + n.cloneOffset,
                d && !v ? (n.container.height(200 * (n.count + n.cloneCount) + "%").css("position", "absolute").width("100%"),
                setTimeout(function() {
                    n.newSlides.css({
                        display: "block"
                    }),
                    n.doMath(),
                    n.viewport.height(n.h),
                    n.setProps(t * n.h, "init")
                }, "init" === e ? 100 : 0)) : (n.container.width(200 * (n.count + n.cloneCount) + "%"),
                n.setProps(t * n.computedW, "init"),
                setTimeout(function() {
                    n.doMath(),
                    n.vars.rtl && n.isFirefox ? n.newSlides.css({
                        width: n.computedW,
                        marginRight: n.computedM,
                        float: "right",
                        display: "block"
                    }) : n.newSlides.css({
                        width: n.computedW,
                        marginRight: n.computedM,
                        float: "left",
                        display: "block"
                    }),
                    n.vars.smoothHeight && f.smoothHeight()
                }, "init" === e ? 100 : 0))
            }
            v || n.slides.removeClass(i + "active-slide").eq(n.currentSlide).addClass(i + "active-slide"),
            n.vars.init(n)
        }
        ,
        n.doMath = function() {
            var e = n.slides.first()
              , t = n.vars.itemMargin
              , a = n.vars.minItems
              , i = n.vars.maxItems;
            n.w = void 0 === n.viewport ? n.width() : n.viewport.width(),
            n.isFirefox && (n.w = n.width()),
            n.h = e.height(),
            n.boxPadding = e.outerWidth() - e.width(),
            v ? (n.itemT = n.vars.itemWidth + t,
            n.itemM = t,
            n.minW = a ? a * n.itemT : n.w,
            n.maxW = i ? i * n.itemT - t : n.w,
            n.itemW = n.minW > n.w ? (n.w - t * (a - 1)) / a : n.maxW < n.w ? (n.w - t * (i - 1)) / i : n.vars.itemWidth > n.w ? n.w : n.vars.itemWidth,
            n.visible = Math.floor(n.w / n.itemW),
            n.move = n.vars.move > 0 && n.vars.move < n.visible ? n.vars.move : n.visible,
            n.pagingCount = Math.ceil((n.count - n.visible) / n.move + 1),
            n.last = n.pagingCount - 1,
            n.limit = 1 === n.pagingCount ? 0 : n.vars.itemWidth > n.w ? n.itemW * (n.count - 1) + t * (n.count - 1) : (n.itemW + t) * n.count - n.w - t) : (n.itemW = n.w,
            n.itemM = t,
            n.pagingCount = n.count,
            n.last = n.count - 1),
            n.computedW = n.itemW - n.boxPadding,
            n.computedM = n.itemM
        }
        ,
        n.update = function(e, t) {
            n.doMath(),
            v || (e < n.currentSlide ? n.currentSlide += 1 : e <= n.currentSlide && 0 !== e && (n.currentSlide -= 1),
            n.animatingTo = n.currentSlide),
            n.vars.controlNav && !n.manualControls && ("add" === t && !v || n.pagingCount > n.controlNav.length ? f.controlNav.update("add") : ("remove" === t && !v || n.pagingCount < n.controlNav.length) && (v && n.currentSlide > n.last && (n.currentSlide -= 1,
            n.animatingTo -= 1),
            f.controlNav.update("remove", n.last))),
            n.vars.directionNav && f.directionNav.update()
        }
        ,
        n.addSlide = function(e, t) {
            var a = $(e);
            n.count += 1,
            n.last = n.count - 1,
            d && u ? void 0 !== t ? n.slides.eq(n.count - t).after(a) : n.container.prepend(a) : void 0 !== t ? n.slides.eq(t).before(a) : n.container.append(a),
            n.update(t, "add"),
            n.slides = $(n.vars.selector + ":not(.clone)", n),
            n.setup(),
            n.vars.added(n)
        }
        ,
        n.removeSlide = function(e) {
            var t = isNaN(e) ? n.slides.index($(e)) : e;
            n.count -= 1,
            n.last = n.count - 1,
            isNaN(e) ? $(e, n.slides).remove() : d && u ? n.slides.eq(n.last).remove() : n.slides.eq(e).remove(),
            n.doMath(),
            n.update(t, "remove"),
            n.slides = $(n.vars.selector + ":not(.clone)", n),
            n.setup(),
            n.vars.removed(n)
        }
        ,
        f.init()
    }
    ,
    $(window).blur(function(t) {
        e = !1
    }).focus(function(t) {
        e = !0
    }),
    $.flexslider.defaults = {
        namespace: "flex-",
        selector: ".slides > li",
        animation: "fade",
        easing: "swing",
        direction: "horizontal",
        reverse: !1,
        animationLoop: !0,
        smoothHeight: !1,
        startAt: 0,
        slideshow: !0,
        slideshowSpeed: 7e3,
        animationSpeed: 600,
        initDelay: 0,
        randomize: !1,
        fadeFirstSlide: !0,
        thumbCaptions: !1,
        pauseOnAction: !0,
        pauseOnHover: !1,
        pauseInvisible: !0,
        useCSS: !0,
        touch: !0,
        video: !1,
        controlNav: !0,
        directionNav: !0,
        prevText: "<span class='icon-arrow-left'></span>",
        nextText: "<span class='icon-arrow-right'></span>",
        keyboard: !0,
        multipleKeyboard: !1,
        mousewheel: !1,
        pausePlay: !1,
        pauseText: "Pause",
        playText: "Play",
        controlsContainer: "",
        manualControls: "",
        customDirectionNav: "",
        sync: "",
        asNavFor: "",
        itemWidth: 0,
        itemMargin: 0,
        minItems: 1,
        maxItems: 0,
        move: 0,
        allowOneSlide: !0,
        isFirefox: !1,
        start: function() {},
        before: function() {},
        after: function() {},
        end: function() {},
        added: function() {},
        removed: function() {},
        init: function() {},
        rtl: !1
    },
    $.fn.flexslider = function(e) {
        if (void 0 === e && (e = {}),
        "object" == typeof e)
            return this.each(function() {
                var t = $(this)
                  , a = e.selector ? e.selector : ".slides > li"
                  , n = t.find(a);
                1 === n.length && !1 === e.allowOneSlide || 0 === n.length ? (n.fadeIn(400),
                e.start && e.start(t)) : void 0 === t.data("flexslider") && new $.flexslider(this,e)
            });
        var t = $(this).data("flexslider");
        switch (e) {
        case "play":
            t.play();
            break;
        case "pause":
            t.pause();
            break;
        case "stop":
            t.stop();
            break;
        case "next":
            t.flexAnimate(t.getTarget("next"), !0);
            break;
        case "prev":
        case "previous":
            t.flexAnimate(t.getTarget("prev"), !0);
            break;
        default:
            "number" == typeof e && t.flexAnimate(e, !0)
        }
    }
}(jQuery);

/*! lazysizes - v4.0.0-rc2 */
!function(a, b) {
    var c = b(a, a.document);
    a.lazySizes = c,
    "object" == typeof module && module.exports && (module.exports = c)
}(window, function(a, b) {
    "use strict";
    if (b.getElementsByClassName) {
        var c, d, e = b.documentElement, f = a.Date, g = a.HTMLPictureElement, h = "addEventListener", i = "getAttribute", j = a[h], k = a.setTimeout, l = a.requestAnimationFrame || k, m = a.requestIdleCallback, n = /^picture$/i, o = ["load", "error", "lazyincluded", "_lazyloaded"], p = {}, q = Array.prototype.forEach, r = function(a, b) {
            return p[b] || (p[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")),
            p[b].test(a[i]("class") || "") && p[b]
        }, s = function(a, b) {
            r(a, b) || a.setAttribute("class", (a[i]("class") || "").trim() + " " + b)
        }, t = function(a, b) {
            var c;
            (c = r(a, b)) && a.setAttribute("class", (a[i]("class") || "").replace(c, " "))
        }, u = function(a, b, c) {
            var d = c ? h : "removeEventListener";
            c && u(a, b),
            o.forEach(function(c) {
                a[d](c, b)
            })
        }, v = function(a, d, e, f, g) {
            var h = b.createEvent("CustomEvent");
            return e || (e = {}),
            e.instance = c,
            h.initCustomEvent(d, !f, !g, e),
            a.dispatchEvent(h),
            h
        }, w = function(b, c) {
            var e;
            !g && (e = a.picturefill || d.pf) ? e({
                reevaluate: !0,
                elements: [b]
            }) : c && c.src && (b.src = c.src)
        }, x = function(a, b) {
            return (getComputedStyle(a, null) || {})[b]
        }, y = function(a, b, c) {
            for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth; )
                c = b.offsetWidth,
                b = b.parentNode;
            return c
        }, z = function() {
            var a, c, d = [], e = [], f = d, g = function() {
                var b = f;
                for (f = d.length ? e : d,
                a = !0,
                c = !1; b.length; )
                    b.shift()();
                a = !1
            }, h = function(d, e) {
                a && !e ? d.apply(this, arguments) : (f.push(d),
                c || (c = !0,
                (b.hidden ? k : l)(g)))
            };
            return h._lsFlush = g,
            h
        }(), A = function(a, b) {
            return b ? function() {
                z(a)
            }
            : function() {
                var b = this
                  , c = arguments;
                z(function() {
                    a.apply(b, c)
                })
            }
        }, B = function(a) {
            var b, c = 0, d = 125, e = 666, g = e, h = function() {
                b = !1,
                c = f.now(),
                a()
            }, i = m ? function() {
                m(h, {
                    timeout: g
                }),
                g !== e && (g = e)
            }
            : A(function() {
                k(h)
            }, !0);
            return function(a) {
                var e;
                (a = a === !0) && (g = 44),
                b || (b = !0,
                e = d - (f.now() - c),
                0 > e && (e = 0),
                a || 9 > e && m ? i() : k(i, e))
            }
        }, C = function(a) {
            var b, c, d = 99, e = function() {
                b = null,
                a()
            }, g = function() {
                var a = f.now() - c;
                d > a ? k(g, d - a) : (m || e)(e)
            };
            return function() {
                c = f.now(),
                b || (b = k(g, d))
            }
        }, D = function() {
            var g, l, m, o, p, y, D, F, G, H, I, J, K, L, M = /^img$/i, N = /^iframe$/i, O = "onscroll"in a && !/glebot/.test(navigator.userAgent), P = 0, Q = 0, R = 0, S = -1, T = function(a) {
                R--,
                a && a.target && u(a.target, T),
                (!a || 0 > R || !a.target) && (R = 0)
            }, U = function(a, c) {
                var d, f = a, g = "hidden" == x(b.body, "visibility") || "hidden" != x(a, "visibility");
                for (F -= c,
                I += c,
                G -= c,
                H += c; g && (f = f.offsetParent) && f != b.body && f != e; )
                    g = (x(f, "opacity") || 1) > 0,
                    g && "visible" != x(f, "overflow") && (d = f.getBoundingClientRect(),
                    g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1);
                return g
            }, V = function() {
                var a, f, h, j, k, m, n, p, q, r = c.elements;
                if ((o = d.loadMode) && 8 > R && (a = r.length)) {
                    f = 0,
                    S++,
                    null == K && ("expand"in d || (d.expand = e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370),
                    J = d.expand,
                    K = J * d.expFactor),
                    K > Q && 1 > R && S > 2 && o > 2 && !b.hidden ? (Q = K,
                    S = 0) : Q = o > 1 && S > 1 && 6 > R ? J : P;
                    for (; a > f; f++)
                        if (r[f] && !r[f]._lazyRace)
                            if (O)
                                if ((p = r[f][i]("data-expand")) && (m = 1 * p) || (m = Q),
                                q !== m && (y = innerWidth + m * L,
                                D = innerHeight + m,
                                n = -1 * m,
                                q = m),
                                h = r[f].getBoundingClientRect(),
                                (I = h.bottom) >= n && (F = h.top) <= D && (H = h.right) >= n * L && (G = h.left) <= y && (I || H || G || F) && (d.loadHidden || "hidden" != x(r[f], "visibility")) && (l && 3 > R && !p && (3 > o || 4 > S) || U(r[f], m))) {
                                    if (ba(r[f]),
                                    k = !0,
                                    R > 9)
                                        break
                                } else
                                    !k && l && !j && 4 > R && 4 > S && o > 2 && (g[0] || d.preloadAfterLoad) && (g[0] || !p && (I || H || G || F || "auto" != r[f][i](d.sizesAttr))) && (j = g[0] || r[f]);
                            else
                                ba(r[f]);
                    j && !k && ba(j)
                }
            }, W = B(V), X = function(a) {
                s(a.target, d.loadedClass),
                t(a.target, d.loadingClass),
                u(a.target, Z),
                v(a.target, "lazyloaded")
            }, Y = A(X), Z = function(a) {
                Y({
                    target: a.target
                })
            }, $ = function(a, b) {
                try {
                    a.contentWindow.location.replace(b)
                } catch (c) {
                    a.src = b
                }
            }, _ = function(a) {
                var b, c = a[i](d.srcsetAttr);
                (b = d.customMedia[a[i]("data-media") || a[i]("media")]) && a.setAttribute("media", b),
                c && a.setAttribute("srcset", c)
            }, aa = A(function(a, b, c, e, f) {
                var g, h, j, l, o, p;
                (o = v(a, "lazybeforeunveil", b)).defaultPrevented || (e && (c ? s(a, d.autosizesClass) : a.setAttribute("sizes", e)),
                h = a[i](d.srcsetAttr),
                g = a[i](d.srcAttr),
                f && (j = a.parentNode,
                l = j && n.test(j.nodeName || "")),
                p = b.firesLoad || "src"in a && (h || g || l),
                o = {
                    target: a
                },
                p && (u(a, T, !0),
                clearTimeout(m),
                m = k(T, 2500),
                s(a, d.loadingClass),
                u(a, Z, !0)),
                l && q.call(j.getElementsByTagName("source"), _),
                h ? a.setAttribute("srcset", h) : g && !l && (N.test(a.nodeName) ? $(a, g) : a.src = g),
                f && (h || l) && w(a, {
                    src: g
                })),
                a._lazyRace && delete a._lazyRace,
                t(a, d.lazyClass),
                z(function() {
                    (!p || a.complete && a.naturalWidth > 1) && (p ? T(o) : R--,
                    X(o))
                }, !0)
            }), ba = function(a) {
                var b, c = M.test(a.nodeName), e = c && (a[i](d.sizesAttr) || a[i]("sizes")), f = "auto" == e;
                (!f && l || !c || !a[i]("src") && !a.srcset || a.complete || r(a, d.errorClass)) && (b = v(a, "lazyunveilread").detail,
                f && E.updateElem(a, !0, a.offsetWidth),
                a._lazyRace = !0,
                R++,
                aa(a, b, f, e, c))
            }, ca = function() {
                if (!l) {
                    if (f.now() - p < 999)
                        return void k(ca, 999);
                    var a = C(function() {
                        d.loadMode = 3,
                        W()
                    });
                    l = !0,
                    d.loadMode = 3,
                    W(),
                    j("scroll", function() {
                        3 == d.loadMode && (d.loadMode = 2),
                        a()
                    }, !0)
                }
            };
            return {
                _: function() {
                    p = f.now(),
                    c.elements = b.getElementsByClassName(d.lazyClass),
                    g = b.getElementsByClassName(d.lazyClass + " " + d.preloadClass),
                    L = d.hFac,
                    j("scroll", W, !0),
                    j("resize", W, !0),
                    a.MutationObserver ? new MutationObserver(W).observe(e, {
                        childList: !0,
                        subtree: !0,
                        attributes: !0
                    }) : (e[h]("DOMNodeInserted", W, !0),
                    e[h]("DOMAttrModified", W, !0),
                    setInterval(W, 999)),
                    j("hashchange", W, !0),
                    ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function(a) {
                        b[h](a, W, !0)
                    }),
                    /d$|^c/.test(b.readyState) ? ca() : (j("load", ca),
                    b[h]("DOMContentLoaded", W),
                    k(ca, 2e4)),
                    c.elements.length ? (V(),
                    z._lsFlush()) : W()
                },
                checkElems: W,
                unveil: ba
            }
        }(), E = function() {
            var a, c = A(function(a, b, c, d) {
                var e, f, g;
                if (a._lazysizesWidth = d,
                d += "px",
                a.setAttribute("sizes", d),
                n.test(b.nodeName || ""))
                    for (e = b.getElementsByTagName("source"),
                    f = 0,
                    g = e.length; g > f; f++)
                        e[f].setAttribute("sizes", d);
                c.detail.dataAttr || w(a, c.detail)
            }), e = function(a, b, d) {
                var e, f = a.parentNode;
                f && (d = y(a, f, d),
                e = v(a, "lazybeforesizes", {
                    width: d,
                    dataAttr: !!b
                }),
                e.defaultPrevented || (d = e.detail.width,
                d && d !== a._lazysizesWidth && c(a, f, e, d)))
            }, f = function() {
                var b, c = a.length;
                if (c)
                    for (b = 0; c > b; b++)
                        e(a[b])
            }, g = C(f);
            return {
                _: function() {
                    a = b.getElementsByClassName(d.autosizesClass),
                    j("resize", g)
                },
                checkElems: g,
                updateElem: e
            }
        }(), F = function() {
            F.i || (F.i = !0,
            E._(),
            D._())
        };
        return function() {
            var b, c = {
                lazyClass: "lazyload",
                loadedClass: "lazyloaded",
                loadingClass: "lazyloading",
                preloadClass: "lazypreload",
                errorClass: "lazyerror",
                autosizesClass: "lazyautosizes",
                srcAttr: "data-src",
                srcsetAttr: "data-srcset",
                sizesAttr: "data-sizes",
                minSize: 40,
                customMedia: {},
                init: !0,
                expFactor: 1.5,
                hFac: .8,
                loadMode: 2,
                loadHidden: !0
            };
            d = a.lazySizesConfig || a.lazysizesConfig || {};
            for (b in c)
                b in d || (d[b] = c[b]);
            a.lazySizesConfig = d,
            k(function() {
                d.init && F()
            })
        }(),
        c = {
            cfg: d,
            autoSizer: E,
            loader: D,
            init: F,
            uP: w,
            aC: s,
            rC: t,
            hC: r,
            fire: v,
            gW: y,
            rAF: z
        }
    }
});

/*! lazysizes - v4.0.0-rc2 */
!function(a, b) {
    var c = function() {
        b(a.lazySizes),
        a.removeEventListener("lazyunveilread", c, !0)
    };
    b = b.bind(null, a, a.document),
    "object" == typeof module && module.exports ? b(require("lazysizes"), require("../fix-ios-sizes/fix-ios-sizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0)
}(window, function(a, b, c) {
    "use strict";
    var d, e = c && c.cfg || a.lazySizesConfig, f = b.createElement("img"), g = "sizes"in f && "srcset"in f, h = /\s+\d+h/g, i = function() {
        var a = /\s+(\d+)(w|h)\s+(\d+)(w|h)/
          , c = Array.prototype.forEach;
        return function(d) {
            var e = b.createElement("img")
              , f = function(b) {
                var c, d = b.getAttribute(lazySizesConfig.srcsetAttr);
                d && (d.match(a) && (c = "w" == RegExp.$2 ? RegExp.$1 / RegExp.$3 : RegExp.$3 / RegExp.$1,
                c && b.setAttribute("data-aspectratio", c)),
                b.setAttribute(lazySizesConfig.srcsetAttr, d.replace(h, "")))
            }
              , g = function(a) {
                var b = a.target.parentNode;
                b && "PICTURE" == b.nodeName && c.call(b.getElementsByTagName("source"), f),
                f(a.target)
            }
              , i = function() {
                e.currentSrc && b.removeEventListener("lazybeforeunveil", g)
            };
            d[1] && (b.addEventListener("lazybeforeunveil", g),
            e.onload = i,
            e.onerror = i,
            e.srcset = "data:,a 1w 1h",
            e.complete && i())
        }
    }();
    if (e || (e = {},
    a.lazySizesConfig = e),
    e.supportsType || (e.supportsType = function(a) {
        return !a
    }
    ),
    !a.picturefill && !e.pf) {
        if (a.HTMLPictureElement && g)
            return b.msElementsFromPoint && i(navigator.userAgent.match(/Edge\/(\d+)/)),
            void (e.pf = function() {}
            );
        e.pf = function(b) {
            var c, e;
            if (!a.picturefill)
                for (c = 0,
                e = b.elements.length; e > c; c++)
                    d(b.elements[c])
        }
        ,
        d = function() {
            var f = function(a, b) {
                return a.w - b.w
            }
              , i = /^\s*\d+\.*\d*px\s*$/
              , j = function(a) {
                var b, c, d = a.length, e = a[d - 1], f = 0;
                for (f; d > f; f++)
                    if (e = a[f],
                    e.d = e.w / a.w,
                    e.d >= a.d) {
                        !e.cached && (b = a[f - 1]) && b.d > a.d - .13 * Math.pow(a.d, 2.2) && (c = Math.pow(b.d - .6, 1.6),
                        b.cached && (b.d += .15 * c),
                        b.d + (e.d - a.d) * c > a.d && (e = b));
                        break
                    }
                return e
            }
              , k = function() {
                var a, b = /(([^,\s].[^\s]+)\s+(\d+)w)/g, c = /\s/, d = function(b, c, d, e) {
                    a.push({
                        c: c,
                        u: d,
                        w: 1 * e
                    })
                };
                return function(e) {
                    return a = [],
                    e = e.trim(),
                    e.replace(h, "").replace(b, d),
                    a.length || !e || c.test(e) || a.push({
                        c: e,
                        u: e,
                        w: 99
                    }),
                    a
                }
            }()
              , l = function() {
                l.init || (l.init = !0,
                addEventListener("resize", function() {
                    var a, c = b.getElementsByClassName("lazymatchmedia"), e = function() {
                        var a, b;
                        for (a = 0,
                        b = c.length; b > a; a++)
                            d(c[a])
                    };
                    return function() {
                        clearTimeout(a),
                        a = setTimeout(e, 66)
                    }
                }()))
            }
              , m = function(b, d) {
                var f, g = b.getAttribute("srcset") || b.getAttribute(e.srcsetAttr);
                !g && d && (g = b._lazypolyfill ? b._lazypolyfill._set : b.getAttribute(e.srcAttr) || b.getAttribute("src")),
                b._lazypolyfill && b._lazypolyfill._set == g || (f = k(g || ""),
                d && b.parentNode && (f.isPicture = "PICTURE" == b.parentNode.nodeName.toUpperCase(),
                f.isPicture && a.matchMedia && (c.aC(b, "lazymatchmedia"),
                l())),
                f._set = g,
                Object.defineProperty(b, "_lazypolyfill", {
                    value: f,
                    writable: !0
                }))
            }
              , n = function(b) {
                var d = a.devicePixelRatio || 1
                  , e = c.getX && c.getX(b);
                return Math.min(e || d, 2.5, d)
            }
              , o = function(b) {
                return a.matchMedia ? (o = function(a) {
                    return !a || (matchMedia(a) || {}).matches
                }
                )(b) : !b
            }
              , p = function(a) {
                var b, d, g, h, k, l, p;
                if (h = a,
                m(h, !0),
                k = h._lazypolyfill,
                k.isPicture)
                    for (d = 0,
                    b = a.parentNode.getElementsByTagName("source"),
                    g = b.length; g > d; d++)
                        if (e.supportsType(b[d].getAttribute("type"), a) && o(b[d].getAttribute("media"))) {
                            h = b[d],
                            m(h),
                            k = h._lazypolyfill;
                            break
                        }
                return k.length > 1 ? (p = h.getAttribute("sizes") || "",
                p = i.test(p) && parseInt(p, 10) || c.gW(a, a.parentNode),
                k.d = n(a),
                !k.src || !k.w || k.w < p ? (k.w = p,
                l = j(k.sort(f)),
                k.src = l) : l = k.src) : l = k[0],
                l
            }
              , q = function(a) {
                if (!g || !a.parentNode || "PICTURE" == a.parentNode.nodeName.toUpperCase()) {
                    var b = p(a);
                    b && b.u && a._lazypolyfill.cur != b.u && (a._lazypolyfill.cur = b.u,
                    b.cached = !0,
                    a.setAttribute(e.srcAttr, b.u),
                    a.setAttribute("src", b.u))
                }
            };
            return q.parse = k,
            q
        }(),
        e.loadedClass && e.loadingClass && !function() {
            var a = [];
            ['img[sizes$="px"][srcset].', "picture > img:not([srcset])."].forEach(function(b) {
                a.push(b + e.loadedClass),
                a.push(b + e.loadingClass)
            }),
            e.pf({
                elements: b.querySelectorAll(a.join(", "))
            })
        }()
    }
});

/*! lazysizes - v4.1.4 */
!function(a, b) {
    var c = function() {
        b(a.lazySizes),
        a.removeEventListener("lazyunveilread", c, !0)
    };
    b = b.bind(null, a, a.document),
    "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0)
}(window, function(a, b, c) {
    "use strict";
    function d() {
        this.ratioElems = b.getElementsByClassName("lazyaspectratio"),
        this._setupEvents(),
        this.processImages()
    }
    if (a.addEventListener) {
        var e, f, g, h = Array.prototype.forEach, i = /^picture$/i, j = "data-aspectratio", k = "img[" + j + "]", l = function(b) {
            return a.matchMedia ? (l = function(a) {
                return !a || (matchMedia(a) || {}).matches
            }
            )(b) : a.Modernizr && Modernizr.mq ? !b || Modernizr.mq(b) : !b
        }, m = c.aC, n = c.rC, o = c.cfg;
        d.prototype = {
            _setupEvents: function() {
                var a = this
                  , c = function(b) {
                    b.naturalWidth < 36 ? a.addAspectRatio(b, !0) : a.removeAspectRatio(b, !0)
                }
                  , d = function() {
                    a.processImages()
                };
                b.addEventListener("load", function(a) {
                    a.target.getAttribute && a.target.getAttribute(j) && c(a.target)
                }, !0),
                addEventListener("resize", function() {
                    var b, d = function() {
                        h.call(a.ratioElems, c)
                    };
                    return function() {
                        clearTimeout(b),
                        b = setTimeout(d, 99)
                    }
                }()),
                b.addEventListener("DOMContentLoaded", d),
                addEventListener("load", d)
            },
            processImages: function(a) {
                var c, d;
                a || (a = b),
                c = "length"in a && !a.nodeName ? a : a.querySelectorAll(k);
                for (d = 0; d < c.length; d++)
                    c[d].naturalWidth > 36 ? this.removeAspectRatio(c[d]) : this.addAspectRatio(c[d])
            },
            getSelectedRatio: function(a) {
                var b, c, d, e, f, g = a.parentNode;
                if (g && i.test(g.nodeName || ""))
                    for (d = g.getElementsByTagName("source"),
                    b = 0,
                    c = d.length; c > b; b++)
                        if (e = d[b].getAttribute("data-media") || d[b].getAttribute("media"),
                        o.customMedia[e] && (e = o.customMedia[e]),
                        l(e)) {
                            f = d[b].getAttribute(j);
                            break
                        }
                return f || a.getAttribute(j) || ""
            },
            parseRatio: function() {
                var a = /^\s*([+\d\.]+)(\s*[\/x]\s*([+\d\.]+))?\s*$/
                  , b = {};
                return function(c) {
                    var d;
                    return !b[c] && (d = c.match(a)) && (d[3] ? b[c] = d[1] / d[3] : b[c] = 1 * d[1]),
                    b[c]
                }
            }(),
            addAspectRatio: function(b, c) {
                var d, e = b.offsetWidth, f = b.offsetHeight;
                return c || m(b, "lazyaspectratio"),
                36 > e && 0 >= f ? void ((e || f && a.console) && console.log("Define width or height of image, so we can calculate the other dimension")) : (d = this.getSelectedRatio(b),
                d = this.parseRatio(d),
                void (d && (e ? b.style.height = e / d + "px" : b.style.width = f * d + "px")))
            },
            removeAspectRatio: function(a) {
                n(a, "lazyaspectratio"),
                a.style.height = "",
                a.style.width = "",
                a.removeAttribute(j)
            }
        },
        f = function() {
            g = a.jQuery || a.Zepto || a.shoestring || a.$,
            g && g.fn && !g.fn.imageRatio && g.fn.filter && g.fn.add && g.fn.find ? g.fn.imageRatio = function() {
                return e.processImages(this.find(k).add(this.filter(k))),
                this
            }
            : g = !1
        }
        ,
        f(),
        setTimeout(f),
        e = new d,
        a.imageRatio = e,
        "object" == typeof module && module.exports ? module.exports = e : "function" == typeof define && define.amd && define(e)
    }
});

/*
 * jQuery offscreen plugin
 *
 * Copyright Cory LaViska for A Beautiful Site, LLC
 *
 * @license: http://opensource.org/licenses/MIT
 *
 */
(function($) {
    $.extend($.expr[':'], {
        'off-top': function(el) {
            return $(el).offset().top < $(window).scrollTop();
        },
        'off-right': function(el) {
            return $(el).offset().left + $(el).outerWidth() - $(window).scrollLeft() > $(window).width();
        },
        'off-bottom': function(el) {
            return $(el).offset().top + $(el).outerHeight() - $(window).scrollTop() > $(window).height();
        },
        'off-left': function(el) {
            return $(el).offset().left < $(window).scrollLeft();
        },
        'off-screen': function(el) {
            return $(el).is(':off-top, :off-right, :off-bottom, :off-left');
        }
    });
}
)(jQuery);

/*
 * jQuery mmenu v5.7.8
 * @requires jQuery 1.7.0 or later
 *
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 * www.frebsite.nl
 *
 * License: CC-BY-NC-4.0
 * http://creativecommons.org/licenses/by-nc/4.0/
 */
!function(e) {
    function n() {
        e[t].glbl || (r = {
            $wndw: e(window),
            $docu: e(document),
            $html: e("html"),
            $body: e("body")
        },
        s = {},
        a = {},
        o = {},
        e.each([s, a, o], function(e, n) {
            n.add = function(e) {
                e = e.split(" ");
                for (var t = 0, i = e.length; t < i; t++)
                    n[e[t]] = n.mm(e[t])
            }
        }),
        s.mm = function(e) {
            return "mm-" + e
        }
        ,
        s.add("wrapper menu panels panel nopanel current highest opened subopened navbar hasnavbar title btn prev next listview nolistview inset vertical selected divider spacer hidden fullsubopen"),
        s.umm = function(e) {
            return "mm-" == e.slice(0, 3) && (e = e.slice(3)),
            e
        }
        ,
        a.mm = function(e) {
            return "mm-" + e
        }
        ,
        a.add("parent child"),
        o.mm = function(e) {
            return e + ".mm"
        }
        ,
        o.add("transitionend webkitTransitionEnd click scroll keydown mousedown mouseup touchstart touchmove touchend orientationchange"),
        e[t]._c = s,
        e[t]._d = a,
        e[t]._e = o,
        e[t].glbl = r)
    }
    var t = "mmenu"
      , i = "5.7.8";
    if (!(e[t] && e[t].version > i)) {
        e[t] = function(e, n, t) {
            this.$menu = e,
            this._api = ["bind", "getInstance", "update", "initPanels", "openPanel", "closePanel", "closeAllPanels", "setSelected"],
            this.opts = n,
            this.conf = t,
            this.vars = {},
            this.cbck = {},
            "function" == typeof this.___deprecated && this.___deprecated(),
            this._initMenu(),
            this._initAnchors();
            var i = this.$pnls.children();
            return this._initAddons(),
            this.initPanels(i),
            "function" == typeof this.___debug && this.___debug(),
            this
        }
        ,
        e[t].version = i,
        e[t].addons = {},
        e[t].uniqueId = 0,
        e[t].defaults = {
            extensions: [],
            initMenu: function() {},
            initPanels: function() {},
            navbar: {
                add: !0,
                title: "Menu",
                titleLink: "panel"
            },
            onClick: {
                setSelected: !0
            },
            slidingSubmenus: !0
        },
        e[t].configuration = {
            classNames: {
                divider: "Divider",
                inset: "Inset",
                panel: "Panel",
                selected: "Selected",
                spacer: "Spacer",
                vertical: "Vertical"
            },
            clone: !1,
            openingInterval: 25,
            panelNodetype: "ul, ol, div",
            transitionDuration: 400
        },
        e[t].prototype = {
            init: function(e) {
                this.initPanels(e)
            },
            getInstance: function() {
                return this
            },
            update: function() {
                this.trigger("update")
            },
            initPanels: function(e) {
                e = e.not("." + s.nopanel),
                e = this._initPanels(e),
                this.opts.initPanels.call(this, e),
                this.trigger("initPanels", e),
                this.trigger("update")
            },
            openPanel: function(n) {
                var i = n.parent()
                  , a = this;
                if (i.hasClass(s.vertical)) {
                    var o = i.parents("." + s.subopened);
                    if (o.length)
                        return void this.openPanel(o.first());
                    i.addClass(s.opened),
                    this.trigger("openPanel", n),
                    this.trigger("openingPanel", n),
                    this.trigger("openedPanel", n)
                } else {
                    if (n.hasClass(s.current))
                        return;
                    var r = this.$pnls.children("." + s.panel)
                      , l = r.filter("." + s.current);
                    r.removeClass(s.highest).removeClass(s.current).not(n).not(l).not("." + s.vertical).addClass(s.hidden),
                    e[t].support.csstransitions || l.addClass(s.hidden),
                    n.hasClass(s.opened) ? n.nextAll("." + s.opened).addClass(s.highest).removeClass(s.opened).removeClass(s.subopened) : (n.addClass(s.highest),
                    l.addClass(s.subopened)),
                    n.removeClass(s.hidden).addClass(s.current),
                    a.trigger("openPanel", n),
                    setTimeout(function() {
                        n.removeClass(s.subopened).addClass(s.opened),
                        a.trigger("openingPanel", n),
                        a.__transitionend(n, function() {
                            a.trigger("openedPanel", n)
                        }, a.conf.transitionDuration)
                    }, this.conf.openingInterval)
                }
            },
            closePanel: function(e) {
                var n = e.parent();
                n.hasClass(s.vertical) && (n.removeClass(s.opened),
                this.trigger("closePanel", e),
                this.trigger("closingPanel", e),
                this.trigger("closedPanel", e))
            },
            closeAllPanels: function() {
                this.$menu.find("." + s.listview).children().removeClass(s.selected).filter("." + s.vertical).removeClass(s.opened);
                var e = this.$pnls.children("." + s.panel)
                  , n = e.first();
                this.$pnls.children("." + s.panel).not(n).removeClass(s.subopened).removeClass(s.opened).removeClass(s.current).removeClass(s.highest).addClass(s.hidden),
                this.openPanel(n)
            },
            togglePanel: function(e) {
                var n = e.parent();
                n.hasClass(s.vertical) && this[n.hasClass(s.opened) ? "closePanel" : "openPanel"](e)
            },
            setSelected: function(e) {
                this.$menu.find("." + s.listview).children("." + s.selected).removeClass(s.selected),
                e.addClass(s.selected),
                this.trigger("setSelected", e)
            },
            bind: function(e, n) {
                e = "init" == e ? "initPanels" : e,
                this.cbck[e] = this.cbck[e] || [],
                this.cbck[e].push(n)
            },
            trigger: function() {
                var e = this
                  , n = Array.prototype.slice.call(arguments)
                  , t = n.shift();
                if (t = "init" == t ? "initPanels" : t,
                this.cbck[t])
                    for (var i = 0, s = this.cbck[t].length; i < s; i++)
                        this.cbck[t][i].apply(e, n)
            },
            _initMenu: function() {
                this.conf.clone && (this.$orig = this.$menu,
                this.$menu = this.$orig.clone(!0),
                this.$menu.add(this.$menu.find("[id]")).filter("[id]").each(function() {
                    e(this).attr("id", s.mm(e(this).attr("id")))
                })),
                this.opts.initMenu.call(this, this.$menu, this.$orig),
                this.$menu.attr("id", this.$menu.attr("id") || this.__getUniqueId()),
                this.$pnls = e('<div class="' + s.panels + '" />').append(this.$menu.children(this.conf.panelNodetype)).prependTo(this.$menu),
                this.$menu.parent().addClass(s.wrapper);
                var n = [s.menu];
                this.opts.slidingSubmenus || n.push(s.vertical),
                this.opts.extensions = this.opts.extensions.length ? "mm-" + this.opts.extensions.join(" mm-") : "",
                this.opts.extensions && n.push(this.opts.extensions),
                this.$menu.addClass(n.join(" ")),
                this.trigger("_initMenu")
            },
            _initPanels: function(n) {
                var i = this
                  , o = this.__findAddBack(n, "ul, ol");
                this.__refactorClass(o, this.conf.classNames.inset, "inset").addClass(s.nolistview + " " + s.nopanel),
                o.not("." + s.nolistview).addClass(s.listview);
                var r = this.__findAddBack(n, "." + s.listview).children();
                this.__refactorClass(r, this.conf.classNames.selected, "selected"),
                this.__refactorClass(r, this.conf.classNames.divider, "divider"),
                this.__refactorClass(r, this.conf.classNames.spacer, "spacer"),
                this.__refactorClass(this.__findAddBack(n, "." + this.conf.classNames.panel), this.conf.classNames.panel, "panel");
                var l = e()
                  , d = n.add(n.find("." + s.panel)).add(this.__findAddBack(n, "." + s.listview).children().children(this.conf.panelNodetype)).not("." + s.nopanel);
                this.__refactorClass(d, this.conf.classNames.vertical, "vertical"),
                this.opts.slidingSubmenus || d.addClass(s.vertical),
                d.each(function() {
                    var n = e(this)
                      , t = n;
                    n.is("ul, ol") ? (n.wrap('<div class="' + s.panel + '" />'),
                    t = n.parent()) : t.addClass(s.panel);
                    var a = n.attr("id");
                    n.removeAttr("id"),
                    t.attr("id", a || i.__getUniqueId()),
                    n.hasClass(s.vertical) && (n.removeClass(i.conf.classNames.vertical),
                    t.add(t.parent()).addClass(s.vertical)),
                    l = l.add(t)
                });
                var c = e("." + s.panel, this.$menu);
                l.each(function(n) {
                    var o, r, l = e(this), d = l.parent(), c = d.children("a, span").first();
                    if (d.is("." + s.panels) || (d.data(a.child, l),
                    l.data(a.parent, d)),
                    d.children("." + s.next).length || d.parent().is("." + s.listview) && (o = l.attr("id"),
                    r = e('<a class="' + s.next + '" href="#' + o + '" data-target="#' + o + '" />').insertBefore(c),
                    c.is("span") && r.addClass(s.fullsubopen)),
                    !l.children("." + s.navbar).length && !d.hasClass(s.vertical)) {
                        d.parent().is("." + s.listview) ? d = d.closest("." + s.panel) : (c = d.closest("." + s.panel).find('a[href="#' + l.attr("id") + '"]').first(),
                        d = c.closest("." + s.panel));
                        var h = !1
                          , u = e('<div class="' + s.navbar + '" />');
                        if (i.opts.navbar.add && l.addClass(s.hasnavbar),
                        d.length) {
                            switch (o = d.attr("id"),
                            i.opts.navbar.titleLink) {
                            case "anchor":
                                h = c.attr("href");
                                break;
                            case "panel":
                            case "parent":
                                h = "#" + o;
                                break;
                            default:
                                h = !1
                            }
                            u.append('<a class="' + s.btn + " " + s.prev + '" href="#' + o + '" data-target="#' + o + '" />').append(e('<a class="' + s.title + '"' + (h ? ' href="' + h + '"' : "") + " />").text(c.text())).prependTo(l)
                        } else
                            i.opts.navbar.title && u.append('<a class="' + s.title + '">' + e[t].i18n(i.opts.navbar.title) + "</a>").prependTo(l)
                    }
                });
                var h = this.__findAddBack(n, "." + s.listview).children("." + s.selected).removeClass(s.selected).last().addClass(s.selected);
                h.add(h.parentsUntil("." + s.menu, "li")).filter("." + s.vertical).addClass(s.opened).end().each(function() {
                    e(this).parentsUntil("." + s.menu, "." + s.panel).not("." + s.vertical).first().addClass(s.opened).parentsUntil("." + s.menu, "." + s.panel).not("." + s.vertical).first().addClass(s.opened).addClass(s.subopened)
                }),
                h.children("." + s.panel).not("." + s.vertical).addClass(s.opened).parentsUntil("." + s.menu, "." + s.panel).not("." + s.vertical).first().addClass(s.opened).addClass(s.subopened);
                var u = c.filter("." + s.opened);
                return u.length || (u = l.first()),
                u.addClass(s.opened).last().addClass(s.current),
                l.not("." + s.vertical).not(u.last()).addClass(s.hidden).end().filter(function() {
                    return !e(this).parent().hasClass(s.panels)
                }).appendTo(this.$pnls),
                this.trigger("_initPanels", l),
                l
            },
            _initAnchors: function() {
                var n = this;
                r.$body.on(o.click + "-oncanvas", "a[href]", function(i) {
                    var a = e(this)
                      , o = !1
                      , r = n.$menu.find(a).length;
                    for (var l in e[t].addons)
                        if (e[t].addons[l].clickAnchor.call(n, a, r)) {
                            o = !0;
                            break
                        }
                    var d = a.attr("href");
                    if (!o && r && d.length > 1 && "#" == d.slice(0, 1))
                        try {
                            var c = e(d, n.$menu);
                            c.is("." + s.panel) && (o = !0,
                            n[a.parent().hasClass(s.vertical) ? "togglePanel" : "openPanel"](c))
                        } catch (h) {}
                    if (o && i.preventDefault(),
                    !o && r && a.is("." + s.listview + " > li > a") && !a.is('[rel="external"]') && !a.is('[target="_blank"]')) {
                        n.__valueOrFn(n.opts.onClick.setSelected, a) && n.setSelected(e(i.target).parent());
                        var u = n.__valueOrFn(n.opts.onClick.preventDefault, a, "#" == d.slice(0, 1));
                        u && i.preventDefault(),
                        n.__valueOrFn(n.opts.onClick.close, a, u) && n.close()
                    }
                }),
                this.trigger("_initAnchors")
            },
            _initAddons: function() {
                var n;
                for (n in e[t].addons)
                    e[t].addons[n].add.call(this),
                    e[t].addons[n].add = function() {}
                    ;
                for (n in e[t].addons)
                    e[t].addons[n].setup.call(this);
                this.trigger("_initAddons")
            },
            _getOriginalMenuId: function() {
                var e = this.$menu.attr("id");
                return e && e.length && this.conf.clone && (e = s.umm(e)),
                e
            },
            __api: function() {
                var n = this
                  , t = {};
                return e.each(this._api, function(e) {
                    var i = this;
                    t[i] = function() {
                        var e = n[i].apply(n, arguments);
                        return "undefined" == typeof e ? t : e
                    }
                }),
                t
            },
            __valueOrFn: function(e, n, t) {
                return "function" == typeof e ? e.call(n[0]) : "undefined" == typeof e && "undefined" != typeof t ? t : e
            },
            __refactorClass: function(e, n, t) {
                return e.filter("." + n).removeClass(n).addClass(s[t])
            },
            __findAddBack: function(e, n) {
                return e.find(n).add(e.filter(n))
            },
            __filterListItems: function(e) {
                return e.not("." + s.divider).not("." + s.hidden)
            },
            __transitionend: function(n, t, i) {
                var s = !1
                  , a = function(i) {
                    if ("undefined" != typeof i) {
                        if (!e(i.target).is(n))
                            return !1;
                        n.unbind(o.transitionend),
                        n.unbind(o.webkitTransitionEnd)
                    }
                    s || t.call(n[0]),
                    s = !0
                };
                n.on(o.transitionend, a),
                n.on(o.webkitTransitionEnd, a),
                setTimeout(a, 1.1 * i)
            },
            __getUniqueId: function() {
                return s.mm(e[t].uniqueId++)
            }
        },
        e.fn[t] = function(i, s) {
            n(),
            i = e.extend(!0, {}, e[t].defaults, i),
            s = e.extend(!0, {}, e[t].configuration, s);
            var a = e();
            return this.each(function() {
                var n = e(this);
                if (!n.data(t)) {
                    var o = new e[t](n,i,s);
                    o.$menu.data(t, o.__api()),
                    a = a.add(o.$menu)
                }
            }),
            a
        }
        ,
        e[t].i18n = function() {
            var n = {};
            return function(t) {
                switch (typeof t) {
                case "object":
                    return e.extend(n, t),
                    n;
                case "string":
                    return n[t] || t;
                case "undefined":
                default:
                    return n
                }
            }
        }(),
        e[t].support = {
            touch: "ontouchstart"in window || navigator.msMaxTouchPoints || !1,
            csstransitions: function() {
                if ("undefined" != typeof Modernizr && "undefined" != typeof Modernizr.csstransitions)
                    return Modernizr.csstransitions;
                var e = document.body || document.documentElement
                  , n = e.style
                  , t = "transition";
                if ("string" == typeof n[t])
                    return !0;
                var i = ["Moz", "webkit", "Webkit", "Khtml", "O", "ms"];
                t = t.charAt(0).toUpperCase() + t.substr(1);
                for (var s = 0; s < i.length; s++)
                    if ("string" == typeof n[i[s] + t])
                        return !0;
                return !1
            }(),
            csstransforms: function() {
                return "undefined" == typeof Modernizr || "undefined" == typeof Modernizr.csstransforms || Modernizr.csstransforms
            }(),
            csstransforms3d: function() {
                return "undefined" == typeof Modernizr || "undefined" == typeof Modernizr.csstransforms3d || Modernizr.csstransforms3d
            }()
        };
        var s, a, o, r
    }
}(jQuery),
/*
 * jQuery mmenu offCanvas add-on
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
function(e) {
    var n = "mmenu"
      , t = "offCanvas";
    e[n].addons[t] = {
        setup: function() {
            if (this.opts[t]) {
                var s = this.opts[t]
                  , a = this.conf[t];
                o = e[n].glbl,
                this._api = e.merge(this._api, ["open", "close", "setPage"]),
                "top" != s.position && "bottom" != s.position || (s.zposition = "front"),
                "string" != typeof a.pageSelector && (a.pageSelector = "> " + a.pageNodetype),
                o.$allMenus = (o.$allMenus || e()).add(this.$menu),
                this.vars.opened = !1;
                var r = [i.offcanvas];
                "left" != s.position && r.push(i.mm(s.position)),
                "back" != s.zposition && r.push(i.mm(s.zposition)),
                this.$menu.addClass(r.join(" ")).parent().removeClass(i.wrapper),
                e[n].support.csstransforms || this.$menu.addClass(i["no-csstransforms"]),
                e[n].support.csstransforms3d || this.$menu.addClass(i["no-csstransforms3d"]),
                this.setPage(o.$page),
                this._initBlocker(),
                this["_initWindow_" + t](),
                this.$menu[a.menuInjectMethod + "To"](a.menuWrapperSelector);
                var l = window.location.hash;
                if (l) {
                    var d = this._getOriginalMenuId();
                    d && d == l.slice(1) && this.open()
                }
            }
        },
        add: function() {
            i = e[n]._c,
            s = e[n]._d,
            a = e[n]._e,
            i.add("offcanvas slideout blocking modal background opening blocker page no-csstransforms3d"),
            s.add("style"),
            a.add("resize")
        },
        clickAnchor: function(e, n) {
            var s = this;
            if (this.opts[t]) {
                var a = this._getOriginalMenuId();
                if (a && e.is('[href="#' + a + '"]')) {
                    if (n)
                        return !0;
                    var r = e.closest("." + i.menu);
                    if (r.length) {
                        var l = r.data("mmenu");
                        if (l && l.close)
                            return l.close(),
                            s.__transitionend(r, function() {
                                s.open()
                            }, s.conf.transitionDuration),
                            !0
                    }
                    return this.open(),
                    !0
                }
                if (o.$page)
                    return a = o.$page.first().attr("id"),
                    a && e.is('[href="#' + a + '"]') ? (this.close(),
                    !0) : void 0
            }
        }
    },
    e[n].defaults[t] = {
        position: "left",
        zposition: "back",
        blockUI: !0,
        moveBackground: !0
    },
    e[n].configuration[t] = {
        pageNodetype: "div",
        pageSelector: null,
        noPageSelector: [],
        wrapPageIfNeeded: !0,
        menuWrapperSelector: "body",
        menuInjectMethod: "prepend"
    },
    e[n].prototype.open = function() {
        if (!this.vars.opened) {
            var e = this;
            this._openSetup(),
            setTimeout(function() {
                e._openFinish()
            }, this.conf.openingInterval),
            this.trigger("open")
        }
    }
    ,
    e[n].prototype._openSetup = function() {
        var n = this
          , r = this.opts[t];
        this.closeAllOthers(),
        o.$page.each(function() {
            e(this).data(s.style, e(this).attr("style") || "")
        }),
        o.$wndw.trigger(a.resize + "-" + t, [!0]);
        var l = [i.opened];
        r.blockUI && l.push(i.blocking),
        "modal" == r.blockUI && l.push(i.modal),
        r.moveBackground && l.push(i.background),
        "left" != r.position && l.push(i.mm(this.opts[t].position)),
        "back" != r.zposition && l.push(i.mm(this.opts[t].zposition)),
        this.opts.extensions && l.push(this.opts.extensions),
        o.$html.addClass(l.join(" ")),
        setTimeout(function() {
            n.vars.opened = !0
        }, this.conf.openingInterval),
        this.$menu.addClass(i.current + " " + i.opened)
    }
    ,
    e[n].prototype._openFinish = function() {
        var e = this;
        this.__transitionend(o.$page.first(), function() {
            e.trigger("opened")
        }, this.conf.transitionDuration),
        o.$html.addClass(i.opening),
        this.trigger("opening")
    }
    ,
    e[n].prototype.close = function() {
        if (this.vars.opened) {
            var n = this;
            this.__transitionend(o.$page.first(), function() {
                n.$menu.removeClass(i.current + " " + i.opened);
                var a = [i.opened, i.blocking, i.modal, i.background, i.mm(n.opts[t].position), i.mm(n.opts[t].zposition)];
                n.opts.extensions && a.push(n.opts.extensions),
                o.$html.removeClass(a.join(" ")),
                o.$page.each(function() {
                    e(this).attr("style", e(this).data(s.style))
                }),
                n.vars.opened = !1,
                n.trigger("closed")
            }, this.conf.transitionDuration),
            o.$html.removeClass(i.opening),
            this.trigger("close"),
            this.trigger("closing")
        }
    }
    ,
    e[n].prototype.closeAllOthers = function() {
        o.$allMenus.not(this.$menu).each(function() {
            var t = e(this).data(n);
            t && t.close && t.close()
        })
    }
    ,
    e[n].prototype.setPage = function(n) {
        var s = this
          , a = this.conf[t];
        n && n.length || (n = o.$body.find(a.pageSelector),
        a.noPageSelector.length && (n = n.not(a.noPageSelector.join(", "))),
        n.length > 1 && a.wrapPageIfNeeded && (n = n.wrapAll("<" + this.conf[t].pageNodetype + " />").parent())),
        n.each(function() {
            e(this).attr("id", e(this).attr("id") || s.__getUniqueId())
        }),
        n.addClass(i.page + " " + i.slideout),
        o.$page = n,
        this.trigger("setPage", n)
    }
    ,
    e[n].prototype["_initWindow_" + t] = function() {
        o.$wndw.off(a.keydown + "-" + t).on(a.keydown + "-" + t, function(e) {
            if (o.$html.hasClass(i.opened) && 9 == e.keyCode)
                return e.preventDefault(),
                !1
        });
        var e = 0;
        o.$wndw.off(a.resize + "-" + t).on(a.resize + "-" + t, function(n, t) {
            if (1 == o.$page.length && (t || o.$html.hasClass(i.opened))) {
                var s = o.$wndw.height();
                (t || s != e) && (e = s,
                o.$page.css("minHeight", s))
            }
        })
    }
    ,
    e[n].prototype._initBlocker = function() {
        var n = this;
        this.opts[t].blockUI && (o.$blck || (o.$blck = e('<div id="' + i.blocker + '" class="' + i.slideout + '" />')),
        o.$blck.appendTo(o.$body).off(a.touchstart + "-" + t + " " + a.touchmove + "-" + t).on(a.touchstart + "-" + t + " " + a.touchmove + "-" + t, function(e) {
            e.preventDefault(),
            e.stopPropagation(),
            o.$blck.trigger(a.mousedown + "-" + t)
        }).off(a.mousedown + "-" + t).on(a.mousedown + "-" + t, function(e) {
            e.preventDefault(),
            o.$html.hasClass(i.modal) || (n.closeAllOthers(),
            n.close())
        }))
    }
    ;
    var i, s, a, o
}(jQuery),
/*

* jQuery mmenu searchfield add-on
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
function(e) {
    function n(e) {
        switch (e) {
        case 9:
        case 16:
        case 17:
        case 18:
        case 37:
        case 38:
        case 39:
        case 40:
            return !0
        }
        return !1
    }
    var t = "mmenu"
      , i = "searchfield";
    e[t].addons[i] = {
        setup: function() {
            var l = this
              , d = this.opts[i]
              , c = this.conf[i];
            r = e[t].glbl,
            "boolean" == typeof d && (d = {
                add: d
            }),
            "object" != typeof d && (d = {}),
            "boolean" == typeof d.resultsPanel && (d.resultsPanel = {
                add: d.resultsPanel
            }),
            d = this.opts[i] = e.extend(!0, {}, e[t].defaults[i], d),
            c = this.conf[i] = e.extend(!0, {}, e[t].configuration[i], c),
            this.bind("close", function() {
                this.$menu.find("." + s.search).find("input").blur()
            }),
            this.bind("initPanels", function(r) {
                if (d.add) {
                    var h;
                    switch (d.addTo) {
                    case "panels":
                        h = r;
                        break;
                    default:
                        h = this.$menu.find(d.addTo)
                    }
                    if (h.each(function() {
                        var n = e(this);
                        if (!n.is("." + s.panel) || !n.is("." + s.vertical)) {
                            if (!n.children("." + s.search).length) {
                                var i = l.__valueOrFn(c.clear, n)
                                  , a = l.__valueOrFn(c.form, n)
                                  , r = l.__valueOrFn(c.input, n)
                                  , h = l.__valueOrFn(c.submit, n)
                                  , u = e("<" + (a ? "form" : "div") + ' class="' + s.search + '" />')
                                  , f = e('<input placeholder="' + e[t].i18n(d.placeholder) + '" type="text" autocomplete="off" />');
                                u.append(f);
                                var p;
                                if (r)
                                    for (p in r)
                                        f.attr(p, r[p]);
                                if (i && e('<a class="' + s.btn + " " + s.clear + '" href="#" />').appendTo(u).on(o.click + "-searchfield", function(e) {
                                    e.preventDefault(),
                                    f.val("").trigger(o.keyup + "-searchfield")
                                }),
                                a) {
                                    for (p in a)
                                        u.attr(p, a[p]);
                                    h && !i && e('<a class="' + s.btn + " " + s.next + '" href="#" />').appendTo(u).on(o.click + "-searchfield", function(e) {
                                        e.preventDefault(),
                                        u.submit()
                                    })
                                }
                                n.hasClass(s.search) ? n.replaceWith(u) : n.prepend(u).addClass(s.hassearch)
                            }
                            if (d.noResults) {
                                var v = n.closest("." + s.panel).length;
                                if (v || (n = l.$pnls.children("." + s.panel).first()),
                                !n.children("." + s.noresultsmsg).length) {
                                    var m = n.children("." + s.listview).first();
                                    e('<div class="' + s.noresultsmsg + " " + s.hidden + '" />').append(e[t].i18n(d.noResults))[m.length ? "insertAfter" : "prependTo"](m.length ? m : n)
                                }
                            }
                        }
                    }),
                    d.search) {
                        if (d.resultsPanel.add) {
                            d.showSubPanels = !1;
                            var u = this.$pnls.children("." + s.resultspanel);
                            u.length || (u = e('<div class="' + s.panel + " " + s.resultspanel + " " + s.hidden + '" />').appendTo(this.$pnls).append('<div class="' + s.navbar + " " + s.hidden + '"><a class="' + s.title + '">' + e[t].i18n(d.resultsPanel.title) + "</a></div>").append('<ul class="' + s.listview + '" />').append(this.$pnls.find("." + s.noresultsmsg).first().clone()),
                            this.initPanels(u))
                        }
                        this.$menu.find("." + s.search).each(function() {
                            var t, r, c = e(this), h = c.closest("." + s.panel).length;
                            h ? (t = c.closest("." + s.panel),
                            r = t) : (t = e("." + s.panel, l.$menu),
                            r = l.$menu),
                            d.resultsPanel.add && (t = t.not(u));
                            var f = c.children("input")
                              , p = l.__findAddBack(t, "." + s.listview).children("li")
                              , v = p.filter("." + s.divider)
                              , m = l.__filterListItems(p)
                              , g = "a"
                              , b = g + ", span"
                              , _ = ""
                              , C = function() {
                                var n = f.val().toLowerCase();
                                if (n != _) {
                                    if (_ = n,
                                    d.resultsPanel.add && u.children("." + s.listview).empty(),
                                    t.scrollTop(0),
                                    m.add(v).addClass(s.hidden).find("." + s.fullsubopensearch).removeClass(s.fullsubopen + " " + s.fullsubopensearch),
                                    m.each(function() {
                                        var n = e(this)
                                          , t = g;
                                        (d.showTextItems || d.showSubPanels && n.find("." + s.next)) && (t = b);
                                        var i = n.data(a.searchtext) || n.children(t).text();
                                        i.toLowerCase().indexOf(_) > -1 && n.add(n.prevAll("." + s.divider).first()).removeClass(s.hidden)
                                    }),
                                    d.showSubPanels && t.each(function(n) {
                                        var t = e(this);
                                        l.__filterListItems(t.find("." + s.listview).children()).each(function() {
                                            var n = e(this)
                                              , t = n.data(a.child);
                                            n.removeClass(s.nosubresults),
                                            t && t.find("." + s.listview).children().removeClass(s.hidden)
                                        })
                                    }),
                                    d.resultsPanel.add)
                                        if ("" === _)
                                            this.closeAllPanels(),
                                            this.openPanel(this.$pnls.children("." + s.subopened).last());
                                        else {
                                            var i = e();
                                            t.each(function() {
                                                var n = l.__filterListItems(e(this).find("." + s.listview).children()).not("." + s.hidden).clone(!0);
                                                n.length && (d.resultsPanel.dividers && (i = i.add('<li class="' + s.divider + '">' + e(this).children("." + s.navbar).text() + "</li>")),
                                                i = i.add(n))
                                            }),
                                            i.find("." + s.next).remove(),
                                            u.children("." + s.listview).append(i),
                                            this.openPanel(u)
                                        }
                                    else
                                        e(t.get().reverse()).each(function(n) {
                                            var t = e(this)
                                              , i = t.data(a.parent);
                                            i && (l.__filterListItems(t.find("." + s.listview).children()).length ? (i.hasClass(s.hidden) && i.children("." + s.next).not("." + s.fullsubopen).addClass(s.fullsubopen).addClass(s.fullsubopensearch),
                                            i.removeClass(s.hidden).removeClass(s.nosubresults).prevAll("." + s.divider).first().removeClass(s.hidden)) : h || (t.hasClass(s.opened) && setTimeout(function() {
                                                l.openPanel(i.closest("." + s.panel))
                                            }, (n + 1) * (1.5 * l.conf.openingInterval)),
                                            i.addClass(s.nosubresults)))
                                        });
                                    r.find("." + s.noresultsmsg)[m.not("." + s.hidden).length ? "addClass" : "removeClass"](s.hidden),
                                    this.update()
                                }
                            };
                            f.off(o.keyup + "-" + i + " " + o.change + "-" + i).on(o.keyup + "-" + i, function(e) {
                                n(e.keyCode) || C.call(l)
                            }).on(o.change + "-" + i, function(e) {
                                C.call(l)
                            });
                            var y = c.children("." + s.btn);
                            y.length && f.on(o.keyup + "-" + i, function(e) {
                                y[f.val().length ? "removeClass" : "addClass"](s.hidden)
                            }),
                            f.trigger(o.keyup + "-" + i)
                        })
                    }
                }
            })
        },
        add: function() {
            s = e[t]._c,
            a = e[t]._d,
            o = e[t]._e,
            s.add("clear search hassearch resultspanel noresultsmsg noresults nosubresults fullsubopensearch"),
            a.add("searchtext"),
            o.add("change keyup")
        },
        clickAnchor: function(e, n) {}
    },
    e[t].defaults[i] = {
        add: !1,
        addTo: "panels",
        placeholder: "Search",
        noResults: "No results found.",
        resultsPanel: {
            add: !1,
            dividers: !0,
            title: "Search results"
        },
        search: !0,
        showTextItems: !1,
        showSubPanels: !0
    },
    e[t].configuration[i] = {
        clear: !1,
        form: !1,
        input: !1,
        submit: !1
    };
    var s, a, o, r
}(jQuery)
/*

/*
 * jQuery mmenu fixedElements add-on
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
!function(s) {
    var i = "mmenu"
      , t = "fixedElements";
    s[i].addons[t] = {
        setup: function() {
            if (this.opts.offCanvas) {
                var n = this.opts[t];
                this.conf[t];
                d = s[i].glbl,
                n = this.opts[t] = s.extend(!0, {}, s[i].defaults[t], n);
                var a = function(s) {
                    var i = this.conf.classNames[t].fixed;
                    this.__refactorClass(s.find("." + i), i, "slideout").appendTo(d.$body)
                };
                a.call(this, d.$page),
                this.bind("setPage", a)
            }
        },
        add: function() {
            n = s[i]._c,
            a = s[i]._d,
            e = s[i]._e,
            n.add("fixed")
        },
        clickAnchor: function(s, i) {}
    },
    s[i].configuration.classNames[t] = {
        fixed: "Fixed"
    };
    var n, a, e, d
}(jQuery);

/*
 * jQuery mmenu navbar add-on
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
!function(n) {
    var a = "mmenu"
      , t = "navbars";
    n[a].addons[t] = {
        setup: function() {
            var r = this
              , s = this.opts[t]
              , c = this.conf[t];
            if (i = n[a].glbl,
            "undefined" != typeof s) {
                s instanceof Array || (s = [s]);
                var o = {};
                if (s.length) {
                    n.each(s, function(i) {
                        var l = s[i];
                        "boolean" == typeof l && l && (l = {}),
                        "object" != typeof l && (l = {}),
                        "undefined" == typeof l.content && (l.content = ["prev", "title"]),
                        l.content instanceof Array || (l.content = [l.content]),
                        l = n.extend(!0, {}, r.opts.navbar, l);
                        var d = l.position
                          , h = l.height;
                        "number" != typeof h && (h = 1),
                        h = Math.min(4, Math.max(1, h)),
                        "bottom" != d && (d = "top"),
                        o[d] || (o[d] = 0),
                        o[d]++;
                        var f = n("<div />").addClass(e.navbar + " " + e.navbar + "-" + d + " " + e.navbar + "-" + d + "-" + o[d] + " " + e.navbar + "-size-" + h);
                        o[d] += h - 1;
                        for (var v = 0, u = 0, p = l.content.length; u < p; u++) {
                            var b = n[a].addons[t][l.content[u]] || !1;
                            b ? v += b.call(r, f, l, c) : (b = l.content[u],
                            b instanceof n || (b = n(l.content[u])),
                            f.append(b))
                        }
                        v += Math.ceil(f.children().not("." + e.btn).length / h),
                        v > 1 && f.addClass(e.navbar + "-content-" + v),
                        f.children("." + e.btn).length && f.addClass(e.hasbtns),
                        f.prependTo(r.$menu)
                    });
                    for (var l in o)
                        r.$menu.addClass(e.hasnavbar + "-" + l + "-" + o[l])
                }
            }
        },
        add: function() {
            e = n[a]._c,
            r = n[a]._d,
            s = n[a]._e,
            e.add("close hasbtns")
        },
        clickAnchor: function(n, a) {}
    },
    n[a].configuration[t] = {
        breadcrumbSeparator: "/"
    },
    n[a].configuration.classNames[t] = {};
    var e, r, s, i
}(jQuery),
/*
 * jQuery mmenu navbar add-on breadcrumbs content
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
function(n) {
    var a = "mmenu"
      , t = "navbars"
      , e = "breadcrumbs";
    n[a].addons[t][e] = function(t, e, r) {
        var s = n[a]._c
          , i = n[a]._d;
        s.add("breadcrumbs separator");
        var c = n('<span class="' + s.breadcrumbs + '" />').appendTo(t);
        this.bind("initPanels", function(a) {
            a.removeClass(s.hasnavbar).each(function() {
                for (var a = [], t = n(this), e = n('<span class="' + s.breadcrumbs + '"></span>'), c = n(this).children().first(), o = !0; c && c.length; ) {
                    c.is("." + s.panel) || (c = c.closest("." + s.panel));
                    var l = c.children("." + s.navbar).children("." + s.title).text();
                    a.unshift(o ? "<span>" + l + "</span>" : '<a href="#' + c.attr("id") + '">' + l + "</a>"),
                    o = !1,
                    c = c.data(i.parent)
                }
                e.append(a.join('<span class="' + s.separator + '">' + r.breadcrumbSeparator + "</span>")).appendTo(t.children("." + s.navbar))
            })
        });
        var o = function() {
            c.html(this.$pnls.children("." + s.current).children("." + s.navbar).children("." + s.breadcrumbs).html())
        };
        return this.bind("openPanel", o),
        this.bind("initPanels", o),
        0
    }
}(jQuery),
/*
 * jQuery mmenu navbar add-on close content
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
function(n) {
    var a = "mmenu"
      , t = "navbars"
      , e = "close";
    n[a].addons[t][e] = function(t, e) {
        var r = n[a]._c
          , s = n[a].glbl
          , i = n('<a class="' + r.close + " " + r.btn + '" href="#" />').appendTo(t)
          , c = function(n) {
            i.attr("href", "#" + n.attr("id"))
        };
        return c.call(this, s.$page),
        this.bind("setPage", c),
        -1
    }
}(jQuery),
/*
 * jQuery mmenu navbar add-on next content
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
function(n) {
    var a = "mmenu"
      , t = "navbars"
      , e = "next";
    n[a].addons[t][e] = function(e, r) {
        var s, i, c, o = n[a]._c, l = n('<a class="' + o.next + " " + o.btn + '" href="#" />').appendTo(e), d = function(n) {
            n = n || this.$pnls.children("." + o.current);
            var a = n.find("." + this.conf.classNames[t].panelNext);
            s = a.attr("href"),
            c = a.attr("aria-owns"),
            i = a.html(),
            l[s ? "attr" : "removeAttr"]("href", s),
            l[c ? "attr" : "removeAttr"]("aria-owns", c),
            l[s || i ? "removeClass" : "addClass"](o.hidden),
            l.html(i)
        };
        return this.bind("openPanel", d),
        this.bind("initPanels", function() {
            d.call(this)
        }),
        -1
    }
    ,
    n[a].configuration.classNames[t].panelNext = "Next"
}(jQuery),
/*
 * jQuery mmenu navbar add-on prev content
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
function(n) {
    var a = "mmenu"
      , t = "navbars"
      , e = "prev";
    n[a].addons[t][e] = function(e, r) {
        var s = n[a]._c
          , i = n('<a class="' + s.prev + " " + s.btn + '" href="#" />').appendTo(e);
        this.bind("initPanels", function(n) {
            n.removeClass(s.hasnavbar).children("." + s.navbar).addClass(s.hidden)
        });
        var c, o, l, d = function(n) {
            if (n = n || this.$pnls.children("." + s.current),
            !n.hasClass(s.vertical)) {
                var a = n.find("." + this.conf.classNames[t].panelPrev);
                a.length || (a = n.children("." + s.navbar).children("." + s.prev)),
                c = a.attr("href"),
                l = a.attr("aria-owns"),
                o = a.html(),
                i[c ? "attr" : "removeAttr"]("href", c),
                i[l ? "attr" : "removeAttr"]("aria-owns", l),
                i[c || o ? "removeClass" : "addClass"](s.hidden),
                i.html(o)
            }
        };
        return this.bind("openPanel", d),
        this.bind("initPanels", function() {
            d.call(this)
        }),
        -1
    }
    ,
    n[a].configuration.classNames[t].panelPrev = "Prev"
}(jQuery),
/*
 * jQuery mmenu navbar add-on searchfield content
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
function(n) {
    var a = "mmenu"
      , t = "navbars"
      , e = "searchfield";
    n[a].addons[t][e] = function(t, e) {
        var r = n[a]._c
          , s = n('<div class="' + r.search + '" />').appendTo(t);
        return "object" != typeof this.opts.searchfield && (this.opts.searchfield = {}),
        this.opts.searchfield.add = !0,
        this.opts.searchfield.addTo = s,
        0
    }
}(jQuery),
/*
 * jQuery mmenu navbar add-on title content
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
function(n) {
    var a = "mmenu"
      , t = "navbars"
      , e = "title";
    n[a].addons[t][e] = function(e, r) {
        var s, i, c = n[a]._c, o = n('<a class="' + c.title + '" />').appendTo(e), l = function(n) {
            if (n = n || this.$pnls.children("." + c.current),
            !n.hasClass(c.vertical)) {
                var a = n.find("." + this.conf.classNames[t].panelTitle);
                a.length || (a = n.children("." + c.navbar).children("." + c.title)),
                s = a.attr("href"),
                i = a.html() || r.title,
                o[s ? "attr" : "removeAttr"]("href", s),
                o[s || i ? "removeClass" : "addClass"](c.hidden),
                o.html(i)
            }
        };
        return this.bind("openPanel", l),
        this.bind("initPanels", function(n) {
            l.call(this)
        }),
        0
    }
    ,
    n[a].configuration.classNames[t].panelTitle = "Title"
}(jQuery);
/*
 * jQuery mmenu screenReader add-on
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
!function(i) {
    var t = "mmenu"
      , n = "screenReader";
    i[t].addons[n] = {
        setup: function() {
            var a = this
              , h = this.opts[n]
              , o = this.conf[n];
            s = i[t].glbl,
            "boolean" == typeof h && (h = {
                aria: h,
                text: h
            }),
            "object" != typeof h && (h = {}),
            h = this.opts[n] = i.extend(!0, {}, i[t].defaults[n], h),
            h.aria && (this.bind("initAddons:after", function() {
                this.bind("initMenu:after", function() {
                    this.trigger("initMenu:after:sr-aria")
                }),
                this.bind("initNavbar:after", function() {
                    this.trigger("initNavbar:after:sr-aria", arguments[0])
                }),
                this.bind("openPanel:start", function() {
                    this.trigger("openPanel:start:sr-aria", arguments[0])
                }),
                this.bind("close:start", function() {
                    this.trigger("close:start:sr-aria")
                }),
                this.bind("close:finish", function() {
                    this.trigger("close:finish:sr-aria")
                }),
                this.bind("open:start", function() {
                    this.trigger("open:start:sr-aria")
                }),
                this.bind("open:finish", function() {
                    this.trigger("open:finish:sr-aria")
                })
            }),
            this.bind("updateListview", function() {
                this.$pnls.find("." + e.listview).children().each(function() {
                    a.__sr_aria(i(this), "hidden", i(this).is("." + e.hidden))
                })
            }),
            this.bind("openPanel:start", function(i) {
                var t = this.$menu.find("." + e.panel).not(i).not(i.parents("." + e.panel))
                  , n = i.add(i.find("." + e.vertical + "." + e.opened).children("." + e.panel));
                this.__sr_aria(t, "hidden", !0),
                this.__sr_aria(n, "hidden", !1)
            }),
            this.bind("closePanel", function(i) {
                this.__sr_aria(i, "hidden", !0)
            }),
            this.bind("initPanels:after", function(t) {
                var n = t.find("." + e.prev + ", ." + e.next).each(function() {
                    a.__sr_aria(i(this), "owns", i(this).attr("href").replace("#", ""))
                });
                this.__sr_aria(n, "haspopup", !0)
            }),
            this.bind("initNavbar:after", function(i) {
                var t = i.children("." + e.navbar);
                this.__sr_aria(t, "hidden", !i.hasClass(e.hasnavbar))
            }),
            h.text && (this.bind("initlistview:after", function(i) {
                var t = i.find("." + e.listview).find("." + e.fullsubopen).parent().children("span");
                this.__sr_aria(t, "hidden", !0)
            }),
            "parent" == this.opts.navbar.titleLink && this.bind("initNavbar:after", function(i) {
                var t = i.children("." + e.navbar)
                  , n = !!t.children("." + e.prev).length;
                this.__sr_aria(t.children("." + e.title), "hidden", n)
            }))),
            h.text && (this.bind("initAddons:after", function() {
                this.bind("setPage:after", function() {
                    this.trigger("setPage:after:sr-text", arguments[0])
                })
            }),
            this.bind("initNavbar:after", function(n) {
                var r = n.children("." + e.navbar)
                  , a = r.children("." + e.title).text()
                  , s = i[t].i18n(o.text.closeSubmenu);
                a && (s += " (" + a + ")"),
                r.children("." + e.prev).html(this.__sr_text(s))
            }),
            this.bind("initListview:after", function(n) {
                var s = n.data(r.parent);
                if (s && s.length) {
                    var h = s.children("." + e.next)
                      , d = h.nextAll("span, a").first().text()
                      , f = i[t].i18n(o.text[h.parent().is("." + e.vertical) ? "toggleSubmenu" : "openSubmenu"]);
                    d && (f += " (" + d + ")"),
                    h.html(a.__sr_text(f))
                }
            }))
        },
        add: function() {
            e = i[t]._c,
            r = i[t]._d,
            a = i[t]._e,
            e.add("sronly")
        },
        clickAnchor: function(i, t) {}
    },
    i[t].defaults[n] = {
        aria: !0,
        text: !0
    },
    i[t].configuration[n] = {
        text: {
            closeMenu: "Close menu",
            closeSubmenu: "Close submenu",
            openSubmenu: "Open submenu",
            toggleSubmenu: "Toggle submenu"
        }
    },
    i[t].prototype.__sr_aria = function(i, t, n) {
        i.prop("aria-" + t, n)[n ? "attr" : "removeAttr"]("aria-" + t, n)
    }
    ,
    i[t].prototype.__sr_text = function(i) {
        return '<span class="' + e.sronly + '">' + i + "</span>"
    }
    ;
    var e, r, a, s
}(jQuery);

/*
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

jQuery.cookie = function(b, j, m) {
    if (typeof j != "undefined") {
        m = m || {};
        if (j === null) {
            j = "";
            m.expires = -1
        }
        var e = "";
        if (m.expires && (typeof m.expires == "number" || m.expires.toUTCString)) {
            var f;
            if (typeof m.expires == "number") {
                f = new Date();
                f.setTime(f.getTime() + (m.expires * 24 * 60 * 60 * 1000))
            } else {
                f = m.expires
            }
            e = "; expires=" + f.toUTCString()
        }
        var l = m.path ? "; path=" + (m.path) : "";
        var g = m.domain ? "; domain=" + (m.domain) : "";
        var a = m.secure ? "; secure" : "";
        document.cookie = [b, "=", encodeURIComponent(j), e, l, g, a].join("")
    } else {
        var d = null;
        if (document.cookie && document.cookie != "") {
            var k = document.cookie.split(";");
            for (var h = 0; h < k.length; h++) {
                var c = jQuery.trim(k[h]);
                if (c.substring(0, b.length + 1) == (b + "=")) {
                    d = decodeURIComponent(c.substring(b.length + 1));
                    break
                }
            }
        }
        return d
    }
}
;

var instagram = {
    loadContent: function(s) {
        if (s.clientID) {
            var url = 'https://api.instagram.com/v1/users/self/media/recent/?access_token=' + s.clientID + '&count=25';

            $.ajax({
                type: 'GET',
                url: url,
                dataType: 'jsonp',
                success: function(data) {

                    if (data.meta.code === 200 && data.data.length) {
                        var data = data.data;
                        var count = 0;
                        s.el.empty();

                        for (var i = 0; i < data.length; i++) {
                            var thisMedia = data[i], item;

                            var url = thisMedia.images.low_resolution.url;

                            if (!thisMedia.images.low_resolution.url.indexOf("null") > -1) {
                                item = '<div class="il-photo__img instagram__bg" style="background-image:url(' + url + ')" data-filter="' + thisMedia.filter + '" /></div>';
                                item = '<a href="' + thisMedia.link + '" target="_blank" class="instagram__link">' + item + '</a>';
                            }

                            if (thisMedia.videos) {
                                item = '<div class="instagram__video instagram__bg" style="background-image:url(' + url + ')" data-filter="' + thisMedia.filter + '" /></div>';
                                item = '<a href="' + thisMedia.link + '" target="_blank" class="instagram__link instagram__video-link">' + item + '</a>';
                            }

                            if (item) {
                                item = '<div class="one-fifth column instagram__item">' + item + '</div>';
                            }
                            if (item !== '') {
                                s.el.append(item);
                                count++;
                            }
                            if (count == s.limit) {
                                break;
                            }
                        }
                    }
                },
                error: function() {}
            });
        }
    }
}

$(document).on('shopify:block:select', function(e) {

    var blockId = e.detail.blockId;
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')) {
        sliderBlock.select(blockId, $parentSection)
    }

});

$(document).on('shopify:block:deselect', function(e) {

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')) {
        sliderBlock.deselect($parentSection)
    }

});

$(document).on('shopify:section:load', function(e) {

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    header.init();

    if ($parentSection.hasClass('twitter-feed-section')) {
        $('.twitter-feed-wrap').each(function(index, value) {
            social.twitter();
        });
    }

    if ($parentSection.hasClass('instagram-feed-section')) {
        $('.instagram-feed-wrap').each(function(index, value) {

            var $target = $(this).find(".js-instafeed");
            instagram.loadContent({
                el: $target,
                clientID: $target.data('client-id'),
                limit: $target.data('count')
            });
        });
    }

    if ($parentSection.hasClass('cart-section')) {
        productFormListeners.init();
    }

    if ($parentSection.hasClass('faq-template-section')) {
        faqAccordion.init();
    }

    if ($parentSection.hasClass('slideshow-section')) {
        slideshow.init();
    }

    if ($parentSection.hasClass('map-section')) {
        map.init();
    }

    if ($parentSection.hasClass('page-details-section')) {
        map.init();
    }

    if ($parentSection.hasClass('contact-template-section')) {
        map.init();
    }

    if ($parentSection.hasClass('featured-product-section')) {
        product.init();
        utils.initializeTabs();
        utils.initializeAccordions();
    }

    if ($parentSection.hasClass('featured-collection-section')) {
        collection.init();
        product.init();
    }

    if ($parentSection.hasClass('video-section')) {
        video.init();
    }

    if ($parentSection.hasClass('page-details-section')) {
        video.init();
    }

    if ($parentSection.hasClass('product-template-section')) {
        collection.init();
        product.init();
    }

    if ($parentSection.hasClass('collection-template-section')) {
        collection.init();
        product.init();
    }

    if ($parentSection.hasClass('banner-template-section')) {
        $('.banner-flexslider').flexslider({
            touch: false,
            controlNav: false,
            directionNav: false,
            animation: "fade"
        });
    }

    if ($parentSection.hasClass('search-template-section')) {
        collection.init();
    }

    if ($parentSection.hasClass('testimonial-section')) {
        testimonials.init();
    }
});

$(document).on('shopify:section:unload', function(e) {

    var $target = $(e.target);
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    banner.unload($target);

    if ($parentSection.hasClass('social-feeds-section')) {
        $('.social-feeds-wrap').each(function(index, value) {
            social.unload($target);
        });
    }

    if ($parentSection.hasClass('slideshow-section')) {
        slideshow.unload($target);
    }

    if ($parentSection.hasClass('featured-product-section')) {
        product.unload($target);
        utils.unload($target);
    }

    if ($parentSection.hasClass('featured-collection-section')) {
        collection.unload($target);
    }

    if ($parentSection.hasClass('product-template-section')) {
        product.unload($target);
    }

    if ($parentSection.hasClass('collection-template-section')) {
        collection.unload($target);
    }

});

$(document).on('shopify:section:select', function(e) {

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('twitter-feed-section')) {
        $('.twitter-feed-wrap').each(function(index, value) {
            social.twitter();
        });
    }

    if ($parentSection.hasClass('featured-collection-section')) {
        collection.init();
        product.init();
    }

});

$(document).on('shopify:section:deselect', function(e) {

    var $target = $(e.target);
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('social-feeds-section')) {
        $('.social-feeds-wrap').each(function(index, value) {
            social.unload();
        });
    }

});

$(document).on('shopify:section:reorder', function(e) {

    var $target = $(e.target);
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    banner.unload($target);
    banner.init();

});
